/* live-bust-1777861687 */
/* cache-bust: 1781913600 */
/* HALLOWEEN_VAULT_V6 — restore after 4th stale-branch revert; self-heal workflow added */
/* coldest-drop-collections.js v20260420
   Themed Drop Collection Filter
   ─────────────────────────────
   Transforms Shopify collection pages into variant-level grids.
   Only activates on collections defined in DROP_CONFIG below.
   Each variant gets its own card with image, title, size, price, and ATC.
*/
(function() {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────────────── */
  var DROP_CONFIG = {
    'shark-tankathon': {
      colors: ['shark tankathon'],
      heading: 'Shark Tankathon',
      subheading: 'Shark Tankathon — the Coldest drop that broke the internet. Leak-proof, ice-cold for up to 36+ hours*, and built to outlast the hype. Once it\'s gone, it\'s gone! 🦈',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'shark tankathon': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/v3.png?v=1780883321',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_v2_e359ba88-7edb-496a-a280-f7305024d1c6.png?v=1780883899',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_36_46_cfe56611-e4a4-446d-ae7a-9790b25770ce.png?v=1780883463',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_36_46_4b2fc9bc-3da2-4e91-9335-b1ab028f067f.png?v=1780883535',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_36_46_05b7fee5-b2db-4ab4-b6e8-c5857802c9fa.png?v=1780883731',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_36_46_4b2fc9bc-3da2-4e91-9335-b1ab028f067f.png?v=1780883535'
        }
      }
    },
    'the-hamilton': {
      colors: ['the hamilton'],
      heading: 'The Hamilton',
      subheading: 'The Hamilton — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'the hamilton': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'baby-fireflies': {
      colors: ['baby fireflies'],
      heading: 'Baby Fireflies',
      subheading: 'Baby Fireflies — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'baby fireflies': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'deer-moon': {
      colors: ['deer moon'],
      heading: 'Deer Moon',
      subheading: 'Deer Moon — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'deer moon': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'glowie-baby-fireflies': {
      colors: ['glowie baby fireflies'],
      heading: 'Glowie Baby Fireflies',
      subheading: 'Glowie Baby Fireflies — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'glowie baby fireflies': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },

    'baby-dinosaur': {
      colors: ['baby dinosaur'],
      heading: 'Baby Dinosaur',
      subheading: 'Say hi to Baby Dinosaur — the loud, lovable, slightly-prehistoric Coldest drop for anyone who refuses to take themselves too seriously. You blink and the herd has already migrated, so maybe don\'t blink. 🦖',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    'crochet-is-life': {
      colors: ['crochet is life'],
      heading: 'Crochet is Life',
      subheading: 'Crochet is Life is your cozy-corner Coldest drop, hand-picked for the makers, the homebodies, and anyone whose hobby has its own basket. We only stitched a small batch, so grab yours before the yarn runs out. 🧶',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    'sports-drop': {
      colors: ['buzzer beater', 'pursuit of winning', 'the world stage'],
      heading: 'Sports Drop',
      subheading: 'Lace up — Sports Drop is the Coldest collection for athletes, fans, and the chronically competitive among us. We only printed enough jerseys for the starting lineup, so don\'t wait for OT. 🏆',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      /* Per-size image overrides — keyed by normalized color, then size.
         Falls back to 'default' key if size not found. */
      imageOverrides: {
        'buzzer beater': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_Buzzer_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_Buzzer_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561'
        },
        'pursuit of winning': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/pursuit-of-winning-ultra-ph.jpg?v=1774831244',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/pursuit-of-winning-ultra-ph.jpg?v=1774831244'
        },
        'the world stage': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify.png?v=1774926734',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914'
        }
      }
    },
    /* ── Halloween Vault — aggregated multi-drop collection ──
       Every Coldest Halloween drop pulled into one filterable/sortable grid.
       singleColor:true renders ONE flat grid (not per-color sections); the new
       dropFilters flag turns on the drop-filter chips + sort control. */
    'glowie-meow': {
      colors: ['glowie meow'],
      heading: 'Glowie Meow',
      subheading: 'Glowie Meow — glows after dark. Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'glowie meow': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'pink-moonlight-floral': {
      colors: ['pink moonlight floral'],
      heading: 'Pink Moonlight Floral',
      subheading: 'Pink Moonlight Floral — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'pink moonlight floral': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'glowie-written-in-the-stars': {
      colors: ['glowie written in the stars'],
      heading: 'Glowie Written in the Stars',
      subheading: 'Glowie Written in the Stars — glows after dark. Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      showSizeFilter: true,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    'rose-all-day': {
      colors: ['rose all day'],
      heading: 'Rose All Day',
      subheading: 'Rose All Day — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'rose all day': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'wizarding-skies': {
      colors: ['wizarding skies'],
      heading: 'Wizarding Skies',
      subheading: 'Wizarding Skies — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      reveal: 'none',   /* art on the PDPs is already the sneak-peek teaser */
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'wizarding skies': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'pink-peach-tree': {
      colors: ['pink peach tree'],
      heading: 'Pink Peach Tree',
      subheading: 'Pink Peach Tree — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      reveal: 'none',   /* art on the PDPs is already the sneak-peek teaser */
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'pink peach tree': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'back-to-school': {
      colors: ['shark tankathon', 'baby duckies', 'baby dinosaur', 'pursuit of winning',
               'buzzer beater', 'green dragon', 'glossy pink', 'xoxo', 'love pop',
               'ship in a bottle'],
      heading: 'Back to School',
      subheading: 'Ten fan-favorite Coldest colorways, in stock and ready for the first bell — Shark Tankathon, Baby Duckies, Baby Dinosaur, Pursuit of Winning, Buzzer Beater, Green Dragon, Glossy Pink, XOXO, Love Pop & Ship in a Bottle. Leak-proof, ice-cold for up to 36+ hours*, and built for lockers, backpacks and lunch bags. \u270f\ufe0f',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-7-oz-bottle','coldest-1-gallon-limitless-ultra','32oz-go'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      showSizeFilter: true,
      inStockOnly: true,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    'halloween': {
      colors: ['pumpkin paws', 'lost mummies', 'haunted webs', 'eerie sistible', 'bats and cats'],
      heading: 'The Halloween Vault',
      subheading: 'Every Coldest Halloween drop, dug up and crammed into one cursed vault — Pumpkin Paws, Lost Mummies, Haunted Webs, Eerie-Sistible & Bats and Cats. When these crawl back into the crypt, they\'re gone for good. Claim yours before midnight. 🎃👻',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-7-oz-bottle','coldest-1-gallon-limitless-ultra','32oz-go'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      hideFilters: true,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    /* ── The Masterpiece Gallery — aggregated fine-art collection ──
       The art-themed sibling of the Halloween Vault: six iconic, public-domain
       masterpieces reimagined as Coldest collectibles, pulled into one curated,
       filterable gallery. singleColor:true renders one flat grid; dropFilters
       turns on the per-artwork filter chips; masterpieceBadge stamps each card
       with a gilded "Masterpiece" placard in the top-right corner. */
    'art': {
      colors: ['the great wave', 'garden at arles', 'bouquet of sunflowers', 'mont sainte', 'water lilies', 'starry night'],
      heading: 'The Masterpiece Gallery',
      subheading: 'Six of the most iconic works in art history, reimagined as Coldest collectibles — Hokusai\'s Great Wave, Van Gogh\'s Starry Night, his Garden at Arles & Bouquet of Sunflowers, Monet\'s Water Lilies, and Cézanne\'s Mont Sainte-Victoire. A curated, limited gallery of wearable fine art. Once a piece leaves the wall, it is retired from the collection for good. 🖼️',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-7-oz-bottle','coldest-1-gallon-limitless-ultra','32oz-go'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      hideFilters: true,
      masterpieceBadge: true,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    /* ── Coldest Prime Week — curated event collection ──
       Prime-Day-style 7-day event (2026-06-23 → 2026-06-30). A blue-themed,
       filterable landing page built on the same aggregated pattern as the
       Halloween Vault / Masterpiece Gallery: a hand-curated lineup of fan-
       favourite blue & cosmic colorways, all 10% off cart-wide with code
       PRIMEWEEK. singleColor:true → one flat grid; dropFilters → per-colorway
       chips + sort; primeWeekBadge stamps each card with a blue Prime Week
       placard. Edit `colors` to change the curated lineup (lowercase base
       names, no " Ultra"). */
    'prime-week': {
      colors: ['the great wave', 'royal blue', 'blue willow', 'blue checkers', 'starry night', 'moonlight mermaid', 'the world stage', 'magical potions', 'pursuit of winning', 'water lilies', 'green dragon', 'aura farming', 'baby dinosaur', 'baby puppy', 'bats and cats', 'berry bae', 'black and white checkers', 'bouquet of sunflowers', 'buzzer beater', 'candy hearts', 'clover floral', 'courting couples', 'crochet is life', 'cuddly puppy', 'ember glowie', 'flirt & flower', 'garden at arles', 'ghosts', 'glossy pink', 'glowie baby fireflies', 'glowie butterflies', 'glowie snowflakes', 'glowie spiral', 'glowie turtle', 'gold dragon', 'haunted webs', 'irises', 'love of music', 'love pop', 'magnolia bloom', 'mont sainte', 'mosaic bloom', 'pink petals', 'pumpkin paws', 'purple oasis', 'red dragon', 'red luna', 'shark tankathon', 'snuggle red', 'stealth black', 'stung by a bee', 'taste of fall', 'the european', 'the hamilton', 'the marrakech', 'the ottoman', 'the persian', 'turtly green', 'wine and willow', 'xoxo', 'mystery'],
      heading: 'Coldest Prime Week',
      subheading: 'Prime Week is here — 7 days only. Our full lineup of fan-favourite colorways plus the legendary Mystery bottles, insanely engineered to stay cold up to 100+ hours*. Take 10% off your entire cart with code PRIMEWEEK. When the week ends, the deal ends. ⚡',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-7-oz-bottle','coldest-1-gallon-limitless-ultra','32oz-go','mystery-15oz-limitless-bottle','mystery-limitless-20z-tumbler-30-colors-coffee-hot-13-hours','mystery-limitless-24oz-tumbler','mystery-limitless-36oz-tumbler','mystery-limitless-46oz-tumbler','mystery-limitless-gallon'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      hideFilters: true,
      showSizeFilter: true,
      soldOutLast: true,
      primeWeekBadge: true,
      infiniteScroll: true,
      infiniteBatch: 12,
      primeWeekDiscountPct: 10,
      primeWeekCode: 'PRIMEWEEK',
      forceDefaultImage: false,
      imageOverrides: {}
    },
    /* ── July 4th Weekend — signature patriotic + beach drop ──
       Eight hand-picked Coldest designs aggregated into one star-spangled,
       beach-ready grid for the holiday weekend. Same pattern as the Halloween
       Vault / Masterpiece Gallery: singleColor renders one flat grid,
       hideFilters keeps it clean. Order leads with the Americana designs, then
       the beach/summer ones. */
    'july-4th-weekend': {
      colors: ['the hamilton', 'shark tankathon', 'the world stage', 'pursuit of winning', 'moonlight seashells', 'moonlight mermaid', 'bouquet of sunflowers', 'flirt & flower'],
      heading: 'July 4th Weekend',
      subheading: 'Red, white & ice-cold. Eight Coldest icons hand-picked for the long weekend — The Hamilton, Shark Tankathon, The World Stage, Pursuit of Winning, Moonlight Seashells, Moonlight Mermaid, Bouquet of Sunflowers & Flirt & Flower. Star-spangled and beach-ready, limited to the holiday weekend. When the fireworks fade, so does the drop. 🎆🇺🇸🏖️',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-7-oz-bottle','coldest-1-gallon-limitless-ultra','32oz-go'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      hideFilters: true,
      mixColorways: true,
      alternateSize: true,
      soldOutEvery: 5,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    /* ── Single-color collections ──────────────────────────── */
    'glossy-pink': {
      colors: ['glossy pink'],
      heading: 'Glossy Pink',
      subheading: 'Meet Glossy Pink, your loudest, proudest, most unapologetic Coldest era. Trendsetters move fast on this one — restocks tend to disappear before you\'ve finished your coffee. 💗',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glossy pink': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_GlossyPink_Main.png?v=1773891363',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_GlossyPink_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_GlossyPink_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_GlossyPink_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_GlossyPink_Main.png?v=1774602615',
          '6.7oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/6_7_GlossyPink_Main.png?v=1773891491',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_GlossyPink_Main.png?v=1774602561'
        }
      }
    },
    'the-world-stage': {
      colors: ['the world stage'],
      heading: 'The World Stage',
      subheading: 'The World Stage is your Coldest passport — made for football fans, world travelers, and anyone who lives for the big moment. We pressed a limited run, so claim your seat before kickoff. ⚽',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'the world stage': {
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify.png?v=1774926734',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/TheWorldStageHypeShopify_939c3fed-48ac-40bf-a867-3827c0ecf228.png?v=1774926914'
        }
      }
    },
    'blue-opal': {
      colors: ['blue opal'],
      heading: 'Blue Opal',
      subheading: 'Slip into Blue Opal, the Coldest drop for ocean people, deep thinkers, and lovers of iridescent everything. Pulled from a tiny vein — once your size is gone, you\'re chasing the next tide. 🌊',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'mont sainte': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_MontSainte_Main.png?v=1774495761',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MontSainte_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_MontSainte_Main.png?v=1774495722',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MontSainte_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561'
        }
      }
    },
    'flirt-flower': {
      colors: ['flirt & flower'],
      heading: 'Flirt & Flower',
      subheading: 'Flirt & Flower is your Coldest bouquet, picked for the romantics and the soft-aesthetic crowd who treat their water bottle like an accessory. We only cut a few stems, so grab yours while it still smells like spring. 🌷',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'flirt & flower': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_FlirtFlower_Main.png?v=1774495783',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_FlirtFlower_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_FlirtFollow_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_FlirtFlower_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_FlirtFlower_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_FlirtFlower_Main.png?v=1774602561'
        }
      }
    },
    'love-of-music': {
      colors: ['love of music'],
      heading: 'Love of Music',
      subheading: 'Love of Music is your Coldest setlist — built for playlist obsessives, festival kids, and anyone whose day comes with a soundtrack. We pressed a tiny limited edition, so try to catch it before it\'s a deep cut. 🎶',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'love of music': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_LoveofMusic_Main.png?v=1773891382',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_LoveofMusic_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_LoveofMusic_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_LoveofMusic_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_LoveofMusic_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_LoveofMusic_Main.png?v=1774602561'
        }
      }
    },
    'water-lilies': {
      colors: ['water lilies'],
      heading: 'Water Lilies',
      subheading: 'Water Lilies is your Coldest quiet hour — perfect for the calm ones, the creatives, and anyone who finds peace at the edge of a pond. We only floated a few, so paddle out while they\'re still on the surface. 🪷',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'water lilies': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_WaterLilies_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_WaterLilies_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_WaterLilies_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__WaterLilies_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_WaterLilies_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__WaterLilies_Main.png?v=1774602561'
        }
      }
    },
    'buzzer-beater': {
      colors: ['buzzer beater'],
      heading: 'Buzzer Beater',
      subheading: 'Buzzer Beater is your Coldest game-winner — made for hoopers, clutch performers, and anyone who lives for the last shot. We\'ve got one possession left on this one, so call your number. 🏀',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'buzzer beater': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_Buzzer_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_Buzzer_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Buzzer_Main.png?v=1774602561'
        }
      }
    },
    'stealth-black': {
      colors: ['stealth black'],
      heading: 'Stealth Black',
      subheading: 'Stealth Black is your Coldest cheat code — matte, moody, and made for the minimalists who\'d rather let their drink do the talking. We dropped it in the shadows; you\'ll want to grab yours before it slips back into them. 🖤',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'stealth black': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StealhBlack_24388ae5-992b-4bf9-b120-364ca0a9966d.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StealthBlack_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StealhBlack_4b99ee77-0179-44a9-b058-e4ed15585a75.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_StealthBlack_Main.png?v=1774602561',
          '6.7oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/6_7_Stealth_Main.png?v=1773102944',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_StealthBlack_Main.png?v=1774602561'
        }
      }
    },
    'the-dragonfly': {
      colors: ['the dragonfly'],
      heading: 'The Dragonfly',
      subheading: 'Hover into The Dragonfly, your Coldest drop for nature lovers, garden wanderers, and anyone who notices the small magic. The swarm is tiny — once it\'s flown past, you\'re not catching it again. 🐉',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'stung by a bee': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StungbuaBee_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StungByaBee_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StungByaBee_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_StungbyaBee_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561'
        }
      }
    },
    'the-marrakech': {
      colors: ['the marrakech'],
      heading: 'The Marrakech',
      subheading: 'Step into The Marrakech, your Coldest drop for the wanderers, the rug-hoarders, and anyone who lives for spice-market color. Woven in small batches — your size won\'t sit on the shelf for long. 🧿',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,

      imageOverrides: {
        'clover floral': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_CloverFloral_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_CloverFloral_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_CloverFloral_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_CloverFloral_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561'
        }
      }
    },
    'starry-night': {
      colors: ['starry night'],
      heading: 'Starry Night',
      subheading: 'Starry Night is your Coldest after-hours companion — made for the dreamers, the late-night thinkers, and anyone who thinks Van Gogh got it right. We painted a tiny run, so claim yours before the lights go out. 🌌',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'starry night': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StarryNight_Main.png?v=1774803592',
          'gallon': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/128_Candy_StarryNight_Main.png?v=1773102776',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StarryNight_Main.png?v=1774803592'
        }
      }
    },
    'red-luna': {
      colors: ['red luna'],
      heading: 'Red Luna',
      subheading: 'Red Luna is your Coldest power phase — bold, fearless, and made for the people who walk in like they own the room. She rises briefly, so don\'t sleep on the moon. 🌕',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'red luna': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_RedLuna_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_RedLuna_Main.png?v=1774803592',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_RedLuna_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_RedLuna_Main.png?v=1774602615'
        }
      }
    },
    'magnolia-bloom': {
      colors: ['magnolia bloom'],
      heading: 'Magnolia Bloom',
      subheading: 'Magnolia Bloom is your Coldest Southern moment — for garden weddings, porch coffees, and anyone who loves a soft pink petal. We only bloom a small batch a season, so don\'t wait for next year. 🪷',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'magnolia bloom': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MagnoliaBloom_Main.png?v=1774803592',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__MagnoliaBloom_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MagnoliaBloom_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__MagnoliaBloom_Main.png?v=1774602561'
        }
      }
    },
    'xoxo': {
      colors: ['xoxo'],
      heading: 'XOXO',
      subheading: 'XOXO is your Coldest love letter, sealed for the romantics, the best friends, and anyone who signs off with hearts. We only mailed a few — don\'t make us send them with someone else\'s name. 💋',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'xoxo': {
        }
      }
    },
    'love-pop': {
      colors: ['love pop'],
      heading: 'Love Pop',
      subheading: 'Love Pop is your Coldest candy aisle — the maximalist, candy-hearted drop for anyone who treats hydration like a vibe. We mixed a small batch, so grab a piece before the jar\'s empty. 🍬',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'love pop': {
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_LovePop_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_LovePop_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__LovePop_Main.png?v=1773102478',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_LovePop_Main.png?v=1773102481',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__LovePop_Main.png?v=1773102478'
        }
      }
    },
    'mont-sainte': {
      colors: ['mont sainte'],
      heading: 'Mont Sainte',
      subheading: 'Mont Sainte is your Coldest summit — built for alpine kids, trail runners, and anyone chasing peak light. We only outfitted a small expedition, so rope up while there\'s still room. ⛰️',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'mont sainte': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_MontSainte_Main.png?v=1774495761',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_MontSainte_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_MontSainte_Main.png?v=1774495722',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_MontSainte_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1774602561'
        }
      }
    },
    'stung-by-a-bee': {
      colors: ['stung by a bee'],
      heading: 'Stung By A Bee',
      subheading: 'Stung By A Bee is your Coldest busy era — loud, bold, and made for the workers who buzz before everyone else\'s alarm. The hive only made so much honey, so go get yours. 🐝',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'stung by a bee': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_StungbuaBee_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_StungByaBee_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_StungByaBee_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_StungbyaBee_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36__StungByaBee_Amazon.png?v=1774602561'
        }
      }
    },
    'clover-floral': {
      colors: ['clover floral'],
      heading: 'Clover Floral',
      subheading: 'Clover Floral is your Coldest lucky day — made for the meadow-walkers, the optimists, and anyone who counts petals just in case. The patch is small, so step into it while you can still find a four-leafer. 🍀',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'clover floral': {
          '15oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/15_CloverFloral_Main.png?v=1773868448',
          '20oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_CloverFloral_Main.png?v=1774803592',
          '24oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/24_CloverFloral_Main.png?v=1774800678',
          '36oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561',
          '46oz': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/46oz_CloverFloral_Main.png?v=1774602615',
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/36_CloverFloral_Main.png?v=1774602561'
        }
      }
    },
    'pursuit-of-winning': {
      colors: ['pursuit of winning'],
      heading: 'Pursuit of Winning',
      subheading: 'Pursuit of Winning is your Coldest morning-mode — for the competitors, the early-risers, and the day-claimers. We\'re only handing out a limited round of trophies, so show up early. 🏅',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'pursuit of winning': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'
        }
      }
    },
    'glowie-turtle': {
      colors: ['glowie turtle'],
      heading: 'Glowie Turtle',
      subheading: 'Glowie Turtle is your Coldest slow-and-steady — for ocean kids, beach bums, and anyone who wants their grip to literally glow. We only surfaced a few — you\'ll want to scoop yours before the tide pulls them under. 🐢',
      handles: ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glowie turtle': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'
        }
      }
    },
    'bouquet-of-sunflowers': {
      colors: ['bouquet of sunflowers'],
      heading: 'Bouquet of Sunflowers',
      subheading: 'Bouquet of Sunflowers is your Coldest golden-hour drop — for the sun-chasers, the optimists, and anyone whose mood lifts at first light. We cut a small bouquet, so claim your stems before the field is bare. 🌻',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'bouquet of sunflowers': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'glowie-butterflies': {
      colors: ['glowie butterflies'],
      heading: 'Glowie Butterflies',
      subheading: 'Glowie Butterflies is your Coldest magic-hour drop — for the dreamers, the night-gardeners, and anyone who wants a little glow in their hand. The migration is tiny, so try not to miss the flutter. 🦋',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'glowie butterflies': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'aura-farming': {
      colors: ['aura farming'],
      heading: 'Aura Farming',
      subheading: 'Aura Farming is your Coldest main-character drop — for vibe curators, soft-launch kings, and anyone committed to looking unbothered on purpose. We only harvested a small aura-rich batch this season, so tend to yours early. ✨',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      imageOverrides: {
        'aura farming': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/4a7ea47aef934b1db12108b861949923_tplv-fhlh96nyum-origin-jpeg_d54bd46b-2edf-4d6d-a99b-c5180b93dcc9.jpg?v=1775216289'}
      }
    },
    'irises': {
      colors: ['irises'],
      heading: 'Irises',
      subheading: 'Irises is your Coldest little-museum drop — for art-lovers, garden poets, and anyone whose grandma had Van Gogh on the wall. We only planted a small bed, so pick yours before the petals dry. 🌸',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* No imageOverrides: drop page uses each variant's featured_image (its main photo). */
      imageOverrides: {}
    },
    'green-dragon': {
      colors: ['green dragon'],
      heading: 'Green Dragon',
      subheading: 'Green Dragon is your Coldest fierce era — for the fire-energy crowd, the bold ones, and anyone who shows up breathing smoke. We hatched a small clutch — claim yours before it flies off. 🐲',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* Force the single Green Dragon placeholder image for every size until real
         product photos exist. Replace the URL below to swap. */
      forceDefaultImage: true,
      imageOverrides: {
        'green dragon': {'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/green-dragon-ultra-ph_46022b41-f9fa-4772-9d82-f6a1395e03db.jpg?v=1773102242'}
      }
    },
    'mosaic-bloom': {
      colors: ['mosaic bloom'],
      heading: 'Mosaic Bloom',
      subheading: 'Mosaic Bloom is your Coldest artist drop — for the tile-collectors, the pattern-people, and anyone who sees beauty in tiny broken pieces. We only set a few mosaics, so place your tile while there\'s room. 🌺',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* 2026-05-13 ~10pm ET: MAIN reveal images uploaded by product team for all
         5 sizes. Flipped forceDefaultImage=false and removed imageOverrides so the
         drop grid pulls each variant's featured_image directly (which is now the
         main reveal). This is the standard "live drop" state — same shape as
         green-dragon and earlier shipped drops. */
      forceDefaultImage: false
    },
    'moonlight-mermaid': {
      colors: ['moonlight mermaid'],
      heading: 'Moonlight Mermaid',
      subheading: 'Moonlight Mermaid is your Coldest salt-water self — for the ocean souls, the moon-lovers, and anyone who feels most themselves underwater. She surfaces on a small tide, so swim out while she\'s still up. 🧜‍♀️',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* 2026-05-13 ~10pm ET: MAIN reveal images uploaded for 4 sizes
         (15/20/24/46oz — no 36oz Mermaid variant). Flipped to live-drop mode. */
      forceDefaultImage: false
    },
    'magical-potions': {
      colors: ['magical potions'],
      heading: 'Magical Potions',
      subheading: 'Magical Potions is your Coldest witchy drop — for the wonder-lovers, the tarot-readers, and anyone who keeps hydration a little mysterious. We brewed a tiny cauldron, so cast yours before it goes cold. 🔮',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* Pre-reveal: forceDefaultImage=false with green-dragon placeholder.
         Will be swapped to sneak peek images Monday 2026-05-18 10pm ET
         (see Section 5b in weekly_drop_on_sundays.md). Launch 2026-05-21. */
      forceDefaultImage: true,
      imageOverrides: {}
    },
    'berry-bae': {
      colors: ['berry bae'],
      heading: 'Berry Bae',
      subheading: 'Berry Bae is your Coldest sweet-but-bold drop — for the smoothie people, the fresh-picked crowd, and anyone whose vibe is sunshine-with-a-bite. We only filled a small basket this season, so grab a handful early. 🫐',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      /* Pre-reveal placeholder. Will be swapped to sneak peek Mon 2026-05-18 10pm ET. */
      forceDefaultImage: false,
      imageOverrides: {}
    },
    '280cts-arrival-eta-only-link-in-descript': {
      colors: ['280cts arrival - eta only, link in descript'],
      heading: '280CTS Arrival - ETA ONLY, Link in descript',
      subheading: '280CTS Arrival - ETA ONLY, Link in descript — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        '280cts arrival - eta only, link in descript': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/green-dragon-ultra-ph_46022b41-f9fa-4772-9d82-f6a1395e03db.jpg?v=1773102242'
        }
      }
    },
    '5ctns-arrival-eta-only-link-in-description': {
      colors: ['5ctns arrival - eta only, link in description'],
      heading: '5CTNS Arrival - ETA ONLY, Link in description',
      subheading: '5CTNS Arrival - ETA ONLY, Link in description — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        '5ctns arrival - eta only, link in description': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/green-dragon-ultra-ph_46022b41-f9fa-4772-9d82-f6a1395e03db.jpg?v=1773102242'
        }
      }
    },
    'garden-at-arles': {
      colors: ['garden at arles'],
      heading: 'Garden at Arles',
      subheading: 'Garden at Arles — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'garden at arles': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/green-dragon-ultra-ph_46022b41-f9fa-4772-9d82-f6a1395e03db.jpg?v=1773102242'
        }
      }
    },
    /* NOTE: the-worlds-game-soccer intentionally has NO entry — it ships its own
       dedicated themed template (templates/collection.worlds-game.liquid). Never
       add framework entries for collections that have a custom templateSuffix. */
        'the-great-wave': {
      colors: ['the great wave'],
      heading: 'The Great Wave',
      subheading: 'The Great Wave — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'the great wave': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'the-ottoman': {
      colors: ['the ottoman'],
      heading: 'The Ottoman',
      subheading: 'The Ottoman — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'the ottoman': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'moonlight-seashells': {
      colors: ['moonlight seashells'],
      heading: 'Moonlight Seashells',
      subheading: 'Moonlight Seashells — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'moonlight seashells': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'new-releases': {
      colors: ['glowie witches', 'glowie sugar skulls', 'glowie the big bang', 'the glowie big bang', 'paw or treat', 'pumpkin patch', 'moonlight space exploration', 'glowie meow', 'pink moonlight floral', 'glowie written in the stars'],
      heading: 'New Releases',
      subheading: 'The newest limited-edition Coldest drops, all in one place — every colorway lands here the moment it goes live. Insanely engineered to stay cold up to 100+ hours*. Once a drop sells out, it\'s gone. ✨',
      handles: ['15oz', 'tumbler', 'coldest-limitless-24oz-ultra-v8', 'coldest-limitless-bottle', 'coldest-limitless-bottle-46oz', 'coldest-1-gallon-limitless-ultra', 'coldest-7-oz-bottle', '32oz-go'],
      singleColor: true,
      showFilters: false,
      dropFilters: true,
      hideFilters: true,
      showSizeFilter: true,
      soldOutLast: true,
      infiniteScroll: true,
      infiniteBatch: 12,
      forceDefaultImage: false,
      imageOverrides: {}
    },
    'baby-duckies': {
      colors: ['baby duckies'],
      heading: 'Baby Duckies',
      subheading: 'Baby Duckies — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'baby duckies': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'i-love-icecream': {
      showGridWhenSoldOut: true,   /* pre-release: show the SKUs even at zero inventory */
      colors: ['i love icecream'],
      heading: 'I Love Icecream',
      subheading: 'I Love Icecream — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'i love icecream': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'ship-in-a-bottle': {
      showGridWhenSoldOut: true,   /* pre-release: show the SKUs even at zero inventory */
      colors: ['ship in a bottle'],
      heading: 'Ship in a Bottle',
      subheading: 'Ship in a Bottle — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'ship in a bottle': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'secret-garden': {
      showGridWhenSoldOut: true,   /* pre-release: show the SKUs even at zero inventory */
      colors: ['secret garden'],
      heading: 'Secret Garden',
      subheading: 'Secret Garden — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'secret garden': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'baby-birds': {
      colors: ['baby birds'],
      heading: 'Baby Birds',
      subheading: 'Baby Birds — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'baby birds': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'pink-bows': {
      showGridWhenSoldOut: true,   /* pre-release: show the SKUs even at zero inventory */
      colors: ['pink bows'],
      heading: 'Pink Bows',
      subheading: 'Pink Bows — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'pink bows': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'stained-glass': {
      showGridWhenSoldOut: true,   /* pre-release: show the SKUs even at zero inventory */
      colors: ['stained glass'],
      heading: 'Stained Glass',
      subheading: 'Stained Glass — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'stained glass': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'pumpkin-patch': {
      colors: ['pumpkin patch'],
      heading: 'Pumpkin Patch',
      subheading: 'Pumpkin Patch — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'pumpkin patch': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'moonlight-space-exploration': {
      colors: ['moonlight space exploration'],
      heading: 'Moonlight Space Exploration',
      subheading: 'Moonlight Space Exploration — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'moonlight space exploration': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'glowie-big-bang': {
      colors: ['glowie the big bang', 'the glowie big bang'],
      heading: 'Glowie Big Bang',
      subheading: 'Glowie Big Bang — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'glowie the big bang': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        },
        'the glowie big bang': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'paw-or-treat': {
      colors: ['paw or treat'],
      heading: 'Paw or Treat',
      subheading: 'Paw or Treat — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: true,
      imageOverrides: {
        'paw or treat': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'glowie-witches': {
      colors: ['glowie witches'],
      heading: 'Glowie Witches',
      subheading: 'Glowie Witches — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'glowie witches': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'glowie-sugar-skulls': {
      colors: ['glowie sugar skulls'],
      heading: 'Glowie Sugar Skulls',
      subheading: 'Glowie Sugar Skulls — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'glowie sugar skulls': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'deadly-pumpkin-heads': {
      colors: ['deadly pumpkin heads'],
      heading: 'Deadly Pumpkin Heads',
      subheading: 'Deadly Pumpkin Heads — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'deadly pumpkin heads': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'dark-fire': {
      colors: ['dark fire'],
      heading: 'Dark Fire',
      subheading: 'Dark Fire — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'dark fire': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'fallout': {
      colors: ['fallout'],
      heading: 'Fallout',
      subheading: 'Fallout — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'fallout': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'herbology-class': {
      colors: ['herbology class'],
      heading: 'Herbology Class',
      subheading: 'Herbology Class — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'herbology class': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'taste-this-potion': {
      colors: ['taste this potion'],
      heading: 'Taste This Potion',
      subheading: 'Taste This Potion — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'taste this potion': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'dying-to-read': {
      colors: ['dying to read'],
      heading: 'Dying To Read',
      subheading: 'Dying To Read — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'dying to read': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'enchanted-opal': {
      colors: ['enchanted opal'],
      heading: 'Enchanted Opal',
      subheading: 'Enchanted Opal — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'enchanted opal': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'fall-harvest': {
      colors: ['fall harvest'],
      heading: 'Fall Harvest',
      subheading: 'Fall Harvest — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'fall harvest': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'the-scary-ghost': {
      colors: ['the scary ghost'],
      heading: 'The Scary Ghost',
      subheading: 'The Scary Ghost — Once it\'s gone it\'s gone!',
      /* NO glowBadge key any more — glow is decided per COLORWAY in
         GLOW_COLORWAYS, which is empty pending the owner's confirmation.
         David asked for this drop's glow badge on 2026-10-08; it comes back by
         adding 'the scary ghost' to that list, nowhere else. */
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      /* Art went public on its first date (Oct 15); the launch moved to Oct 22,
         so never re-blur it as a Sneak Peek. */
      reveal: 'none',
      imageOverrides: {
        'the scary ghost': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'rocketship-alloy': {
      colors: ['rocketship alloy'],
      heading: 'Rocketship Alloy',
      subheading: 'Rocketship Alloy — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'rocketship alloy': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'textured-doodles': {
      colors: ['textured doodles'],
      heading: 'Textured Doodles',
      subheading: 'Textured Doodles — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'textured doodles': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'sapphire-opal': {
      colors: ['sapphire opal'],
      heading: 'Sapphire Opal',
      subheading: 'Sapphire Opal — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'sapphire opal': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
    'winterglass-luna': {
      colors: ['winterglass luna'],
      heading: 'WinterGlass Luna',
      subheading: 'WinterGlass Luna — Once it\'s gone it\'s gone!',
      handles: ["15oz", "tumbler", "coldest-limitless-24oz-ultra-v8", "coldest-limitless-bottle", "coldest-limitless-bottle-46oz", "coldest-1-gallon-limitless-ultra", "coldest-7-oz-bottle", "32oz-go"],
      singleColor: true,
      showFilters: false,
      forceDefaultImage: false,
      imageOverrides: {
        'winterglass luna': {
          'default': 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/coming-soon-new-drop.jpg'
        }
      }
    },
/* Add more single-color collections by copying the block above */
  };

  /* Launch dates live here (above the collection dispatch) because the Vault
     branch returns early — anything it reads must already be assigned. */
  var DROP_LAUNCH_DATES = {
    'the hamilton': '2026-06-04',
    'baby fireflies': '2026-06-04',
    'deer moon': '2026-06-04',
    'glowie baby fireflies': '2026-06-04',


    'pursuit of winning': '2026-04-23',
    'aura farming': '2026-04-23',
    'glowie turtle': '2026-04-09',
    'bouquet of sunflowers': '2026-04-16',
    'glowie butterflies': '2026-04-16',
    'irises': '2026-04-30',
    'green dragon': '2026-05-04',
    'mosaic bloom': '2026-05-14',
    'moonlight mermaid': '2026-05-14',
    'magical potions': '2026-05-21',
    'berry bae': '2026-05-21',
    'crochet is life': '2026-05-28',
    'baby dinosaur': '2026-05-28',
    '280cts arrival - eta only, link in descript': '2026-06-15',
    'garden at arles': '2026-06-18',
    '5ctns arrival - eta only, link in description': '2026-06-15',
    'shark tankathon': '2026-06-11',
    'the great wave': '2026-06-18',
    'the ottoman': '2026-06-25',
    'moonlight seashells': '2026-07-01',
    'baby duckies': '2026-07-09',
    'i love icecream': '2026-07-17',
    'ship in a bottle': '2026-07-17',
    'secret garden': '2026-07-17',
    'baby birds': '2026-07-18',
    'pink bows': '2026-07-17',
    'stained glass': '2026-07-17',
    'wizarding skies': '2026-08-06',
    'pink peach tree': '2026-08-06',
    'written in the stars': '2026-08-13',
    'glowie written in the stars': '2026-08-13',
    'rose all day': '2026-08-13',
    'glowie meow': '2026-08-20',
    'pink moonlight floral': '2026-08-20',
    'pumpkin patch': '2026-08-27',
    'moonlight space exploration': '2026-08-27',
    'glowie the big bang': '2026-09-03',
    'the glowie big bang': '2026-09-03',
    'paw or treat': '2026-09-03',
    'glowie witches': '2026-09-10',
    'glowie sugar skulls': '2026-09-10',
    'deadly pumpkin heads': '2026-09-17',
    'dark fire': '2026-09-19',
    'fallout': '2026-09-19',
    'herbology class': '2026-09-19',
    'taste this potion': '2026-10-01',
    'dying to read': '2026-10-08',
    'enchanted opal': '2026-10-08',
    'fall harvest': '2026-10-15',
    'the scary ghost': '2026-10-22',
    'rocketship alloy': '2026-10-22',
    'textured doodles': '2026-10-22',
    'sapphire opal': '2026-10-29',
    'winterglass luna': '2026-11-05'
  };

  /* ── DETECT COLLECTION ─────────────────────────────────── */
  var path = window.location.pathname;
  var match = path.match(/\/collections\/([^\/\?#]+)/);
  if (!match) return;
  var handle = match[1].toLowerCase();

  /* ═══════════════════════════════════════════════════════════════════
     THE VAULT (#5) — /collections/vault
     A permanent archive of every drop that has ended. Scarcity is only
     persuasive when it is VISIBLE: new shoppers see the graveyard of what
     they missed, and the page routes that feeling into the systems where a
     Legacy can still be obtained (Mega Live Games / Loyalty). Fully
     data-driven off DROP_LAUNCH_DATES + DROP_CONFIG, so every future drop
     files itself here automatically the moment it sells through.
     ═══════════════════════════════════════════════════════════════════ */
  if (handle === 'vault') {
    if (window.__coldestVaultActive) return;
    window.__coldestVaultActive = true;
    document.documentElement.classList.add('drop-page-active');
    if (document.body) document.body.classList.add('drop-page-active');
    renderVault();
    return;
  }

  function renderVault() {
    var host = document.createElement('div');
    host.className = 'vault-wrap';
    host.innerHTML = '<div class="vault-head"><span class="vault-kicker">The Coldest Archive</span>' +
      '<h1>THE VAULT</h1><p class="vault-lede">Every drop that has come and gone. One run each — ' +
      'never reissued, never restocked.</p></div><div class="vault-loading">Opening the vault…</div>';

    var style = document.createElement('style');
    style.textContent = [
      '.vault-wrap{max-width:1400px;margin:0 auto;padding:34px 16px 60px;background:#08080a;color:#fff;position:relative;',
      'font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif}',
      '.vault-wrap::before{content:"";position:absolute;inset:0;pointer-events:none;z-index:0;',
      'background-image:linear-gradient(rgba(255,255,255,.018) 1px,transparent 1px),',
      'linear-gradient(90deg,rgba(255,255,255,.018) 1px,transparent 1px),',
      'linear-gradient(rgba(155,180,255,.07) 1px,transparent 1px),',
      'linear-gradient(90deg,rgba(155,180,255,.07) 1px,transparent 1px);',
      'background-size:44px 44px,44px 44px,220px 220px,220px 220px;',
      '-webkit-mask-image:linear-gradient(180deg,#000 0%,rgba(0,0,0,.7) 50%,rgba(0,0,0,.3) 100%);',
      'mask-image:linear-gradient(180deg,#000 0%,rgba(0,0,0,.7) 50%,rgba(0,0,0,.3) 100%)}',
      '.vault-wrap > *{position:relative;z-index:1}',
      '@media (max-width:768px){.vault-wrap::before{background-size:32px 32px,32px 32px,160px 160px,160px 160px}}',
      '.vault-head{text-align:center;padding:10px 0 30px}',
      '.vault-kicker{display:inline-block;font-size:11px;font-weight:800;letter-spacing:.22em;text-transform:uppercase;color:rgba(255,255,255,.45)}',
      '.vault-head h1{font-size:clamp(38px,9vw,78px);margin:10px 0 12px;letter-spacing:-.02em;line-height:1}',
      '.vault-lede{max-width:560px;margin:0 auto;font-size:14px;line-height:1.6;color:rgba(255,255,255,.66)}',
      '.vault-loading{text-align:center;padding:60px 0;color:rgba(255,255,255,.5)}',
      '.vault-count{text-align:center;font-size:12px;font-weight:800;letter-spacing:.18em;text-transform:uppercase;color:rgba(255,255,255,.4);padding:0 0 22px}',
      /* NOTE: this grid is behind `if (handle === 'vault')` and renders on no
         live page — the Seasonal Vault shoppers see is .cvt-grid in
         sections/coldest-seasonal-vault.liquid, which is where the 5-up change
         actually lives. Left at 4 so nobody reads this as the vault's ladder. */
      '.vault-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:18px}',
      '@media (max-width:1024px){.vault-grid{grid-template-columns:repeat(3,1fr)}}',
      '@media (max-width:768px){.vault-grid{grid-template-columns:repeat(2,1fr);gap:10px}}',
      '.vault-card{display:block;text-decoration:none;color:#fff;border:1px solid rgba(255,255,255,.1);',
      'border-radius:14px;overflow:hidden;background:#101014;transition:transform .18s,border-color .18s,box-shadow .18s}',
      '.vault-card:hover{transform:translateY(-4px);border-color:rgba(255,255,255,.34);box-shadow:0 18px 40px -18px rgba(0,0,0,.8)}',
      '.vault-imgwrap{position:relative;padding-bottom:100%;background:#15151a;overflow:hidden}',
      '.vault-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;filter:grayscale(1) contrast(.92) brightness(.82);transition:filter .25s}',
      '.vault-card:hover .vault-img{filter:grayscale(.15) contrast(1) brightness(1)}',
      '.vault-noimg{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;',
      'padding:16px;font-size:15px;font-weight:800;letter-spacing:.02em;color:rgba(255,255,255,.5);',
      'background:radial-gradient(120% 90% at 50% 0%,#1b1b22 0%,#101014 60%,#0b0b0e 100%)}',
      '.vault-seal{position:absolute;top:10px;left:10px;z-index:2;padding:5px 10px;border-radius:6px;',
      'background:rgba(8,8,10,.82);border:1px solid rgba(255,255,255,.22);font-size:9.5px;font-weight:900;letter-spacing:.14em}',
      '.vault-body{padding:13px 14px 15px}',
      '.vault-name{font-size:14.5px;font-weight:800;margin:0 0 4px;line-height:1.25}',
      '.vault-date{font-size:11px;color:rgba(255,255,255,.45);letter-spacing:.04em}',
      '.vault-foot{margin:44px auto 0;max-width:620px;text-align:center;padding:24px 20px;border:1px dashed rgba(255,255,255,.22);border-radius:16px}',
      '.vault-foot b{display:block;font-size:13px;letter-spacing:.16em;margin-bottom:8px}',
      '.vault-foot p{margin:0;font-size:13px;line-height:1.65;color:rgba(255,255,255,.66)}',
      '.vault-foot a{color:#fff;font-weight:700}'
    ].join('');
    document.head.appendChild(style);

    function mount() {
      var main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
      main.insertBefore(host, main.firstChild);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();

    /* colorway -> {handle, heading} from the live drop configs */
    var colorMeta = {};
    Object.keys(DROP_CONFIG).forEach(function (h) {
      (DROP_CONFIG[h].colors || []).forEach(function (c) {
        colorMeta[normalizeColor(c)] = { handle: h };
      });
    });

    /* Every base product a drop colorway can live on — availability must be
       checked across ALL of them so "sold out" means zero inventory everywhere. */
    var bases = ['coldest-limitless-bottle', 'coldest-limitless-bottle-46oz',
                 'coldest-limitless-24oz-ultra-v8', '15oz', 'tumbler', '32oz-go',
                 'coldest-7-oz-bottle', 'coldest-1-gallon-limitless-ultra'];
    var archiveUrl = window.__coldestVaultArchive || null;
    Promise.all([
      archiveUrl ? fetch(archiveUrl).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
                 : Promise.resolve(null),
      Promise.all(bases.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      }))
    ]).then(function (both) {
      var archive = both[0], prods = both[1];
      var img = {}, live = {};
      prods.forEach(function (p) {
        if (!p) return;
        (p.variants || []).forEach(function (v) {
          var c = normalizeColor((v.options && v.options[0]) || '');
          if (!c) return;
          if (!img[c] && v.featured_image && v.featured_image.src) img[c] = v.featured_image.src;
          if (v.available) live[c] = true;
        });
      });

      var nowET = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));

      /* PRIMARY SOURCE: the curated drop archive generated from /pages/coming-soon
         (names, dates, artwork and canonical links for every drop ever run).
         A drop belongs in the Vault once it has hit zero inventory across every
         SKU — anything still buyable stays out. */
      if (archive && archive.drops && archive.drops.length) {
        var arch = archive.drops.filter(function (d) { return !live[d.key]; }).map(function (d) {
          return { name: d.name, date: new Date(d.date + 'T09:45:00'),
                   image: img[d.key] || d.image || '', url: d.url };
        }).filter(function (e) { return e.date <= nowET; });
        arch.sort(function (a, b) { return b.date - a.date; });
        paint(arch);
        return;
      }

      /* The COLORWAY is the drop's identity — several colorways can share one
         collection handle (e.g. multi-drop weeks), so naming cards off the
         collection heading would print "New Releases" five times. */
      /* Title-case that respects drop names: "ship in a bottle" -> "Ship in a
         Bottle", "garden at arles" -> "Garden at Arles" (first word always caps). */
      var SMALL = ['in','a','an','of','the','at','and','on','to','for','with','from'];
      function titleCase(s) {
        return (s || '').split(/\s+/).map(function (w, i) {
          if (i > 0 && SMALL.indexOf(w) !== -1) return w;
          return w.charAt(0).toUpperCase() + w.slice(1);
        }).join(' ');
      }
      /* Ops/placeholder colorways that are not real drops (inventory ETA rows) */
      var NOT_A_DROP = /arrival|eta only|link in desc|^\d+\s*ct(n)?s\b/i;
      var entries = [], seen = {};
      Object.keys(DROP_LAUNCH_DATES).forEach(function (c) {
        var key = normalizeColor(c);
        if (seen[key]) return; seen[key] = true;
        if (NOT_A_DROP.test(key)) return;                    /* ops placeholder, not a drop */
        var meta = colorMeta[key];
        if (!meta) return;                                   /* no framework page to link to */
        var d = new Date(DROP_LAUNCH_DATES[c] + 'T09:45:00');
        if (d > nowET) return;                               /* unreleased — not archive */
        if (live[key]) return;                               /* still shoppable — not archive */
        entries.push({ date: d, image: img[key], handle: meta.handle, name: titleCase(key) });
      });
      entries.sort(function (a, b) { return b.date - a.date; });
      paint(entries);
    }).catch(function () {
      var l = host.querySelector('.vault-loading');
      if (l) l.textContent = 'The vault is sealed — try again shortly.';
    });

    function paint(entries) {
      var loading = host.querySelector('.vault-loading');
      if (loading) loading.parentNode.removeChild(loading);

      if (!entries.length) {
        host.insertAdjacentHTML('beforeend',
          '<p class="vault-count">Nothing sealed away yet — every drop is still live.</p>');
        return;
      }

      var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var cards = entries.map(function (e) {
        var when = MONTHS[e.date.getMonth()] + ' ' + e.date.getDate() + ', ' + e.date.getFullYear();
        return '<a class="vault-card" href="' + (e.url || ('/collections/' + e.handle)) + '">' +
          '<div class="vault-imgwrap"><span class="vault-seal">SOLD OUT</span>' +
          (e.image
            ? '<img class="vault-img" src="' + e.image + '" alt="' + e.name + '" loading="lazy" width="500" height="500">'
            : '<span class="vault-noimg">' + e.name + '</span>') +
          '</div><div class="vault-body"><p class="vault-name">' + e.name + '</p>' +
          '<span class="vault-date">Dropped ' + when + ' &middot; never reissued</span></div></a>';
      }).join('');

      host.insertAdjacentHTML('beforeend',
        '<p class="vault-count">' + entries.length + ' drops sealed away</p>' +
        '<div class="vault-grid">' + cards + '</div>' +
        '<div class="vault-foot"><b>STILL WANT ONE?</b><p>Vaulted drops are never restocked — but a Legacy can still ' +
        'find you: win one in the <a href="/collections/mega-live">Mega Live Games</a>, claim one with Loyalty points, ' +
        'or find one sealed inside a Mystery Crate.</p></div>');
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     GLOW-IN-THE-DARK — an explicit per-COLORWAY allow-list, and the ONLY
     thing that may put a "Glows in the Dark" badge on a card.

     Every entry below was CONFIRMED by David on 2026-10-15, after he caught
     the badge on Enchanted Opal and Fall Harvest and had the whole lot pulled:
     he then confirmed the Glowie-named colorways do glow. Add a colorway here
     ONLY on the same footing — the owner saying that product glows. The list
     happening to match the "Glowie" prefix today does NOT license inferring
     the next one from its name: the prefix is a naming convention, not a spec.
     THE SCARY GHOST IS DELIBERATELY ABSENT — David asked for its badge on
     2026-10-08 but did not re-confirm it on the 15th, and an unconfirmed
     product claim stays off.

     WHY PER-COLORWAY AND NOT PER-PAGE. This used to be `config.glowBadge`, a
     flag on the page's DROP_CONFIG entry, read by renderCard(). But
     loadAlternativeCollections() renders OTHER drops' products through that
     same renderCard(), so a sold-out glow drop stamped its claim onto every
     alternative card on its page — Enchanted Opal and Fall Harvest both
     carried "GLOWS IN THE DARK" because they were listed under The Scary
     Ghost. Keying the badge on the card's own colorway makes that leak
     impossible rather than merely fixed.
     ═══════════════════════════════════════════════════════════════════════ */
  var GLOW_COLORWAYS = [
    'ember glowie',
    'glowie baby fireflies',
    'glowie butterflies',
    'glowie meow',
    'glowie snowflakes',
    'glowie spiral',
    'glowie sugar skulls',
    'glowie the big bang',
    'glowie turtle',
    'glowie witches',
    'glowie written in the stars',
    'the glowie big bang',
  ];
  function isGlowColorway(color) {
    if (!color) return false;
    return GLOW_COLORWAYS.indexOf(String(color).toLowerCase().trim()) !== -1;
  }

  var config = DROP_CONFIG[handle];
  if (!config) return;

  /* Idempotency guard: never render the framework twice on one page. If the
     asset is included/evaluated more than once (theme injection, app proxy,
     SPA nav), the second run bails — otherwise every block, including reviews,
     would render twice. */
  if (window.__coldestDropFrameworkActive) return;
  window.__coldestDropFrameworkActive = true;

  /* Units-remaining scarcity bar (CRON/CONFIG-MANAGED). Each size launches with
     ~UNITS_PER_SIZE units; the bar shows total remaining inventory vs that start
     across the whole collection. Per-drop override via config.unitsPerSize.
     UNITS_BAR_HANDLES gates which collections show it (test rollout). */
  var UNITS_PER_SIZE = 1005;
  /* Per-variant low-stock badge: show "Only N left" on any in-stock variant with
     fewer than this many units remaining (real qty from the server inventory map). */
  var LOW_STOCK_THRESHOLD = 90;
  /* Quick-add bag overlay (replaces the big "Add to Bag" button). The bag icon
     stays visible the whole time; an "Add" label reveals on hover (desktop) and
     the button animates (pulse while adding -> green pop when added). */
  var BAG_ICON = '<svg class="drop-card-bag-ic" viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg><span class="drop-card-bag-label">Add</span>';
  /* Request 177: on phones the buy control is a full-width button under the
     card (wideAtcHTML), shown instead of the bag. Its icon is a CSS mask of
     the same bag art, so it needs no extra markup. */
  var ATC_BAG_MASK = 'url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23000%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpath d=%22M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z%22/%3E%3Cpath d=%22M3 6h18%22/%3E%3Cpath d=%22M16 10a4 4 0 0 1-8 0%22/%3E%3C/svg%3E")';
  var ATC_CHECK_MASK = 'url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23000%22 stroke-width=%222.6%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpath d=%22M20 6 9 17l-5-5%22/%3E%3C/svg%3E")';
  function wideAtcHTML(variantId) {
    return '<button type="button" class="drop-card-atc drop-card-atc--m" data-variant-id="' + variantId + '">Add to Bag</button>';
  }

  /* Binds the bag AND the phone's full-width button: same add, same drawer. */
  function bindBagButtons(scope) {
    scope.querySelectorAll('.drop-card-bag[data-variant-id], .drop-card-atc--m[data-variant-id]').forEach(function(btn) {
      if (btn.__bagBound) return; btn.__bagBound = true;
      var wide = btn.classList.contains('drop-card-atc--m');
      var busyCls = wide ? 'drop-card-atc--adding' : 'drop-card-bag--adding';
      var doneCls = wide ? 'drop-card-atc--added' : 'drop-card-bag--added';
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.classList.contains(busyCls)) return;
        var vid = btn.getAttribute('data-variant-id');
        var restText = wide ? (btn.__restText = btn.__restText || btn.textContent) : '';
        /* Keep the button visible — animate it instead of swapping it. */
        btn.classList.remove(doneCls);
        btn.classList.add(busyCls);
        if (wide) btn.textContent = 'Adding…';
        cartAddXHR({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        .then(function(item) { return item; })
        .then(function() {
          btn.classList.remove(busyCls);
          /* re-add the 'added' class on the next frame so the pop animation
             replays even on rapid repeat adds */
          void btn.offsetWidth;
          btn.classList.add(doneCls);
          if (wide) btn.textContent = 'Added';
          openCartDrawer();
          setTimeout(function() {
            btn.classList.remove(doneCls);
            if (wide) btn.textContent = restText;
          }, wide ? 1500 : 1100);
        })
        .catch(function(err) {
          btn.classList.remove(busyCls);
          if (!wide) return;
          /* 422 = Shopify refused the qty (sold out since the page loaded) */
          btn.textContent = /422/.test(err && err.message) ? 'Sold out' : 'Try again';
          setTimeout(function() { btn.textContent = restText; }, 1800);
        });
      });
    });
  }
  /* ── CART DRAWER ────────────────────────────────────────────────────────
     AOV.ai Cart Drawer (Avada) is this store's drawer; window.AVADA_CART_DRAWER
     is the global its theme app-embed sets up. Every add-to-cart in this file
     routes through here so the drawer opens instead of the shopper being left
     on the page (or, worse, sent to /cart). Ask the app to open itself, then
     fall back to its launcher, then to the events cart-drawer apps listen for.
     Never navigates. */
  /* Adds via XMLHttpRequest on purpose: AOV.ai's cart tracker on this
     jQuery-era theme watches XHR, and adds made through window.fetch never
     reached it — the drawer sat closed while the badge count moved. Same
     endpoint, same payload, and the app sees the add itself. */
  function cartAddXHR(payload) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) {
          try { resolve(JSON.parse(x.responseText)); } catch (e) { resolve({}); }
        } else { reject(new Error('add failed ' + x.status)); }
      };
      x.onerror = function () { reject(new Error('add failed')); };
      x.send(JSON.stringify(payload));
    });
  }

  function openCartDrawer() {
    if (typeof window.coldestOpenCartDrawer === 'function') return window.coldestOpenCartDrawer(); /* canonical: snippets/coldest-atc-drawer.liquid */
    var opened = false;
    /* AOV.ai (Avada) Slide Cart is this store's drawer. Its app embed exposes
       window.aovCartDrawerUpdateAndOpen() / aovCartDrawerOpen(); those are the
       only reliable ways to open it, so try them FIRST.
       Shopify.actions.openCart() must never be used here: the theme's cart type
       is "page", so that action NAVIGATES the shopper to /cart -- which is the
       exact bug this block replaces. */
    var aovOpeners = ['aovCartDrawerUpdateAndOpen', 'aovCartDrawerOpen', 'aovCartDrawerUpdate'];
    for (var ao = 0; ao < aovOpeners.length && !opened; ao++) {
      if (typeof window[aovOpeners[ao]] === 'function') {
        try { window[aovOpeners[ao]](); opened = true; } catch (e) {}
      }
    }

    var apis = ['AVADA_CART_DRAWER', 'AvadaCartDrawer', 'AOVCartDrawer', 'AOV', 'MonsterCart'];
    var verbs = ['open', 'openDrawer', 'openCart', 'show', 'showDrawer', 'toggle'];
    for (var i = 0; i < apis.length && !opened; i++) {
      var api = window[apis[i]];
      if (!api || typeof api !== 'object') continue;
      for (var j = 0; j < verbs.length; j++) {
        if (typeof api[verbs[j]] === 'function') {
          try { api[verbs[j]](); opened = true; break; } catch (e) {}
        }
      }
    }
    if (!opened) {
      var trigger = document.querySelector(
        '[data-aov-cart-drawer-trigger],[data-avada-cart-drawer-trigger],' +
        '.aov-cart-drawer-trigger,.avada-cart-drawer-trigger,' +
        '#aov-sticky-cart,#avada-cart-drawer-icon');
      if (trigger) { try { trigger.click(); opened = true; } catch (e) {} }
    }
    ['avada:cart-drawer:open', 'aov:cart-drawer:open', 'cart-drawer:open',
     'cart:open', 'cart:refresh', 'cart:updated'].forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) {}
    });
    /* Deliberately NOT calling Shopify.actions.openCart(): with cart type
       "page" it navigates to /cart instead of opening the slide cart. */
    return opened;
  }

  /* Show the units-remaining bar on every limited drop. UNITS_BAR_HANDLES is a
     legacy allowlist kept for reference; core staple colors are excluded at the
     render site (they carry large ongoing inventory, so scarcity doesn't apply). */
  var UNITS_BAR_ALL = true;
  var UNITS_BAR_HANDLES = ['the-hamilton'];
  /* Server-rendered inventory (variant id -> qty) from collection.drop.liquid.
     The storefront /products/*.js returns 0 inventory on this store, so the
     units bar reads real quantities from this Liquid-emitted map. */
  var SERVER_INVENTORY = (function() {
    try {
      var el = document.getElementById('drop-inventory-data');
      return el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) { return {}; }
  })();
  function serverInv(variantId) {
    var q = SERVER_INVENTORY[String(variantId)];
    return (typeof q === 'number') ? q : null;
  }

  /* Server-rendered review totals (product id -> {c: count, a: "4.8"}) emitted
     by collection.drop.liquid. Okendo's star widget is data-ON-PAGE: it reads
     the payload its own app block renders INSIDE the element, and this template
     renders no app blocks, so the bare [data-oke-star-rating] div that used to
     sit here had no data source and Okendo painted grey stars + "0 Reviews" on
     products with thousands of reviews. Cards draw their stars from this map
     instead — the BASE product's lifetime total, so a brand-new colorway with
     no reviews of its own still shows its size's real count. Same pattern as
     SERVER_INVENTORY above, for the same reason: the data has to come from
     Liquid, because /products/*.js carries no metafields. */
  var SERVER_REVIEWS = (function() {
    try {
      var el = document.getElementById('drop-reviews-data');
      return el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) { return {}; }
  })();

  /* DROP COMPANIONS (Request 241, David: "add the 30oz to all collections
     where it exists"). A one-size product whose colorway NAMES equal drop
     colorway names joins the grid of every page whose colours it carries IN
     STOCK — today the 30oz Drive Thru. It is not a base product: it is not in
     any config's handles and not a member of the drop collections, so the
     template hands its in-stock colours, quantities and review totals over in
     #drop-companions (same reason as the two maps above), and the product is
     fetched only on pages it actually matches. Mirrors: snippets/
     coldest-drop-companions.liquid and COMPANION_PRODUCTS in automations/
     fetch_newest_drops.py. Its card: in stock only, its OWN packshot only
     (never borrows or lends one), no reveal scrim (it is already on sale),
     and it never counts toward the drop's scarcity, staging or bundle. */
  var COMPANION_HANDLES = ['drive-thru'];
  function isCompanion(handle) { return COMPANION_HANDLES.indexOf(handle) !== -1; }
  var SERVER_COMPANIONS = (function() {
    try {
      var el = document.getElementById('drop-companions');
      return el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) { return {}; }
  })();
  Object.keys(SERVER_COMPANIONS).forEach(function(h) {
    var c = SERVER_COMPANIONS[h] || {};
    Object.keys(c.inv || {}).forEach(function(vid) {
      if (typeof SERVER_INVENTORY[vid] !== 'number') SERVER_INVENTORY[vid] = c.inv[vid];
    });
    if (c.pid && c.rev && !SERVER_REVIEWS[String(c.pid)]) SERVER_REVIEWS[String(c.pid)] = c.rev;
  });

  function serverReview(productId) {
    var r = SERVER_REVIEWS[String(productId)];
    if (!r) return null;
    var c = parseInt(r.c, 10);
    var a = parseFloat(r.a);
    if (!c || c <= 0) return null;
    return { count: c, avg: (a > 0 && a <= 5) ? a : 0 };
  }

  /* Returns '' when there is no data, so a card shows NOTHING rather than a
     zero state — blank beats "0 Reviews" on a 5,202-review product. Half-step
     rounding matches the Limitless lander's star rendering. */
  function cardRatingHtml(productId) {
    var r = serverReview(productId);
    if (!r || !r.avg) return '';
    var rounded = Math.round(r.avg * 2) / 2;
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += (rounded >= i - 0.5)
        ? '<span class="drop-card-star drop-card-star--on">\u2605</span>'
        : '<span class="drop-card-star">\u2605</span>';
    }
    return '<div class="drop-card-rating" aria-label="' + r.avg + ' out of 5 stars, ' +
           r.count + ' reviews"><span class="drop-card-stars">' + stars + '</span>' +
           '<span class="drop-card-rcount">(' + r.count.toLocaleString() + ')</span></div>';
  }

  /* ── DROP THEMES (CRON-MANAGED) ───────────────────────────
     Per-drop visual identity — the ENTIRE drop page takes the drop's vibe:
       accent/accent2  dominant colors pulled from the revealed drop image
       ink             moody base tone
       bg              full-page background behind the whole drop experience
       font/fontUrl    display font for headings (exactly ONE Google Fonts file)
       tagline         edgy one-liner derived from the drop name
     Generated by weekly_drop_sync.py at Thursday 12:01am ET; drops without an
     entry keep the default Coldest ink + ice glow. */
  var DROP_THEMES = {
    'prime-week': { curated: true, accent: '#38bdf8', accent2: '#0c2c6e', ink: '#04101f', tagline: 'Seven days of cold deals — when the week ends, the deal ends.', controlsHint: 'Filter by colorway or size, then sort the deals ⚡', bg: 'radial-gradient(125% 105% at 50% -8%, #1d6bff -42%, #0c2c6e 22%, #061a3e 54%, #04101f 100%)', pattern: 'radial-gradient(rgba(56,189,248,0.18) 1.2px, transparent 1.7px)', titleGradient: 'linear-gradient(95deg, #bae6fd 0%, #7fc4ff 30%, #38bdf8 60%, #1d6bff 100%)', ribbon: 'repeating-linear-gradient(45deg, #1d6bff 0 20px, #04101f 20px 24px, #38bdf8 24px 40px, #04101f 40px 44px)', motif: '⚡', pills: ['⚡ Prime Week · 7 Days Only', '🧊 10% off everything · code PRIMEWEEK', '💙 Curated fan-favourite colorways'], font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'the-hamilton': { curated: true, accent: '#e8505f', accent2: '#1d3557', ink: '#0a1126', tagline: 'An American legend — iced in red, white & blue.', bg: 'radial-gradient(120% 90% at 50% 0%, #24467c 0%, #101c3a 55%, #060a18 100%)', pattern: 'radial-gradient(rgba(255,255,255,0.16) 1.2px, transparent 1.6px)', titleGradient: 'linear-gradient(90deg, #ff6b74 0%, #ffffff 48%, #8fb8ff 100%)', ribbon: 'repeating-linear-gradient(90deg, #b22234 0 48px, #ffffff 48px 96px, #3c3b6e 96px 144px)', motif: '🇺🇸', pills: ['🇺🇸 Limited Edition Drop', 'Once it’s gone, it’s gone', 'Land of the cold · Thursdays 9:45am ET'], font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'shark-tankathon': { curated: true, accent: '#22d3ee', accent2: '#0e3a5d', ink: '#06121c', tagline: 'The viral one. Gone when it’s gone.', bg: 'radial-gradient(120% 90% at 50% 0%, #0a2b40 0%, #061a29 55%, #02090f 100%)', titleGradient: 'linear-gradient(90deg, #67e8f9 0%, #ffffff 55%, #38bdf8 100%)', motif: '🦈', pills: ['🦈 Limited Edition Drop', 'One viral run · Limited', 'Once it’s gone, it’s gone'], font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'garden-at-arles': { curated: true, accent: '#e8b13f', accent2: '#2e4a2f', ink: '#0c100b', tagline: 'A masterpiece you can carry.', bg: 'radial-gradient(120% 90% at 50% 0%, #2e4a2f 0%, #16241a 55%, #070b07 100%)', titleGradient: 'linear-gradient(90deg, #f5d98a 0%, #fff7e0 50%, #e8b13f 100%)', motif: '🌻', pills: ['🎨 Limited Edition Drop', 'One small run — like the original', 'New drops Thursdays · 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'the-great-wave': { curated: true, accent: '#7cc7e8', accent2: '#1e3a5f', ink: '#0a1622', tagline: 'A masterpiece in motion — ride it before it breaks.', bg: 'radial-gradient(120% 90% at 50% 0%, #1e3a5f 0%, #102338 55%, #060f1a 100%)', titleGradient: 'linear-gradient(90deg, #bfe3f5 0%, #ffffff 50%, #5ea8d6 100%)', motif: '🌊', pills: ['🌊 Limited Edition Drop', 'Once it’s gone, it’s gone', 'New drops Thursdays · 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'the-ottoman': { curated: true, accent: '#e0b341', accent2: '#6b1f2a', ink: '#140709', tagline: 'An empire in your hands — claimed once, never reissued.', bg: 'radial-gradient(120% 90% at 50% 0%, #6b1f2a 0%, #350f16 55%, #120508 100%)', titleGradient: 'linear-gradient(90deg, #f3d488 0%, #fff3d0 50%, #d4a017 100%)', motif: '🕌', pills: ['🕌 Limited Edition Drop', 'One imperial run · never reissued', 'New drops Thursdays · 9:45am ET'], font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'baby-dinosaur': { curated: true, accent: '#4ade80', accent2: '#166534', ink: '#07130a', tagline: 'Hatched in a limited clutch.', bg: 'radial-gradient(120% 90% at 50% 0%, #1f7a44 0%, #0d2c18 55%, #04110a 100%)', titleGradient: 'linear-gradient(90deg, #86efac 0%, #f0fdf4 50%, #4ade80 100%)', motif: '🦕', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'crochet-is-life': { curated: true, accent: '#f4a8b8', accent2: '#7c4a3a', ink: '#170d0a', tagline: 'Stitched once. Never again.', bg: 'radial-gradient(120% 90% at 50% 0%, #7c4a3a 0%, #3a221b 55%, #150c09 100%)', titleGradient: 'linear-gradient(90deg, #ffd9e0 0%, #fff7f0 50%, #f4a8b8 100%)', motif: '🧶', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'berry-bae': { curated: true, accent: '#e879f9', accent2: '#581c87', ink: '#120618', tagline: 'Sweet. Bold. Short-lived.', bg: 'radial-gradient(120% 90% at 50% 0%, #6d28a9 0%, #2e1052 55%, #0e0519 100%)', titleGradient: 'linear-gradient(90deg, #f0abfc 0%, #fdf4ff 50%, #c026d3 100%)', motif: '🫐', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'magical-potions': { curated: true, accent: '#a78bfa', accent2: '#10403b', ink: '#0a0714', tagline: 'Brewed once. Never again.', bg: 'radial-gradient(120% 90% at 50% 0%, #3b2a6d 0%, #1a1233 55%, #080513 100%)', titleGradient: 'linear-gradient(90deg, #c4b5fd 0%, #f5f3ff 50%, #34d399 100%)', motif: '🔮', font: "'Orbitron', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&display=swap' },
    'moonlight-mermaid': { curated: true, accent: '#5eead4', accent2: '#134e5e', ink: '#04121a', tagline: 'Surfaced for one week only.', bg: 'radial-gradient(120% 90% at 50% 0%, #155e6e 0%, #082a36 55%, #030f15 100%)', titleGradient: 'linear-gradient(90deg, #99f6e4 0%, #f0fdfa 50%, #2dd4bf 100%)', motif: '🧜‍♀️', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'moonlight-seashells': { curated: true, accent: '#bcd4e6', accent2: '#21425a', ink: '#050f18', tagline: 'Gathered by moonlight — gone by morning.', bg: 'radial-gradient(120% 90% at 50% 0%, #21425a 0%, #0d2434 55%, #050f18 100%)', pattern: 'radial-gradient(rgba(188,212,230,0.15) 1.1px, transparent 1.6px)', titleGradient: 'linear-gradient(90deg, #dbe9f3 0%, #fdf6ea 50%, #9cc0db 100%)', motif: '🐚', pills: ['🐚 Limited Edition Drop', 'One moonlit run · once it’s gone, it’s gone', 'New drops Thursdays · 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'baby-duckies': { curated: true, accent: '#ffd84d', accent2: '#1b6b8f', ink: '#07141c', tagline: 'Waddled in for one week only.', bg: 'radial-gradient(120% 90% at 50% 0%, #1b6b8f 0%, #0d3549 55%, #06131c 100%)', pattern: 'radial-gradient(rgba(255,216,77,0.14) 1.3px, transparent 1.8px)', titleGradient: 'linear-gradient(90deg, #ffe98a 0%, #fffbe8 50%, #ffd84d 100%)', motif: '🦆', pills: ['🦆 Limited Edition Drop', 'One little flock · once it’s gone, it’s gone', 'New drops Thursdays · 9:45am ET'], font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'mosaic-bloom': { curated: true, accent: '#fb923c', accent2: '#155e63', ink: '#0c0a06', tagline: 'Pieced together. Gone in pieces.', bg: 'radial-gradient(120% 90% at 50% 0%, #155e63 0%, #0a2c30 55%, #050f10 100%)', titleGradient: 'linear-gradient(90deg, #fdba74 0%, #fff7ed 50%, #2dd4bf 100%)', motif: '🌺', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'green-dragon': { curated: true, accent: '#34d399', accent2: '#064e3b', ink: '#040f0b', tagline: 'Hatched in a small clutch. Breathing smoke.', bg: 'radial-gradient(120% 90% at 50% 0%, #0b6b4f 0%, #06301f 55%, #03110b 100%)', titleGradient: 'linear-gradient(90deg, #6ee7b7 0%, #ecfdf5 50%, #10b981 100%)', motif: '🐉', font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'irises': { curated: true, accent: '#a5b4fc', accent2: '#3730a3', ink: '#0a0918', tagline: 'Van Gogh energy. Limited canvas.', bg: 'radial-gradient(120% 90% at 50% 0%, #3d35a8 0%, #1c1850 55%, #08071c 100%)', titleGradient: 'linear-gradient(90deg, #c7d2fe 0%, #eef2ff 50%, #818cf8 100%)', motif: '🌸', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'aura-farming': { curated: true, accent: '#d8b4fe', accent2: '#5b21b6', ink: '#0e0716', tagline: 'Harvest your aura early.', bg: 'radial-gradient(120% 90% at 50% 0%, #6d28d9 0%, #311260 55%, #0d061b 100%)', titleGradient: 'linear-gradient(90deg, #e9d5ff 0%, #faf5ff 50%, #c084fc 100%)', motif: '✨', font: "'Orbitron', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&display=swap' },
    'pursuit-of-winning': { curated: true, accent: '#fbbf24', accent2: '#713f12', ink: '#110c04', tagline: 'One shot. No reruns.', bg: 'radial-gradient(120% 90% at 50% 0%, #8a5a16 0%, #3c2709 55%, #120c03 100%)', titleGradient: 'linear-gradient(90deg, #fde68a 0%, #fffbeb 50%, #f59e0b 100%)', motif: '🏅', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'bouquet-of-sunflowers': { curated: true, accent: '#facc15', accent2: '#3f6212', ink: '#0d0f04', tagline: 'Cut fresh. Wilts fast.', bg: 'radial-gradient(120% 90% at 50% 0%, #4d7c0f 0%, #233a08 55%, #0c1403 100%)', titleGradient: 'linear-gradient(90deg, #fde047 0%, #fefce8 50%, #eab308 100%)', motif: '🌻', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'glowie-turtle': { curated: true, accent: '#6ee7b7', accent2: '#065f46', ink: '#04110d', tagline: 'Glows at night. Gone by Sunday.', bg: 'radial-gradient(120% 90% at 50% 0%, #0a7559 0%, #053527 55%, #02130e 100%)', titleGradient: 'linear-gradient(90deg, #a7f3d0 0%, #ecfdf5 50%, #34d399 100%)', motif: '🐢', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'the-world-stage': { curated: true, accent: '#60a5fa', accent2: '#1e3a8a', ink: '#060b1a', tagline: 'Claim your seat before kickoff.', bg: 'radial-gradient(120% 90% at 50% 0%, #1e44a8 0%, #0e1f4e 55%, #05091b 100%)', titleGradient: 'linear-gradient(90deg, #93c5fd 0%, #eff6ff 50%, #3b82f6 100%)', motif: '⚽', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'blue-opal': { curated: true, accent: '#7dd3fc', accent2: '#0c4a6e', ink: '#040e16', tagline: 'Pulled from a tiny vein.', bg: 'radial-gradient(120% 90% at 50% 0%, #0e5a85 0%, #07293d 55%, #030f17 100%)', titleGradient: 'linear-gradient(90deg, #bae6fd 0%, #f0f9ff 50%, #38bdf8 100%)', motif: '🌊', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'mont-sainte': { curated: true, accent: '#a3e635', accent2: '#365314', ink: '#0b0f05', tagline: 'Peak season is short.', bg: 'radial-gradient(120% 90% at 50% 0%, #44651a 0%, #1f2f0b 55%, #0a1004 100%)', titleGradient: 'linear-gradient(90deg, #d9f99d 0%, #f7fee7 50%, #84cc16 100%)', motif: '⛰️', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'flirt-flower': { curated: true, accent: '#f9a8d4', accent2: '#831843', ink: '#16060e', tagline: 'Picked fresh. Wilts fast.', bg: 'radial-gradient(120% 90% at 50% 0%, #9d2463 0%, #4a102e 55%, #160510 100%)', titleGradient: 'linear-gradient(90deg, #fbcfe8 0%, #fdf2f8 50%, #ec4899 100%)', motif: '🌷', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'love-of-music': { curated: true, accent: '#c084fc', accent2: '#6b21a8', ink: '#10061a', tagline: 'A limited pressing.', bg: 'radial-gradient(120% 90% at 50% 0%, #7e22ce 0%, #3a0f63 55%, #10051d 100%)', titleGradient: 'linear-gradient(90deg, #d8b4fe 0%, #faf5ff 50%, #a855f7 100%)', motif: '🎵', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'glossy-pink': { curated: true, accent: '#f472b6', accent2: '#9d174d', ink: '#170710', tagline: 'Loud, proud, low stock.', bg: 'radial-gradient(120% 90% at 50% 0%, #be1865 0%, #5c0c31 55%, #1a0512 100%)', titleGradient: 'linear-gradient(90deg, #f9a8d4 0%, #fdf2f8 50%, #ec4899 100%)', motif: '💗', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'water-lilies': { curated: true, accent: '#86efac', accent2: '#14532d', ink: '#06110a', tagline: 'Still water. Short run.', bg: 'radial-gradient(120% 90% at 50% 0%, #1b6b3c 0%, #0c3019 55%, #04120a 100%)', titleGradient: 'linear-gradient(90deg, #bbf7d0 0%, #f0fdf4 50%, #4ade80 100%)', motif: '🪷', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'buzzer-beater': { curated: true, accent: '#fb923c', accent2: '#7c2d12', ink: '#120804', tagline: 'Last possession. Call your number.', bg: 'radial-gradient(120% 90% at 50% 0%, #94380f 0%, #471a06 55%, #150803 100%)', titleGradient: 'linear-gradient(90deg, #fdba74 0%, #fff7ed 50%, #f97316 100%)', motif: '🏀', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'stealth-black': { curated: true, accent: '#9ca3af', accent2: '#1f2937', ink: '#050608', tagline: 'Darker. Colder. Limited.', bg: 'radial-gradient(120% 90% at 50% 0%, #2c3848 0%, #131a24 55%, #05070a 100%)', titleGradient: 'linear-gradient(90deg, #d1d5db 0%, #ffffff 50%, #6b7280 100%)', motif: '🌑', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'stung-by-a-bee': { curated: true, accent: '#fde047', accent2: '#713f12', ink: '#100c03', tagline: 'The hive only made so much honey.', bg: 'radial-gradient(120% 90% at 50% 0%, #8a5a16 0%, #3e2a08 55%, #120d03 100%)', titleGradient: 'linear-gradient(90deg, #fef08a 0%, #fefce8 50%, #facc15 100%)', motif: '🐝', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'the-marrakech': { curated: true, accent: '#2dd4bf', accent2: '#9a3412', ink: '#100804', tagline: 'Woven in small batches.', bg: 'radial-gradient(120% 90% at 50% 0%, #a8421a 0%, #4c1f0b 55%, #150904 100%)', titleGradient: 'linear-gradient(90deg, #5eead4 0%, #fff7ed 50%, #fb923c 100%)', motif: '🧿', font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'clover-floral': { curated: true, accent: '#4ade80', accent2: '#15803d', ink: '#05110a', tagline: 'Step in while the luck lasts.', bg: 'radial-gradient(120% 90% at 50% 0%, #19883f 0%, #0b3d1d 55%, #04130a 100%)', titleGradient: 'linear-gradient(90deg, #86efac 0%, #f0fdf4 50%, #22c55e 100%)', motif: '🍀', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'starry-night': { curated: true, accent: '#fbbf24', accent2: '#1e3a8a', ink: '#060a18', tagline: 'Made for the after-hours.', bg: 'radial-gradient(120% 90% at 50% 0%, #1e40af 0%, #101f54 55%, #05081c 100%)', titleGradient: 'linear-gradient(90deg, #fde68a 0%, #eff6ff 50%, #60a5fa 100%)', motif: '🌌', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'red-luna': { curated: true, accent: '#f87171', accent2: '#7f1d1d', ink: '#130505', tagline: 'She rises briefly. Don\'t sleep.', bg: 'radial-gradient(120% 90% at 50% 0%, #991f1f 0%, #460e0e 55%, #150505 100%)', titleGradient: 'linear-gradient(90deg, #fecaca 0%, #fef2f2 50%, #ef4444 100%)', motif: '🌕', font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'magnolia-bloom': { curated: true, accent: '#fda4af', accent2: '#881337', ink: '#15060b', tagline: 'A season that doesn\'t repeat.', bg: 'radial-gradient(120% 90% at 50% 0%, #9f1d45 0%, #4c0e22 55%, #16050b 100%)', titleGradient: 'linear-gradient(90deg, #fecdd3 0%, #fff1f2 50%, #fb7185 100%)', motif: '🌸', font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'xoxo': { curated: true, accent: '#fb7185', accent2: '#9f1239', ink: '#160509', tagline: 'Sealed with a kiss. Sent once.', bg: 'radial-gradient(120% 90% at 50% 0%, #be1445 0%, #5b0a21 55%, #18050a 100%)', titleGradient: 'linear-gradient(90deg, #fda4af 0%, #fff1f2 50%, #f43f5e 100%)', motif: '💋', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'love-pop': { curated: true, accent: '#f472b6', accent2: '#be185d', ink: '#16060e', tagline: 'Sweet while it lasts.', bg: 'radial-gradient(120% 90% at 50% 0%, #d21d72 0%, #650d36 55%, #1a0511 100%)', titleGradient: 'linear-gradient(90deg, #f9a8d4 0%, #fdf2f8 50%, #ec4899 100%)', motif: '🍬', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'deer-moon': { curated: true, accent: '#cbd5e1', accent2: '#1e293b', ink: '#05080d', tagline: 'Out by moonlight. Gone by dawn.', bg: 'radial-gradient(120% 90% at 50% 0%, #2b3b54 0%, #131c2b 55%, #05080d 100%)', titleGradient: 'linear-gradient(90deg, #e2e8f0 0%, #ffffff 50%, #94a3b8 100%)', motif: '🦌', font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'baby-fireflies': { curated: true, accent: '#bef264', accent2: '#1a2e05', ink: '#070d02', tagline: 'Caught for one week only.', bg: 'radial-gradient(120% 90% at 50% 0%, #2e4a0c 0%, #162505 55%, #070d02 100%)', titleGradient: 'linear-gradient(90deg, #d9f99d 0%, #f7fee7 50%, #a3e635 100%)', motif: '✨', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'glowie-baby-fireflies': { curated: true, accent: '#bef264', accent2: '#1a2e05', ink: '#070d02', tagline: 'Lights out. Glow up.', bg: 'radial-gradient(120% 90% at 50% 0%, #2e4a0c 0%, #162505 55%, #070d02 100%)', titleGradient: 'linear-gradient(90deg, #d9f99d 0%, #f7fee7 50%, #a3e635 100%)', motif: '✨', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'halloween': { curated: true, controlsHint: 'Filter by drop or size, then sort the haunt 👇', accent: '#ff6a00', accent2: '#8a0f0f', ink: '#0a0400', tagline: 'Abandon all chill, ye who enter — the whole haunt, one cursed vault.', bg: 'radial-gradient(130% 100% at 50% -8%, #ff6a00 -45%, #5a1e00 18%, #1f0a00 52%, #070200 100%)', pattern: 'radial-gradient(rgba(255,106,0,0.26) 1.5px, transparent 2px)', titleGradient: 'linear-gradient(92deg, #ffd36b 0%, #ff8c1a 26%, #ff5500 58%, #e01616 100%)', ribbon: 'repeating-linear-gradient(45deg, #ff6a00 0 22px, #0a0400 22px 44px)', motif: '🎃', pills: ['🎃 Limited Halloween Vault', '🪦 Once it\'s buried, it\'s gone', '🩸 Every spooky drop, raised from the dead'], font: "'Creepster', system-ui, cursive", fontUrl: 'https://fonts.googleapis.com/css2?family=Creepster&display=swap' },
    'art': { curated: true, accent: '#c9a14a', accent2: '#3a2f1c', ink: '#0a0805', tagline: 'The Masterpiece Gallery — wearable fine art, curated & retired forever.', controlsHint: 'Filter by masterpiece or size, then sort the gallery 🖼️', bg: 'radial-gradient(125% 105% at 50% -8%, #6e5a2e -42%, #2a2114 20%, #14100a 54%, #0a0805 100%)', pattern: 'radial-gradient(rgba(201,161,74,0.16) 1px, transparent 1.6px)', titleGradient: 'linear-gradient(95deg, #f6e7b8 0%, #e7c873 28%, #c9a14a 58%, #a47b2e 100%)', ribbon: 'repeating-linear-gradient(45deg, #c9a14a 0 16px, #14100a 16px 20px, #a47b2e 20px 36px, #14100a 36px 40px)', motif: '🖼️', pills: ['🖼️ Curated Masterpiece Gallery', '🎨 Numbered, limited & retired forever', '🏛️ Six icons of art history'], font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@600;800&family=Cormorant+Garamond:ital,wght@0,500;1,500&display=swap' },
    'july-4th-weekend': { curated: true, accent: '#e63946', accent2: '#1d3a8f', ink: '#050a1a', tagline: 'Star-spangled & beach-ready — iced in red, white & blue for the long weekend.', bg: 'radial-gradient(125% 100% at 50% -8%, #2b4c9b -30%, #14275c 28%, #0a1533 60%, #050a1a 100%)', pattern: 'radial-gradient(rgba(255,255,255,0.18) 1.2px, transparent 1.7px)', titleGradient: 'linear-gradient(92deg, #ff5b6a 0%, #ffffff 48%, #6ea8ff 100%)', ribbon: 'repeating-linear-gradient(90deg, #b22234 0 44px, #ffffff 44px 88px, #1d3a8f 88px 132px)', motif: '🎆', pills: ['🎆 July 4th Weekend Drop', '🇺🇸 Red, white & ice-cold', '🏖️ Limited holiday run — gone after the weekend'], font: "'Anton', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Anton&display=swap' },
    'glowie-meow': { curated: true, accent: '#8ef2c0', accent2: '#1f3d4a', ink: '#08151a', tagline: 'Nine lives, one run.', bg: 'radial-gradient(120% 90% at 50% 0%, #1f3d4a 0%, #10242d 55%, #060f14 100%)', pattern: 'radial-gradient(rgba(142,242,192,0.18) 1.2px, transparent 1.7px)', titleGradient: 'linear-gradient(90deg, #b9ffe0 0%, #ffffff 50%, #8ef2c0 100%)', motif: '\ud83d\udc31', pills: ['\ud83d\udc31 Limited Edition Drop', 'Glows after dark \u00b7 once it\'s gone, it\'s gone', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'pink-moonlight-floral': { curated: true, accent: '#f2a9c4', accent2: '#3a2b5c', ink: '#140f1e', tagline: 'Blooms by moonlight — gone by morning.', bg: 'radial-gradient(120% 90% at 50% 0%, #3a2b5c 0%, #211936 55%, #0e0a16 100%)', pattern: 'radial-gradient(rgba(242,169,196,0.16) 1.3px, transparent 1.8px)', titleGradient: 'linear-gradient(90deg, #ffd0e2 0%, #fff4f8 50%, #c3a6e6 100%)', motif: '\ud83c\udf3a', pills: ['\ud83c\udf3a Limited Edition Drop', 'One moonlit bloom \u00b7 once it\'s gone, it\'s gone', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'glowie-written-in-the-stars': { curated: true, accent: '#ffd98a', accent2: '#233a6b', ink: '#070b18', tagline: 'Some things are written — this one is limited.', bg: 'radial-gradient(120% 90% at 50% 0%, #233a6b 0%, #121d3d 55%, #05070f 100%)', pattern: 'radial-gradient(rgba(255,217,138,0.20) 1.1px, transparent 1.6px), radial-gradient(rgba(255,255,255,0.12) 0.9px, transparent 1.4px)', titleGradient: 'linear-gradient(90deg, #ffe6a8 0%, #ffffff 48%, #9db8ff 100%)', motif: '\u2728', pills: ['\u2728 Limited Edition Drop', 'Standard + Glowie editions', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Cormorant Garamond', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&display=swap' },
    'rose-all-day': { curated: true, accent: '#f7b7c3', accent2: '#7d2b45', ink: '#180b11', tagline: 'Poured once — never poured again.', bg: 'radial-gradient(120% 90% at 50% 0%, #7d2b45 0%, #451826 55%, #180b11 100%)', pattern: 'radial-gradient(rgba(247,183,195,0.16) 1.3px, transparent 1.8px)', titleGradient: 'linear-gradient(90deg, #ffd2db 0%, #fff4f6 50%, #e8a0b2 100%)', motif: '\ud83c\udf39', pills: ['\ud83c\udf39 Limited Edition Drop', 'One pour \u00b7 once it\'s gone, it\'s gone', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'wizarding-skies': { curated: true, accent: '#f0c65a', accent2: '#3b2a6b', ink: '#0a0716', tagline: 'One night of magic — then it vanishes.', bg: 'radial-gradient(120% 90% at 50% 0%, #3b2a6b 0%, #1d1440 55%, #08050f 100%)', pattern: 'radial-gradient(rgba(240,198,90,0.16) 1.2px, transparent 1.7px), radial-gradient(rgba(255,255,255,0.10) 1px, transparent 1.5px)', titleGradient: 'linear-gradient(90deg, #f6d98a 0%, #fff6dc 50%, #b79bff 100%)', motif: '\ud83e\ude84', pills: ['\ud83e\ude84 Limited Edition Drop', 'One spell \u00b7 once it\'s gone, it\'s gone', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'pink-peach-tree': { curated: true, accent: '#f7a8bb', accent2: '#5f7f93', ink: '#141019', tagline: 'In bloom for a moment — then the branch is bare.', bg: 'radial-gradient(120% 90% at 50% 0%, #5f7f93 0%, #33465a 55%, #12161d 100%)', pattern: 'radial-gradient(rgba(247,168,187,0.17) 1.4px, transparent 1.9px)', titleGradient: 'linear-gradient(90deg, #ffc9d7 0%, #fff2f5 50%, #a8c6d8 100%)', motif: '\ud83c\udf38', pills: ['\ud83c\udf38 Limited Edition Drop', 'One bloom \u00b7 once it\'s gone, it\'s gone', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'back-to-school': { curated: true, accent: '#ffc93c', accent2: '#16324f', ink: '#0a1420', tagline: 'Class is in session — the coldest lineup on campus.', bg: 'radial-gradient(120% 90% at 50% 0%, #16324f 0%, #0d2033 55%, #070f18 100%)', pattern: 'repeating-linear-gradient(180deg, transparent 0 25px, rgba(255,255,255,0.05) 25px 26px)', titleGradient: 'linear-gradient(90deg, #ffd76e 0%, #fff6dc 50%, #ffc93c 100%)', motif: '\u270f\ufe0f', pills: ['\u270f\ufe0f Back to School Collection', 'In stock now \u00b7 while they last', 'New drops Thursdays \u00b7 9:45am ET'], font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'i-love-icecream': { curated: true, accent: '#ffc9e2', accent2: '#5a4c72', ink: '#1a1621', tagline: 'Sweet enough to melt — cold enough not to.', bg: 'radial-gradient(120% 90% at 50% 0%, #5a4c72 0%, #2b2138 55%, #120d18 100%)', pattern: 'radial-gradient(rgba(255,201,226,0.16) 1.4px, transparent 1.9px), radial-gradient(rgba(247,194,96,0.12) 1.1px, transparent 1.6px)', titleGradient: 'linear-gradient(90deg, #ffd9ea 0%, #fff3d6 45%, #f7c260 100%)', motif: '🍦', pills: ['🍦 Limited Edition Drop', 'One sweet scoop · once it\'s gone, it\'s gone', 'Mega Live 4 exclusive · while supplies last'], font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'ship-in-a-bottle': { curated: true, accent: '#7bc9d7', accent2: '#1d3a52', ink: '#0a141d', tagline: 'A voyage sealed in glass — one run, then gone.', bg: 'radial-gradient(120% 90% at 50% 0%, #1d3a52 0%, #0f2334 55%, #060d14 100%)', pattern: 'radial-gradient(rgba(123,201,215,0.13) 1.2px, transparent 1.7px)', titleGradient: 'linear-gradient(90deg, #a8dfe9 0%, #f0e6cf 50%, #7bc9d7 100%)', motif: '⛵', pills: ['⛵ Limited Edition Drop', 'One voyage · once it\'s gone, it\'s gone', 'Mega Live 4 exclusive · while supplies last'], font: "'Cinzel', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@700;900&display=swap' },
    'secret-garden': { curated: true, accent: '#d9b64e', accent2: '#2e4a26', ink: '#0c130a', tagline: 'Hidden in bloom — gone by nightfall.', bg: 'radial-gradient(120% 90% at 50% 0%, #2e4a26 0%, #16260f 55%, #070d05 100%)', pattern: 'radial-gradient(rgba(217,182,78,0.13) 1.2px, transparent 1.7px)', titleGradient: 'linear-gradient(90deg, #e8d494 0%, #f7f0da 50%, #a8c97a 100%)', motif: '🌿', pills: ['🌿 Limited Edition Drop', 'One secret bloom · once it\'s gone, it\'s gone', 'Mega Live 4 exclusive · while supplies last'], font: "'Playfair Display', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&display=swap' },
    'baby-birds': { accent: '#ec5fb4', accent2: '#65284d', ink: '#1d0b16', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #65284d 0%, #1d0b16 55%, #000 100%)', font: "'Baloo 2', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&display=swap' },
    'pink-bows': { curated: true, accent: '#ffa8bd', accent2: '#8a3350', ink: '#1e1013', tagline: 'Tied once — gone forever.', bg: 'radial-gradient(120% 90% at 50% 0%, #8a3350 0%, #471a2c 55%, #170a10 100%)', pattern: 'radial-gradient(rgba(255,168,189,0.16) 1.4px, transparent 1.9px)', titleGradient: 'linear-gradient(90deg, #ffc7d6 0%, #fff0f4 50%, #ff9bac 100%)', motif: '🎀', pills: ['🎀 Limited Edition Drop', 'One perfect bow · once it\'s gone, it\'s gone', 'Mega Live 4 exclusive · while supplies last'], font: "'Quicksand', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Quicksand:wght@600;700&display=swap' },
    'stained-glass': { curated: true, accent: '#7bb3ff', accent2: '#232a5c', ink: '#08091a', tagline: 'Light through glass — never the same twice.', bg: 'radial-gradient(120% 90% at 50% 0%, #232a5c 0%, #131638 55%, #060714 100%)', pattern: 'repeating-linear-gradient(45deg, rgba(123,179,255,0.10) 0 1px, transparent 1px 26px), repeating-linear-gradient(-45deg, rgba(243,212,136,0.07) 0 1px, transparent 1px 26px)', titleGradient: 'linear-gradient(90deg, #7bb3ff 0%, #f3d488 35%, #ff9bac 65%, #8fd6a8 100%)', motif: '🪟', pills: ['🪟 Limited Edition Drop', 'One pane of light · once it\'s gone, it\'s gone', 'Mega Live 4 exclusive · while supplies last'], font: "'Cormorant Garamond', serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@700&display=swap' },
    'moonlight-space-exploration': { accent: '#8fe3e0', accent2: '#16233d', ink: '#040711', tagline: 'Made for the after-hours.', bg: 'radial-gradient(120% 90% at 50% 0%, #16233d 0%, #040711 55%, #000 100%)', font: "'Orbitron', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&display=swap' },
    'pumpkin-patch': { accent: '#ff8f3c', accent2: '#3a1a10', ink: '#0d0603', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #3a1a10 0%, #0d0603 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'glowie-big-bang': { accent: '#e3c77b', accent2: '#241c0d', ink: '#080604', tagline: 'Lights out. Glow up.', bg: 'radial-gradient(120% 90% at 50% 0%, #241c0d 0%, #080604 55%, #000 100%)', font: "'Orbitron', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Orbitron:wght@700;900&display=swap' },
    'paw-or-treat': { accent: '#4a71e0', accent2: '#7d4014', ink: '#0a0f1e', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #7d4014 0%, #0a0f1e 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'dark-fire': { accent: '#ff9548', accent2: '#3a1409', ink: '#0c0503', tagline: 'Darker. Colder. Limited.', bg: 'radial-gradient(120% 90% at 50% 0%, #3a1409 0%, #0c0503 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'fallout': { accent: '#62ff2a', accent2: '#153a10', ink: '#050d04', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #153a10 0%, #050d04 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'herbology-class': { accent: '#f2e43c', accent2: '#2a2606', ink: '#0a0901', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #2a2606 0%, #0a0901 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'deadly-pumpkin-heads': { accent: '#e56b2f', accent2: '#3a2554', ink: '#120a1c', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #3a2554 0%, #120a1c 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' },
    'sapphire-opal': { accent: '#c31701', accent2: '#00121b', ink: '#000508', tagline: 'Limited run. Unlimited cold.', bg: 'radial-gradient(120% 90% at 50% 0%, #00121b 0%, #000508 55%, #000 100%)', font: "'Archivo Black', sans-serif", fontUrl: 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap' }
  };
  /* ── DROP FAQ EXTRA (CRON-MANAGED) ────────────────────────
     Per-drop FAQ entries [question, answer] — appended to the global FAQ and
     improved over time by the weekly CRO review loop. */
  var DROP_FAQ_EXTRA = {
    'prime-week': [
      ['What is Coldest Prime Week?', 'Prime Week is our biggest cold-deal event of the season — 7 days only (June 23–30, 2026). We pulled a curated lineup of fan-favourite blue & cosmic colorways into one place and put the <strong>entire cart 10% off</strong> with code <strong>PRIMEWEEK</strong>. When the week ends, the deal ends.'],
      ['How do I get the Prime Week discount?', 'Add anything to your cart and enter code <strong>PRIMEWEEK</strong> at checkout for 10% off your entire order. It works storewide, not just on this collection — but this page is the curated edit of what to grab first. The code expires when Prime Week ends on June 30, 2026.'],
      ['How long does Prime Week last?', 'Seven days: it runs June 23 through June 30, 2026. Once the event closes, the PRIMEWEEK code stops working and these deals go back to normal — so claim your colorway before the week is out.'],
      ['Are these the same Coldest bottles, just on sale?', 'Yes — every bottle and tumbler here is the real Coldest Limitless drinkware, insanely engineered to stay cold up to 100+ hours* and backed by our warranty. Prime Week is simply your window to get them 10% off cart-wide with code PRIMEWEEK.']
    ],
    'art': [
      ['Who painted the masterpieces in this gallery?', 'Six of the most celebrated works in art history. <strong>The Great Wave off Kanagawa</strong> (c. 1831) is by the Japanese ukiyo-e master Katsushika Hokusai. <strong>Starry Night</strong> (1889), <strong>Garden at Arles</strong> (1888) and <strong>Bouquet of Sunflowers</strong> (1888–89) are by the Dutch Post-Impressionist Vincent van Gogh. <strong>Water Lilies</strong> (1890s–1920s) is by the French Impressionist Claude Monet, and <strong>Mont Sainte-Victoire</strong> (1880s–1900s) is by Paul Cézanne, the father of modern art. Every work is in the public domain — these are original Coldest interpretations, not licensed reproductions.'],
      ['Tell me the story of Vincent van Gogh.', 'Vincent van Gogh (1853–1890) was a Dutch Post-Impressionist painter who is now one of the most famous and influential figures in Western art — yet he sold almost nothing in his lifetime. Born in Groot-Zundert, the Netherlands, he worked as an art dealer, a teacher and a missionary before deciding, at 27, to become an artist. In roughly a decade he produced about 2,100 works, including around 860 oil paintings, most of them in the last two years of his life. In 1888 he moved to Arles in the south of France chasing its intense light and color, where he painted his sunflowers, his Garden at Arles, and dreamed of an artists\' colony. After the famous breakdown in which he severed part of his own ear, he admitted himself to an asylum at Saint-Rémy — and there, from his window, painted <strong>The Starry Night</strong> in June 1889. He struggled with mental illness and poverty throughout, and died in 1890 at age 37. His brother Theo, an art dealer, supported him his whole career; the hundreds of letters between them survive as one of the most moving records of an artist\'s mind ever written. Today his canvases sell for tens of millions and hang in the world\'s greatest museums.'],
      ['What makes The Starry Night so iconic?', 'Painted from the window of his asylum room at Saint-Rémy in 1889, The Starry Night turns a quiet night sky into something alive — swirling currents of blue, a blazing crescent moon and stars haloed in yellow above a sleeping village. Van Gogh painted it from memory and imagination rather than direct observation, which is part of why it feels so emotional rather than literal. It hangs at the Museum of Modern Art in New York and is one of the most recognized paintings on earth.'],
      ['Why is The Great Wave so famous?', 'The Great Wave off Kanagawa is a woodblock print from Hokusai\'s series "Thirty-Six Views of Mount Fuji," made around 1831 when the artist was in his seventies. A towering, claw-like wave threatens three boats while a tiny Mount Fuji sits calm in the distance. Its bold composition and "Prussian blue" pigment made it wildly popular in Japan and, later, a huge influence on European Impressionists. It is one of the most reproduced images in all of art.'],
      ['Are these official reproductions of the paintings?', 'No — and that\'s the point. The original works are all in the public domain (each artist died well over a century ago), so these are original Coldest interpretations inspired by the masterpieces, not licensed prints. Each is a limited, numbered run: once a piece sells through, it is retired from the gallery for good.']
    ],
    'glowie-meow': [{q:'Does Glowie Meow actually glow in the dark?',a:'Yes — the Glowie finish charges in daylight or under a lamp and glows softly once the lights go out. The glow fades over the night and recharges the next day; it never wears off the bottle.'}, {q:'Is the glow finish dishwasher safe?',a:'Hand wash the outside to protect the glow layer. The lid and straw are dishwasher safe, and the inside is the same 18/8 stainless steel as every Coldest bottle.'}],
    'pink-moonlight-floral': [{q:'Is Pink Moonlight Floral a repeat of an earlier floral drop?',a:'No. Every Coldest drop is a single run of its own artwork — Pink Moonlight Floral has never been released before and will not be reprinted once this run sells out.'}, {q:'Will the print fade or scratch?',a:'The artwork is cured into the powder-coat rather than printed on top, so it survives daily use, cupholders and backpacks. It is covered by the same lifetime warranty as the bottle.'}],
  };
  var theme = DROP_THEMES[handle] || {};
  /* Every drop page paints the body near-black from the first frame (the
     anti-flash rule in collection.drop.liquid), and the white cards behind
     the reviews and FAQ only exist in the --themed styling. A drop that has
     not been themed yet — new drops are themed Wednesday night — must still
     get a complete default look, or those sections render dark-on-dark. */
  if (!theme.bg) {
    theme = Object.assign({
      accent: '#7dd3fc',
      accent2: '#1e2a3a',
      ink: '#0b0d10',
      bg: 'radial-gradient(120% 90% at 50% 0%, #1e2a3a 0%, #10161f 55%, #05070b 100%)'
    }, theme);
  }
  /* No dots in the background (David, 2026-10-21). A per-drop pattern made
     only of radial-gradient dots is dropped here, so a theme entry (or
     ensure_art.py / ensure_halloween.py) that still carries one cannot bring
     them back. Line patterns (back-to-school, stained-glass) stay. */
  if (theme.pattern && !/linear-gradient/.test(theme.pattern)) {
    theme = Object.assign({}, theme, { pattern: '' });
  }

  function hexToRgba(hex, a) {
    var m = (hex || '').replace('#', '');
    if (m.length === 3) m = m[0] + m[0] + m[1] + m[1] + m[2] + m[2];
    var n = parseInt(m, 16);
    if (isNaN(n)) return 'rgba(56,189,248,' + a + ')';
    return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
  }
  if (theme.accent) {
    var themeStyle = document.createElement('style');
    /* doubled class: the base stylesheet is appended AFTER this style and
       redeclares --drop-accent at equal specificity, silently clobbering
       every drop's accent back to the default blue */
    themeStyle.textContent = '.drop-grid-wrap.drop-grid-wrap{--drop-accent:' + theme.accent +
      ';--drop-accent-2:' + (theme.accent2 || theme.accent) +
      ';--drop-accent-soft:' + hexToRgba(theme.accent, 0.28) +
      ';--drop-glow:' + hexToRgba(theme.accent, 0.32) +
      ';--drop-ink:' + (theme.ink || '#0b0d10') +
      (theme.bg ? ';--drop-bg:' + theme.bg : '') +
      (theme.font ? ';--drop-font:' + theme.font : '') +
      (theme.titleGradient ? ';--drop-title-grad:' + theme.titleGradient : '') +
      (theme.ribbon ? ';--drop-ribbon:' + theme.ribbon : '') +
      (theme.pattern ? ';--drop-pattern:' + theme.pattern : '') + ';}';
    document.head.appendChild(themeStyle);
  }
  /* Load the drop's display font — exactly one stylesheet, preconnected */
  if (theme.fontUrl) {
    ['https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(function(href) {
      var pc = document.createElement('link');
      pc.rel = 'preconnect'; pc.href = href; pc.crossOrigin = '';
      document.head.appendChild(pc);
    });
    var fl = document.createElement('link');
    fl.rel = 'stylesheet'; fl.href = theme.fontUrl;
    document.head.appendChild(fl);
  }

  /* Mark the body so our CSS hides the native .product-list grid on drop pages.
     This avoids the bug where Boost (or the theme's native product-list) renders
     above the drop-grid because no Boost selector matched. */
  document.documentElement.classList.add('drop-page-active');
  if (document.body) {
    document.body.classList.add('drop-page-active');
  } else {
    document.addEventListener('DOMContentLoaded', function() { document.body.classList.add('drop-page-active'); });
  }

  var COLORS = config.colors.map(function(c) { return c.toLowerCase(); });

  /* ── CAPTURE COLLECTION DESCRIPTION FROM DOM ─────────────
     The native theme renders <div class="collection-description"> with the
     full Shopify collection.description (used by Google + meta description).
     We hide it via CSS, but read its text first so we can re-surface it
     under the drop header. Run this synchronously now if the element
     exists, and again on DOMContentLoaded as a fallback. */
  function captureCollectionDescription() {
    if (config.__capturedDesc !== undefined && config.__capturedDesc !== null) return config.__capturedDesc;
    /* Try common locations: native page-header .rte, then .collection-description,
       then any .rte inside .page-header. */
    var selectors = [
      '.page-header .rte',
      '.collection-description',
      '.page-header .reading-width'
    ];
    var text = '';
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.textContent) {
        var t = el.textContent.trim();
        if (t.length > text.length) text = t;
      }
    }
    if (!text) return null;
    config.__capturedDesc = text;
    return text;
  }
  captureCollectionDescription();
  if (!config.__capturedDesc) {
    document.addEventListener('DOMContentLoaded', captureCollectionDescription);
  }

  /* ── HELPERS ────────────────────────────────────────────── */
  function normalizeColor(name) {
    return (name || '').toLowerCase().replace(/\s*ultra\s*$/i, '').trim();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function sizeSort(a, b) {
    var order = { '6.7oz': 0, '15oz': 1, '20oz': 2, '24oz': 3, '30oz': 4, '32oz': 5, '36oz': 6, '46oz': 7, '128oz': 8, 'gallon': 9 };
    var aKey = (a.size || '').toLowerCase();
    var bKey = (b.size || '').toLowerCase();
    var aVal = order[aKey] !== undefined ? order[aKey] : 99;
    var bVal = order[bKey] !== undefined ? order[bKey] : 99;
    return aVal - bVal;
  }

  /* ── HIDE BOOST GRID + SIDEBAR ─────────────────────────── */
  var style = document.createElement('style');
  style.textContent = [
    /* Hide Boost / theme product grid until we replace it (drop-grid renders our own) */
    '.boost-sd__filter-product-list { display: none !important; }',
    '.boost-sd__toolbar-container { display: none !important; }',
    /* Coldest theme uses native .product-list for the collection grid — hide it on drop pages.
       html.drop-page-active is used because <body> may not exist when the <style> tag is inserted.
       Also hide .filter-shade (full-screen mobile-filter dimmer overlay) which can get stuck visible.
       Also hide native .pagetitle (theme renders its own H1 collection title above our drop heading). */
    'html.drop-page-active .product-list, html.drop-page-active .filters-utility-bar, html.drop-page-active .utility-bar, html.drop-page-active .filter-shade, html.drop-page-active .pagetitle, html.drop-page-active .collection-description, html.drop-page-active .page-header .rte, html.drop-page-active .page-header, body.drop-page-active .product-list, body.drop-page-active .filters-utility-bar, body.drop-page-active .utility-bar, body.drop-page-active .filter-shade, body.drop-page-active .pagetitle, body.drop-page-active .collection-description, body.drop-page-active .page-header .rte, body.drop-page-active .page-header { display: none !important; }',
    /* The framework IS the drop page: hide every native template section (banner,
       button scroller, filters, native grid, shogun + below-grid blocks) so only
       one experience renders — no boring white stack above/below the themed page.
       Descendant selector on purpose: OS 2.0 templates can nest section wrappers. */
    'html.drop-page-active main .shopify-section, html.drop-page-active #MainContent .shopify-section { display: none !important; }',

    /* ── DROP GRID STYLES ──────────────────────────────────── */
    '.drop-grid-wrap { max-width: none; margin: 0 auto; padding: 0 48px 60px; }',
    '@media (max-width: 768px) { .drop-grid-wrap { padding: 0 10px 40px; } }',
    '@media (max-width: 480px) { .drop-grid-wrap { padding: 0 8px 32px; } }',
    '.drop-grid-header { text-align: center; padding: 40px 0 30px; }',
    '.drop-grid-header h1 { font-size: 48px; font-weight: 700; margin: 0 0 8px; text-transform: none; letter-spacing: normal; line-height: 1.1; }',
    '.drop-grid-header p { font-size: 16px; color: #666; margin: 0; }',
    '.drop-grid-header .drop-header-desc { font-size: 16px; color: #555; margin: 12px auto 0; max-width: 760px; line-height: 1.5; }',
    '@media (max-width: 768px) { .drop-grid-header { padding: 24px 8px 18px; } .drop-grid-header h1 { font-size: 36px; } .drop-grid-header .drop-header-desc { font-size: 14px; padding: 0 8px; } }',
    '@media (max-width: 480px) { .drop-grid-header h1 { font-size: 30px; } .drop-grid-header .drop-header-desc { font-size: 13px; } }',

    /* Color section */
    '.drop-color-section { margin-bottom: 48px; }',
    '.drop-color-title { font-size: 22px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin: 0 0 20px; padding-bottom: 12px; border-bottom: 2px solid #111; }',

    /* Grid */
    /* 5 up on desktop (David, 2026-10-14: "let's make our screen 5 items per
       row instead of 4 … apply this to all collections and collections moving
       forward in the framework"). Same ladder as the limitless lander so a
       shopper moving between the two never sees the count jump: 5 from 1280,
       4 from 1024, 3 from 769, 2 on phones. */
    '.drop-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px; }',
    '@media (max-width: 1279.98px) { .drop-grid { grid-template-columns: repeat(4, 1fr); } }',
    '@media (max-width: 1024px) { .drop-grid { grid-template-columns: repeat(3, 1fr); } }',
    '@media (max-width: 768px) { .drop-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }',
    '@media (max-width: 480px) { .drop-grid { gap: 6px; } }',

    /* Card */
    '.drop-card { background: #fff; border-radius: 8px; overflow: hidden; position: relative; transition: box-shadow 0.2s; }',
    '.drop-card:hover { box-shadow: 0 4px 20px rgba(0,0,0,0.1); }',
    '.drop-card-link { display: block; text-decoration: none; color: inherit; }',
    '.drop-card-img-wrap { position: relative; padding-bottom: 100%; background: #f5f5f5; overflow: hidden; }',
    '.drop-card-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s; }',
    '.drop-card:hover .drop-card-img { transform: scale(1.04); }',

    /* Badges */
    /* Top-left badge stack (container is positioned; badges flow in a column) */
    '.drop-card-badges { position: absolute; top: 10px; left: 10px; z-index: 2; display: flex; flex-direction: column; align-items: flex-start; gap: 5px; }',
    '.drop-card-badge { background: #111; color: #fff; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 4px 10px; border-radius: 3px; letter-spacing: 0.5px; }',
    '.drop-predrop-banner { display: inline-flex; align-items: center; gap: 9px; margin: 14px auto 0; padding: 10px 20px; border-radius: 999px; border: 1px solid var(--drop-accent-soft, rgba(255,255,255,0.28)); background: rgba(255,255,255,0.06); font-size: 12.5px; font-weight: 800; letter-spacing: 0.04em; color: #fff; }',
    '.drop-predrop-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--drop-accent, #38bdf8); box-shadow: 0 0 0 0 var(--drop-accent-soft, rgba(56,189,248,0.5)); animation: dropPulse 2s infinite; }',
    '@keyframes dropPulse { 0% { box-shadow: 0 0 0 0 var(--drop-accent-soft, rgba(56,189,248,0.5)); } 70% { box-shadow: 0 0 0 10px rgba(0,0,0,0); } 100% { box-shadow: 0 0 0 0 rgba(0,0,0,0); } }',
    '.drop-header-badge--soon { background: var(--drop-accent, #38bdf8) !important; color: var(--drop-ink, #0b0d10) !important; }',
    '.drop-card--soon { opacity: 1; }',
    '.drop-card--soon .drop-card-img { filter: none; }',
    '.drop-card--soon .drop-card-atc { background: var(--drop-accent, #38bdf8); color: var(--drop-ink, #0b0d10); }',
    '.drop-card-badge--soon { background: var(--drop-accent, #38bdf8); color: var(--drop-ink, #0b0d10); }',
    '.drop-card-badge--oos { background: #888; }',
    '.drop-card-badge--sale { background: #c0392b; }',
    '.drop-card-badge--lowstock { background: linear-gradient(135deg, #e11d48 0%, #b91c1c 100%); box-shadow: 0 1px 6px rgba(225,29,72,0.4); }',
    /* Glow-in-the-dark drops (config.glowBadge). Luminous green so it reads as
       the product's own property rather than a stock or price state. */
    '.drop-card-badge--glow { background: linear-gradient(135deg, #7dff4f 0%, #22c55e 100%); color: #06240f; box-shadow: 0 1px 8px rgba(125,255,79,0.55); }',
    '.drop-card-badge.drop-card-pw-flag { background: linear-gradient(135deg, #1d6bff 0%, #0c2c6e 100%); box-shadow: 0 1px 6px rgba(13,60,160,0.4); }',
    /* Mobile: smaller, tighter badges */
    '@media (max-width: 768px) { .drop-card-badges { top: 6px; left: 6px; gap: 4px; } .drop-card-badge { font-size: 9px; padding: 3px 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-badges { top: 5px; left: 5px; } .drop-card-badge { font-size: 8.5px; padding: 2px 5px; } }',

    /* Info */
    '.drop-card-info { padding: 12px 14px 6px; text-align: left; }',
    '.drop-card-title { font-size: 13px; font-weight: 600; margin: 0 0 2px; line-height: 1.3; text-align: left; }',
    '.drop-card-size { font-size: 12px; color: #888; margin: 0 0 6px; text-align: left; }',
    '.drop-card-price { font-size: 15px; font-weight: 700; margin: 0 0 4px; display: flex; align-items: center; gap: 6px; text-align: left; justify-content: flex-start; flex-wrap: wrap; }',
    /* Mobile: tighter card padding and smaller copy */
    '@media (max-width: 768px) { .drop-card-info { padding: 10px 8px 4px; } .drop-card-title { font-size: 12px; line-height: 1.25; } .drop-card-size { font-size: 11px; margin-bottom: 4px; } .drop-card-price { font-size: 13px; gap: 4px; } }',
    '@media (max-width: 480px) { .drop-card-info { padding: 8px 6px 4px; } .drop-card-title { font-size: 11.5px; } .drop-card-price { font-size: 12.5px; } }',
    /* Card review rating — server-rendered from #drop-reviews-data. Replaced the
       bare Okendo [data-oke-star-rating] div, which had no data source on this
       template and so painted Okendo's configured "0 Reviews" empty state. */
    '.drop-card-rating { display: flex; align-items: center; gap: 5px; margin: 0 0 4px; line-height: 1; text-align: left; }',
    '.drop-card-stars { letter-spacing: 1px; font-size: 13px; white-space: nowrap; color: #ddd; }',
    '.drop-card-star--on { color: #111; }',
    '.drop-card-rcount { font-size: 11.5px; font-weight: 600; color: #777; }',
    '@media (max-width: 480px) { .drop-card-rating { gap: 4px; } .drop-card-stars { font-size: 12px; letter-spacing: 0.5px; } .drop-card-rcount { font-size: 10.5px; } }',
    '.drop-card-price--compare { font-size: 13px; font-weight: 400; color: #999; text-decoration: line-through; }',
    '.drop-card-price--sale { color: #c0392b; }',
    '@media (max-width: 768px) { .drop-card-price--compare { font-size: 11px; } }',

    /* ATC */
    '.drop-card-atc { display: block; width: calc(100% - 28px); margin: 6px 14px 14px; padding: 10px 0; background: #111; color: #fff; border: none; border-radius: 5px; font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; cursor: pointer; text-align: center; transition: background 0.2s; }',
    /* Mobile: tighter ATC button + smaller text so 2-up grid breathes */
    '@media (max-width: 768px) { .drop-card-atc { width: calc(100% - 12px); margin: 4px 6px 8px; padding: 9px 0; font-size: 11px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-atc { width: calc(100% - 8px); margin: 4px 4px 6px; padding: 8px 0; font-size: 10.5px; } }',
    '.drop-card-atc:hover { background: #333; }',
    '.drop-card-atc--oos { background: #ccc; color: #666; cursor: default; }',
    '.drop-card-atc--oos:hover { background: #ccc; }',
    '.drop-card-atc--adding { background: #444; }',
    '.drop-card-atc--added { background: #27ae60; }',
    /* ── Quick-add bag overlay (bottom-right of image) ──────
       Mobile-first: persistent icon. Desktop: hover-reveal + expands to show
       "Add". The bag stays visible on click — it animates (pulse->green pop). */
    '.drop-card-bag { position: absolute; bottom: 10px; right: 10px; z-index: 3; height: 42px; min-width: 42px; border-radius: 999px; border: none; background: #111; color: #fff; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; padding: 0; overflow: hidden; white-space: nowrap; box-shadow: 0 3px 12px rgba(0,0,0,0.28); -webkit-tap-highlight-color: transparent; transition: min-width .2s ease, padding .2s ease, transform .16s ease, background .16s ease, opacity .16s ease; }',
    '.drop-card-bag .drop-card-bag-ic { display: block; flex: 0 0 auto; width: 19px; height: 19px; }',
    /* Force the outline icon — beats the theme globals "svg{fill:...!important}" (white block) and "svg{width:1em}" (mis-size) */
    '.drop-card-bag .drop-card-bag-ic, .drop-card-bag .drop-card-bag-ic path { fill: none !important; stroke: currentColor !important; }',
    '.drop-card-bag-label { font-size: 12px; font-weight: 800; letter-spacing: 0.6px; text-transform: uppercase; max-width: 0; opacity: 0; margin-left: 0; overflow: hidden; transition: max-width .2s ease, opacity .15s ease, margin-left .2s ease; }',
    '.drop-card-bag:active { transform: scale(0.92); }',
    /* Adding: gentle pulse, icon stays visible */
    '.drop-card-bag--adding { animation: dropbagpulse .55s ease-in-out infinite; }',
    '@keyframes dropbagpulse { 0%,100% { transform: scale(1); } 50% { transform: scale(0.86); } }',
    /* Added: satisfying green pop, icon stays visible */
    '.drop-card-bag--added { background: #27ae60 !important; animation: dropbagpop .45s ease; }',
    '@keyframes dropbagpop { 0% { transform: scale(1); } 35% { transform: scale(1.28); } 70% { transform: scale(0.96); } 100% { transform: scale(1); } }',
    /* Themed drop pages: bag picks up the drop accent */
    /* "Shop by Collections" rail: light by default (the snippet's own CSS),
       re-skinned here for the themed dark drop pages. */
    '.drop-grid-wrap .cldst-sbc { margin: 0 0 24px; }',
    '.drop-grid-wrap--themed .cldst-sbc__head { color: rgba(255,255,255,.55); }',
    '.drop-grid-wrap--themed .cldst-sbc__tile { color: #fff; }',
    '.drop-grid-wrap--themed .cldst-sbc__art { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.16); }',
    '.drop-grid-wrap--themed .cldst-sbc__tile:hover .cldst-sbc__art { border-color: #fff; }',
    '.drop-grid-wrap--themed .cldst-sbc__tile.is-current .cldst-sbc__art { border-color: #fff; box-shadow: 0 0 0 2px #fff inset; }',
    '.drop-grid-wrap--themed .cldst-sbc__arrow { background: rgba(255,255,255,.12); border-color: rgba(255,255,255,.34); color: #fff; }',
    '.drop-grid-wrap--themed .cldst-sbc__arrow:hover { background: #fff; border-color: #fff; color: #0b0d10; }',
    '.drop-grid-wrap--themed .drop-card-bag { background: var(--drop-accent, #111); color: #0b0d10; }',
    '.drop-grid-wrap--themed .drop-card-bag--added { color: #fff; }',
    /* Desktop: hidden until card hover; expands to show "Add" on bag hover */
    '@media (hover: hover) and (min-width: 769px) { .drop-card-bag { opacity: 0; transform: translateY(8px); } .drop-card:hover .drop-card-bag, .drop-card-bag:focus-visible { opacity: 1; transform: translateY(0); } .drop-card:hover .drop-card-bag:hover { background: #000; padding: 0 15px 0 13px; } .drop-card:hover .drop-card-bag:hover .drop-card-bag-label { max-width: 54px; opacity: 1; margin-left: 7px; } }',
    '.drop-grid-wrap--themed .drop-card:hover .drop-card-bag:hover { background: var(--drop-ink, #000); color: #fff; }',
    /* Mobile: persistent icon-only, slightly smaller */
    '@media (max-width: 768px) { .drop-card-bag { height: 38px; min-width: 38px; bottom: 8px; right: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3); } }',
    '@media (max-width: 480px) { .drop-card-bag { height: 35px; min-width: 35px; bottom: 7px; right: 7px; } .drop-card-bag .drop-card-bag-ic { width: 17px; height: 17px; } }',
    /* OOS cards never show the bag (greyed image already dims it) */
    '.drop-card--oos .drop-card-bag { display: none; }',
    '.drop-card--soon .drop-card-bag { display: none; }',
    /* ── Phones: full-width ADD TO BAG under the card (Request 177) ─────────
       On the 2-up phone grid the 35px bag on the photo was the only buy
       control. Available cards carry .drop-card-atc--m after the info; the
       card becomes a flex column so margin-top:auto lines the buttons up
       across each row. The bag is hidden there but stays in the DOM (the
       sticky buy bar and "Add all" read its data-variant-id). Tablet and
       desktop keep the hover bag. */
    '.drop-card-atc--m { display: none; }',
    '@media (max-width: 768px) {' +
      ' .drop-card:has(> .drop-card-atc--m) { display: flex; flex-direction: column; }' +
      ' .drop-card:has(> .drop-card-atc--m) .drop-card-bag { display: none !important; }' +
      ' .drop-card .drop-card-atc--m { display: flex; align-items: center; justify-content: center; gap: 7px; width: auto; min-height: 44px; margin: auto 0 6px; padding: 0 8px; background: #fff; color: #111; border: 2px solid #111; border-radius: 10px; font-size: 13px; font-weight: 800; letter-spacing: 0.06em; line-height: 1; white-space: nowrap; -webkit-tap-highlight-color: transparent; touch-action: manipulation; transition: background .15s ease, color .15s ease, border-color .15s ease, transform .12s ease, opacity .15s ease; }' +
      ' .drop-card .drop-card-atc--m::before { content: ""; flex: 0 0 auto; width: 17px; height: 17px; background: currentColor; -webkit-mask: ' + ATC_BAG_MASK + ' center / contain no-repeat; mask: ' + ATC_BAG_MASK + ' center / contain no-repeat; }' +
      /* touch keeps :hover after a tap — never let the base #333 hover paint under dark text */
      ' .drop-card .drop-card-atc--m:hover { background: #fff; }' +
      ' .drop-card .drop-card-atc--m:active { transform: scale(0.97); }' +
      ' .drop-card .drop-card-atc--m.drop-card-atc--adding { background: #fff; opacity: .55; }' +
      ' .drop-card .drop-card-atc--m.drop-card-atc--added { background: #27ae60; border-color: #27ae60; color: #fff; }' +
      ' .drop-card .drop-card-atc--m.drop-card-atc--added::before { -webkit-mask-image: ' + ATC_CHECK_MASK + '; mask-image: ' + ATC_CHECK_MASK + '; }' +
    ' }',
    '@media (max-width: 360px) { .drop-card .drop-card-atc--m { font-size: 12px; letter-spacing: 0.03em; gap: 5px; } }',

    /* Drop badge (top-right) */
    '.drop-card-drop-badge { position: absolute; top: 10px; right: 10px; padding: 4px 10px; border-radius: 3px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; z-index: 2; }',
    '.drop-card-drop-badge--sneak { background: rgba(255,255,255,0.9); color: #333; }',
    '.drop-card-drop-badge--new { background: #111; color: #fff; }',
    '.drop-card-drop-badge--limited { background: rgba(255,255,255,0.9); color: #555; }',
    /* Mobile: smaller drop badge so it doesn\'t collide with the SAVE badge on the left */
    '@media (max-width: 768px) { .drop-card-drop-badge { font-size: 8.5px; padding: 3px 6px; top: 6px; right: 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-drop-badge { font-size: 8px; padding: 2px 5px; top: 5px; right: 5px; } }',
    '.drop-card--oos { opacity: 0.65; }',
    '.drop-card--oos .drop-card-link { pointer-events: none; cursor: default; }',
    '.drop-card--oos .drop-card-img { filter: grayscale(20%); }',

    /* Pre-drop image reveal stages — Sun/Mon = silhouette, Tue/Wed = partial, Thu pre-9:45am = partial, Thu 9:45am ET = full */
    '.drop-card-img-wrap { position: relative; overflow: hidden; }',
    /* Silhouette: heavy darken via overlay scrim (works regardless of image bg color) */
    '.drop-card-img-wrap--reveal::before { content: ""; position: absolute; inset: 0; pointer-events: none; z-index: 1; }',
    '.drop-card-img-wrap--silhouette::before { background: rgba(0,0,0,0.92); }',
    /* Sneak Peek (partial): the image shows CLEAN — no filter, no blur, no scrim,
       no overlay label (the card's "Sneak Peek" corner badge carries the stage).
       Never apply image filters on sneak-peek days: FB traffic lands here and a
       filtered image reads as broken. Silhouette (Sunday sight-unseen) only. */
    '.drop-card-img-wrap--partial::before { background: none; }',
    '.drop-card-img--silhouette { filter: brightness(0.15) contrast(1.4) saturate(0); }',
    '.drop-card-img-wrap--reveal::after { content: attr(data-reveal-label); position: absolute; left: 0; right: 0; bottom: 16px; text-align: center; color: #fff; font-size: 12px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; pointer-events: none; text-shadow: 0 1px 3px rgba(0,0,0,0.8); z-index: 2; }',
    '.drop-card-img-wrap--partial::after { display: none; }',

    /* Limited Edition badge near title */
    '.drop-header-badge { display: inline-block; background: #111; color: #fff; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 4px 12px; border-radius: 3px; letter-spacing: 0.5px; margin-left: 12px; vertical-align: middle; position: relative; top: -4px; }',
    '@media (max-width: 768px) { .drop-header-badge { display: block; margin: 8px auto 0; }  }',

    /* Drop day reserve text under sold out button */
    '.drop-card-reserve { font-size: 11px; color: #c0392b; text-align: center; margin-top: 6px; font-weight: 600; }',

    /* Loading skeleton */
    '.drop-loading { text-align: center; padding: 60px 0; font-size: 14px; color: #999; }',

    /* Filter bar */
    '.drop-filters { display: flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin-bottom: 28px; }',
    '.drop-filter-btn { padding: 8px 18px; border: 1.5px solid #ccc; border-radius: 20px; background: #fff; color: #333; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s; }',
    '.drop-filter-btn:hover { border-color: #111; color: #111; }',
    '.drop-filter-btn--active { background: #111; color: #fff; border-color: #111; }',
    '.drop-filter-btn--active:hover { background: #333; border-color: #333; }',

    /* Coldest Difference banner */
    '.drop-difference { max-width: none; margin: 40px auto 0; padding: 0 48px; }',
    '@media (max-width: 768px) { .drop-difference { padding: 0 16px; } }',
    '.drop-difference-inner { display: flex; align-items: center; gap: 40px; background: rgba(239,177,199,1); border-radius: 12px; padding: 40px; }',
    '@media (max-width: 768px) { .drop-difference-inner { flex-direction: column; padding: 24px; gap: 24px; } }',
    '.drop-difference-media { flex: 1; min-width: 0; }',
    '.drop-difference-media video, .drop-difference-media img { width: 100%; border-radius: 8px; }',
    '.drop-difference-text { flex: 1; min-width: 0; }',
    '.drop-difference-text h2 { font-size: 28px; font-weight: 800; margin: 0 0 14px; text-transform: uppercase; letter-spacing: 0.5px; }',
    '.drop-difference-text p { font-size: 15px; line-height: 1.6; color: #333; margin: 0 0 18px; }',
    '.drop-difference-text ul { list-style: none; padding: 0; margin: 0; }',
    '.drop-difference-text ul li { font-size: 14px; font-weight: 600; margin-bottom: 6px; }',

    /* Bundle CTA — "Buy the Entire Bundle" */
    '.drop-bundle { max-width: 1100px; margin: 48px auto 0; padding: 28px 28px; background: linear-gradient(135deg, #0a0a0a 0%, #1f1f1f 100%); color: #fff; border-radius: 14px; box-shadow: 0 12px 40px rgba(0,0,0,0.18); border: 1px solid rgba(255,255,255,0.06); text-align: left; }',
    '@media (max-width: 768px) { .drop-bundle { margin: 32px 16px 0; padding: 22px 18px; } }',
    '.drop-bundle, .drop-bundle * { text-align: left; }',
    '.drop-bundle-inner { display: flex; flex-direction: column; gap: 18px; align-items: flex-start; }',
    '@media (min-width: 768px) { .drop-bundle-inner { flex-direction: row; align-items: center; justify-content: space-between; gap: 32px; } }',
    '.drop-bundle-copy { flex: 1 1 auto; min-width: 0; text-align: left; }',
    '.drop-bundle-eyebrow-row { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin: 0 0 12px; }',
    '.drop-bundle-eyebrow { display: inline-flex; align-items: center; font-size: 11px; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase; color: #fff; background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%); padding: 5px 11px; border-radius: 4px; text-align: left; }',
    '.drop-bundle-exclusive { display: inline-flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #0a0a0a; background: linear-gradient(135deg, #f5d76e 0%, #f6c948 50%, #d4a017 100%); padding: 5px 11px; border-radius: 4px; box-shadow: 0 0 0 1px rgba(255,255,255,0.15) inset, 0 2px 6px rgba(212,160,23,0.35); text-align: left; }',
    '.drop-bundle-exclusive::before { content: "\u2605"; font-size: 12px; line-height: 1; }',
    '.drop-bundle-gift { display: inline-flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #fff; background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); padding: 5px 11px; border-radius: 4px; box-shadow: 0 0 0 1px rgba(255,255,255,0.12) inset, 0 2px 6px rgba(22,163,74,0.35); text-align: left; }',
    '.drop-bundle-gift::before { content: "\ud83c\udf81"; font-size: 13px; line-height: 1; }',
    '.drop-bundle-title { font-size: 24px; font-weight: 900; margin: 0 0 8px; line-height: 1.15; letter-spacing: -0.015em; color: #fff; text-align: left; }',
    '@media (min-width: 768px) { .drop-bundle-title { font-size: 30px; } }',
    '.drop-bundle-title-shipping { display: inline-block; color: #4ade80; font-weight: 800; font-size: 0.85em; margin-left: 4px; white-space: nowrap; }',
    '.drop-bundle-sub { font-size: 14px; color: #d8d8d8; margin: 0; line-height: 1.5; text-align: left; max-width: 640px; }',
    '.drop-bundle-pricing { display: flex; align-items: baseline; gap: 12px; margin: 16px 0 0; flex-wrap: wrap; justify-content: flex-start; text-align: left; }',
    '.drop-bundle-price-sale { font-size: 34px; font-weight: 900; color: #fff; line-height: 1; }',
    '.drop-bundle-price-orig { font-size: 18px; font-weight: 500; color: #888; text-decoration: line-through; line-height: 1; }',
    '.drop-bundle-savings { display: inline-block; font-size: 12px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; background: #fff; color: #111; padding: 5px 11px; border-radius: 4px; line-height: 1.2; }',
    '.drop-bundle-cta { flex-shrink: 0; align-self: flex-start; }',
    '@media (min-width: 768px) { .drop-bundle-cta { align-self: center; } }',
    '.drop-bundle-btn { display: inline-flex; align-items: center; justify-content: center; gap: 10px; padding: 17px 30px; background: #fff; color: #111; font-size: 15px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; border: none; border-radius: 10px; cursor: pointer; transition: transform 0.15s, background 0.15s, box-shadow 0.15s; min-width: 240px; box-shadow: 0 4px 16px rgba(255,255,255,0.08); }',
    '.drop-bundle-btn:hover { background: #f5f5f5; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(255,255,255,0.12); }',
    /* !important: the theme pins button[disabled] to #999 / #fff !important (2.85:1).
       The picker's button sits disabled until 4 are ticked, so it must stay readable. */
    '.drop-bundle-btn:disabled { background: #3a3a3a !important; color: #d4d4d4 !important; cursor: not-allowed; transform: none; box-shadow: none; }',
    '.drop-bundle-btn-arrow { font-size: 18px; line-height: 1; transition: transform 0.2s; }',
    '.drop-bundle-btn:hover .drop-bundle-btn-arrow { transform: translateX(4px); }',
    '.drop-bundle-inner { display: grid; grid-template-columns: 1fr; gap: 20px; }',
    '@media (min-width: 900px) { .drop-bundle-inner { grid-template-columns: 1.35fr 1fr; gap: 34px; align-items: center; } }',
    '.drop-bundle-eyebrow { background: linear-gradient(90deg,#f5d76e,#e3b341); color: #1d1503; font-weight: 900; letter-spacing: .06em; }',
    '.drop-bundle-title { font-size: clamp(22px, 4vw, 34px); line-height: 1.12; margin: 10px 0 8px; }',
    /* Bundle picker (Request 262): one checkbox tile per in-stock size. The
       ticked state is #1d6bff, this site's selected colour (PDP swatch ring). */
    /* one row at every pick count: the progress copy wraps inside its own box, so
       the tiles never jump under a finger mid-pick */
    '.drop-bundle-pickhead { display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: nowrap; margin: 16px 0 6px; }',
    '.drop-bundle-progress { flex: 1 1 auto; min-width: 0; margin: 0; font-size: 13.5px; font-weight: 800; line-height: 1.35; color: #fff; }',
    '.drop-bundle-ok { color: #4ade80; }',
    /* text links built on <button>: the theme gives every button display:inline-block,
       a #c16452 hover/active fill and text-decoration:none !important */
    '.drop-bundle-all, .drop-bundle-more { flex: none; white-space: nowrap; background: none; border: 0; border-radius: 0; padding: 8px 0; min-height: 36px; font-family: inherit; font-size: 12.5px; font-weight: 800; color: rgba(255,255,255,.85); text-decoration: underline !important; text-underline-offset: 3px; cursor: pointer; }',
    '.drop-bundle-all:hover, .drop-bundle-all:active, .drop-bundle-more:hover, .drop-bundle-more:active { background: none; border-color: transparent; color: rgba(255,255,255,.85); text-decoration-thickness: 2px; }',
    '.drop-bundle-more { margin-top: 4px; }',
    '.drop-bundle-more[hidden], .drop-bundle-all[hidden], .drop-bundle-err[hidden] { display: none; }',
    '.drop-bundle-err { margin: 0; font-size: 12.5px; font-weight: 700; line-height: 1.4; color: #ffb4bc; }',
    '.drop-bundle-meter { display: flex; gap: 4px; max-width: 240px; margin: 0 0 14px; }',
    '.drop-bundle-meter i { flex: 1 1 0; height: 5px; border-radius: 999px; background: rgba(255,255,255,.18); transition: background .2s; }',
    '.drop-bundle-meter i.is-on { background: #1d6bff; }',
    '.drop-bundle-picks { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 10px; }',
    '@media (min-width: 560px) { .drop-bundle-picks { grid-template-columns: repeat(auto-fill, minmax(88px, 1fr)); } }',
    '.drop-bundle-picks:not(.is-open) .drop-bundle-pick.is-extra { display: none; }',
    '.drop-bundle-pick { position: relative; display: flex; flex-direction: column; align-items: center; min-width: 0; cursor: pointer; text-align: center; -webkit-tap-highlight-color: transparent; }',
    /* the invisible input covers the whole tile, so focus scrolling and screen-reader
       highlights follow the tile, not a 1px dot in its corner */
    '.drop-bundle-pick-input { position: absolute; inset: 0; z-index: 1; width: 100%; height: 100%; margin: 0; padding: 0; opacity: 0; -webkit-appearance: none; appearance: none; cursor: pointer; }',
    '.drop-bundle-pick.is-gone { cursor: default; }',
    '.drop-bundle-pick.is-gone .drop-bundle-pick-art { filter: grayscale(1); }',
    '.drop-bundle-pick-art { position: relative; display: block; width: 100%; aspect-ratio: 1 / 1; border-radius: 12px; overflow: hidden; background: rgba(255,255,255,.06); box-shadow: 0 0 0 1.5px rgba(255,255,255,.16); transition: box-shadow .15s, transform .12s; }',
    '.drop-bundle-pick:active .drop-bundle-pick-art { transform: scale(.97); }',
    '.drop-bundle-pick-art img { display: block; width: 100%; height: 100%; object-fit: cover; }',
    '.drop-bundle-pick-check { position: absolute; top: 6px; right: 6px; width: 22px; height: 22px; border-radius: 50%; background: rgba(255,255,255,.92); box-shadow: inset 0 0 0 1.5px rgba(45,54,64,.45), 0 1px 3px rgba(0,0,0,.25); }',
    '.drop-bundle-pick-input:checked ~ .drop-bundle-pick-art { box-shadow: 0 0 0 2.5px #1d6bff; }',
    '.drop-bundle-pick-input:checked ~ .drop-bundle-pick-art .drop-bundle-pick-check { background: #1d6bff; box-shadow: 0 0 0 2px #fff, 0 1px 3px rgba(0,0,0,.25); }',
    '.drop-bundle-pick-input:checked ~ .drop-bundle-pick-art .drop-bundle-pick-check::after { content: ""; position: absolute; left: 8px; top: 4px; width: 5px; height: 10px; border: solid #fff; border-width: 0 2.5px 2.5px 0; transform: rotate(45deg); }',
    '.drop-bundle-pick-input:focus-visible ~ .drop-bundle-pick-art { outline: 2px solid #1d6bff; outline-offset: 3px; }',
    '.drop-bundle-pick-input:disabled ~ .drop-bundle-pick-art { opacity: .6; }',
    '.drop-bundle-pick-size { display: block; margin-top: 6px; font-size: 12px; font-weight: 800; letter-spacing: .02em; line-height: 1.2; color: #fff; text-align: center; overflow-wrap: anywhere; }',
    '.drop-bundle-pick-price { display: block; margin-top: 1px; font-size: 11.5px; color: rgba(255,255,255,.72); text-align: center; }',
    '.drop-bundle-cta { min-width: 0; }',
    '.drop-bundle-trust .drop-bundle-trust-wrap { white-space: normal; }',
    '.drop-bundle-price-from { align-self: center; font-size: 13px; font-weight: 700; color: rgba(255,255,255,.72); }',
    '.drop-bundle-savings--hint { background: transparent; color: #fff; box-shadow: inset 0 0 0 1.5px rgba(255,255,255,.5); }',
    '.drop-bundle-cta { display: flex; flex-direction: column; align-items: stretch; gap: 10px; }',
    '.drop-bundle-pricing { display: flex; align-items: baseline; flex-wrap: wrap; gap: 10px; }',
    '.drop-bundle-unit { margin: -2px 0 2px; font-size: 12.5px; color: rgba(255,255,255,.72); }',
    '.drop-bundle-unit s { opacity: .6; }',
    '.drop-bundle-unit b { color: var(--drop-accent, #7ee0a8); font-weight: 800; }',
    '.drop-bundle-btn { width: 100%; min-width: 0; }',
    '.drop-bundle-trust { display: flex; flex-wrap: wrap; gap: 4px 14px; margin: 2px 0 0; font-size: 11.5px; color: rgba(255,255,255,.66); }',
    '.drop-bundle-trust span { white-space: nowrap; }',
    '.drop-ctl-head { display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap; }',
    '.drop-ctl-addall { border: 1px solid var(--drop-accent-soft, rgba(255,255,255,.35)); background: rgba(255,255,255,.06); color: #fff; font-family: inherit; font-size: 12px; font-weight: 800; letter-spacing: .06em; padding: 10px 16px; border-radius: 999px; cursor: pointer; transition: background .15s, transform .12s; }',
    '.drop-ctl-addall:hover { background: var(--drop-accent, #38bdf8); color: var(--drop-ink, #0b0d10); }',
    '.drop-ctl-addall:active { transform: scale(.97); }',
    '.drop-ctl-addall:disabled { opacity: .7; cursor: default; }',
    /* ── Complete the Look rows (Request 198) ───────────────────────────────
       Third CSS scope for the shared accessory row (the drawer's is `#csc`,
       the PDP's is `.cpe`; the snippet itself ships no CSS, each caller owns
       its own). Deliberately NOT .drop-card: `padding-bottom: 100%` on
       .drop-card-img-wrap (:1913) is what made one accessory 428px tall on
       desktop and 312px on a phone. Measured: 4 rows = 478px at 390 and 254px
       at 1440, against 640/488 for three tiles.
       [hidden] is restated because the theme's global
       `.btn, button, … { display: inline-block }` is an AUTHOR rule and so
       beats the UA sheet's `[hidden] { display: none }` — that is why "Add
       all" painted as a dead 77x34 button on 64 of 75 pages. The PDP snippet
       defends itself the same way at snippets/coldest-pdp-essentials.liquid:118. */
    '.dctl { margin: 8px 0 48px; }',
    '.dctl .drop-color-title { margin: 0; padding: 0; border-bottom: 0; }',
    '.dctl .drop-ctl-head { margin: 0 0 14px; padding-bottom: 12px; border-bottom: 2px solid rgba(17,17,17,.14); }',
    '.dctl .drop-ctl-addall[hidden] { display: none; }',
    '.dctl__list { display: grid; gap: 8px; margin: 0; padding: 0; list-style: none; }',
    '@media (min-width: 700px) { .dctl__list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; } }',
    '.dctl .csc-acc { display: grid; grid-template-columns: 48px minmax(0, 1fr) auto; grid-template-areas: "media title price" "media select add"; align-items: center; column-gap: 10px; row-gap: 6px; margin: 0; padding: 10px 12px; border: 1px solid #e8e8e8; border-radius: 12px; background: #fff; list-style: none; }',
    '.dctl .csc-acc::before, .dctl .csc-acc::after { content: none; }',
    '.dctl .csc-acc__info { display: contents; }',
    '.dctl .csc-acc__media { grid-area: media; align-self: start; display: block; width: 48px; height: 48px; border-radius: 8px; background: #f5f5f5; overflow: hidden; }',
    '.dctl .csc-acc__media img { display: block; width: 100%; height: 100%; object-fit: contain; }',
    '.dctl .csc-acc__title { grid-area: title; min-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-size: 14px; font-weight: 700; line-height: 1.3; color: #111; text-decoration: none; }',
    '.dctl .csc-acc__price { grid-area: price; justify-self: end; margin: 0; font-size: 13px; font-weight: 800; white-space: nowrap; color: #111; }',
    '.dctl .csc-acc__price s { margin-left: 5px; font-size: 12px; font-weight: 500; color: #8d8a8a; }',
    '.dctl .csc-acc__fit { grid-area: title; justify-self: end; display: inline-block; margin: 0; padding: 1px 6px; border-radius: 999px; background: #eef6ff; color: #1d4f91; font-size: 10.5px; font-weight: 700; letter-spacing: .02em; white-space: nowrap; }',
    '.dctl .csc-acc__fit[hidden] { display: none; }',
    '.dctl .csc-acc:has(.csc-acc__fit:not([hidden])) .csc-acc__title { padding-right: 118px; }',
    '.dctl .csc-acc__select { grid-area: select; display: block; width: 100%; max-width: 170px; height: 34px; margin: 0; padding: 0 24px 0 9px; border: 1px solid #d6d6d6; border-radius: 8px; background-color: #fff; color: #111; font-size: 12.5px; line-height: 32px; }',
    /* 44px and labelled at EVERY width. Desktop had no visible add control at
       all before (the wide button was display:none above 768px, the bag was
       opacity:0 until hover). */
    '.dctl .csc-acc__add { grid-area: add; display: inline-flex; align-items: center; justify-content: center; min-width: 92px; min-height: 44px; margin: 0; padding: 0 14px; border: 2px solid #111; border-radius: 10px; background: #fff; color: #111; font-size: 13px; font-weight: 800; letter-spacing: .02em; line-height: 1; white-space: nowrap; text-transform: none; cursor: pointer; touch-action: manipulation; transition: background .15s ease, color .15s ease, border-color .15s ease; }',
    '.dctl .csc-acc__add:hover { background: #111; color: #fff; }',
    '.dctl .csc-acc__add.is-adding { opacity: .55; }',
    '.dctl .csc-acc__add.is-added, .dctl .csc-acc__add.is-added:hover { background: #27ae60; border-color: #27ae60; color: #fff; }',
    '@media (hover: none) { .dctl .csc-acc__add:not(.is-added):hover { background: #fff; color: #111; } }',
    '.dctl__err { margin: 10px 2px 0; font-size: 13px; color: #b00020; }',
    '.dctl__err[hidden] { display: none; }',
    '@media (max-width: 560px) { .dctl .csc-acc { column-gap: 9px; padding: 9px 10px; } .dctl .csc-acc__title { font-size: 13.5px; } .dctl .csc-acc:has(.csc-acc__fit:not([hidden])) .csc-acc__title { padding-right: 108px; } .dctl .csc-acc__select { max-width: none; } .dctl .csc-acc__add { min-width: 84px; padding: 0 10px; } }',
    '@media (max-width: 360px) { .dctl .csc-acc { column-gap: 7px; padding: 8px; } .dctl .csc-acc__add { min-width: 74px; padding: 0 8px; } }',
    /* DAVID'S CALL (Request 198): CLAUDE.md asks for a full-width >=44px phone
       buy button UNDER the title/price. Measured, that costs the whole
       compaction: 632px at 390px vs 478px with the button on the row (and 640px
       today). The PDP's "Frequently added", which this block now shares its data
       and markup with, puts a 76x44 button on the row for the same reason.
       To take the letter of the standard instead, uncomment this:
    '@media (max-width: 560px) { .dctl .csc-acc { grid-template-areas: "media title price" "media select select" "add add add"; } .dctl .csc-acc__add { width: 100%; min-width: 0; } .dctl .csc-acc:not(:has(.csc-acc__select)) { grid-template-areas: "media title price" "add add add"; } }',
    */
    /* Themed drop pages (theme.bg set): the same geometry, dark skin. */
    '.drop-grid-wrap--themed .dctl .drop-ctl-head { border-bottom-color: rgba(255,255,255,.14); }',
    '.drop-grid-wrap--themed .dctl .csc-acc { border-color: rgba(255,255,255,.12); background: rgba(255,255,255,.045); }',
    '.drop-grid-wrap--themed .dctl .csc-acc__media { background: rgba(255,255,255,.07); }',
    '.drop-grid-wrap--themed .dctl .csc-acc__title, .drop-grid-wrap--themed .dctl .csc-acc__price { color: #fff; }',
    '.drop-grid-wrap--themed .dctl .csc-acc__price s { color: rgba(255,255,255,.5); }',
    '.drop-grid-wrap--themed .dctl .csc-acc__fit { background: rgba(255,255,255,.14); color: #e9f6ff; }',
    '.drop-grid-wrap--themed .dctl .csc-acc__select { border-color: rgba(255,255,255,.26); background-color: rgba(0,0,0,.35); color: #fff; }',
    '.drop-grid-wrap--themed .dctl .csc-acc__add { border-color: #fff; background: transparent; color: #fff; }',
    '.drop-grid-wrap--themed .dctl .csc-acc__add:hover { background: var(--drop-accent, #fff); border-color: var(--drop-accent, #fff); color: var(--drop-ink, #0b0d10); }',
    '@media (hover: none) { .drop-grid-wrap--themed .dctl .csc-acc__add:not(.is-added):hover { background: transparent; color: #fff; border-color: #fff; } }',
    '.drop-grid-wrap--themed .dctl__err { color: #ff9ba4; }',
    '.drop-bundle-fineprint { font-size: 11px; color: #999; margin: 14px 0 0; line-height: 1.4; text-align: left; }',
    '\n',
    /* FAQ */
    '.drop-faq { max-width: 900px; margin: 48px auto 0; padding: 0 20px 40px; }',
    '.drop-faq h2 { font-size: 24px; font-weight: 700; text-align: center; margin: 0 0 24px; }',
    '.drop-faq details { border-bottom: 1px solid #e0e0e0; }',
    '.drop-faq summary { padding: 16px 0; font-size: 15px; font-weight: 600; cursor: pointer; list-style: none; display: flex; justify-content: space-between; align-items: center; }',
    '.drop-faq summary::-webkit-details-marker { display: none; }',
    '.drop-faq summary::after { content: "+"; font-size: 20px; font-weight: 300; color: #666; transition: transform 0.2s; }',
    '.drop-faq details[open] summary::after { content: "−"; }',
    '.drop-faq details p { padding: 0 0 16px; font-size: 14px; line-height: 1.7; color: #555; margin: 0; }',
    /* Sold-out experience */
    '.drop-soldout { text-align: center; padding: 40px 0 20px; }',
    '.drop-soldout h1 { font-size: 48px; font-weight: 700; margin: 0 0 6px; line-height: 1.1; }',
    '.drop-soldout-vault { display: inline-block; margin: 14px auto 0; padding: 11px 20px; border: 1px solid rgba(0,0,0,.18); border-radius: 999px; font-size: 12.5px; font-weight: 800; letter-spacing: .02em; color: #111; text-decoration: none; transition: background .15s, border-color .15s, transform .15s; }',
    '.drop-soldout-vault:hover { background: #111; color: #fff; border-color: #111; transform: translateY(-1px); }',
    '.drop-soldout-tag { display: inline-block; background: #c0392b; color: #fff; font-size: 14px; font-weight: 700; text-transform: uppercase; padding: 6px 16px; border-radius: 4px; letter-spacing: 1px; margin-bottom: 16px; }',
    '.drop-soldout p { font-size: 16px; color: #666; margin: 0 0 24px; }',
    '.drop-soldout-form { display: flex; justify-content: center; gap: 8px; max-width: 440px; margin: 0 auto 12px; }',
    '@media (max-width: 480px) { .drop-soldout-form { flex-direction: column; } }',
    '.drop-soldout-input { flex: 1; padding: 12px 16px; border: 1.5px solid #ccc; border-radius: 6px; font-size: 14px; outline: none; }',
    '.drop-soldout-input:focus { border-color: #111; }',
    '.drop-soldout-btn { padding: 12px 28px; background: #111; color: #fff; border: none; border-radius: 6px; font-size: 14px; font-weight: 700; cursor: pointer; white-space: nowrap; }',
    '.drop-soldout-btn:hover { background: #333; }',
    '.drop-soldout-btn--done { background: #27ae60; }',
    '.drop-soldout-msg { font-size: 13px; color: #27ae60; margin: 0; }',
    '.drop-soldout-divider { max-width: 800px; margin: 32px auto 0; padding-top: 32px; border-top: 1px solid #e0e0e0; }',
    '.drop-soldout-divider h2 { font-size: 24px; font-weight: 700; text-align: center; margin: 0 0 8px; }',
    '.drop-soldout-divider p { font-size: 15px; color: #666; text-align: center; margin: 0 0 28px; }',
    '.drop-soldout--capture { max-width: 560px; margin: 8px auto 0; padding: 28px 20px 8px; border-top: 1px solid rgba(0,0,0,0.08); }',
    '.drop-grid-wrap--themed .drop-soldout--capture { border-top-color: rgba(255,255,255,0.15); }',
    /* a.* only: these are the "Shop Now" links. An ID rule here would also out-rank the phone
       button's .drop-card-atc--m show/hide (renderCard cards live in #drop-alt-collections). */
    '#drop-bestsellers a.drop-card-atc, #drop-alt-collections a.drop-card-atc { text-decoration: none; display: block; }',
    '.drop-alt-section { margin-bottom: 36px; }',
    '.drop-alt-section h3 { font-size: 18px; font-weight: 700; margin: 0 0 16px; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid #111; padding-bottom: 10px; }',

    /* ── DROP FRAMEWORK 2.0 — per-drop theming, FOMO, size filters, reviews ── */
    /* Theme variables: overridden per drop by DROP_THEMES (set from the revealed
       drop image). Defaults keep the moody Coldest ink + ice-blue glow. */
    '.drop-grid-wrap { --drop-accent: #38bdf8; --drop-accent-2: #0e7490; --drop-accent-soft: rgba(56,189,248,0.26); --drop-ink: #0b0d10; }',
    /* Moody hero band behind the drop header */
    '.drop-grid-header { position: relative; border-radius: 18px; margin: 20px 0 28px; padding: 54px 24px 46px; background: radial-gradient(130% 170% at 50% -10%, var(--drop-accent-2) -55%, var(--drop-ink) 58%, #000 100%); color: #fff; overflow: hidden; box-shadow: 0 18px 50px rgba(0,0,0,0.25); }',
    '.drop-grid-header::before { content: ""; position: absolute; inset: 0; background: radial-gradient(55% 75% at 82% 8%, var(--drop-accent-soft) 0%, transparent 70%), radial-gradient(40% 60% at 12% 92%, var(--drop-accent-soft) 0%, transparent 75%); pointer-events: none; }',
    '.drop-grid-header > * { position: relative; z-index: 1; }',
    '.drop-grid-header h1 { color: #fff; text-shadow: 0 2px 18px rgba(0,0,0,0.45); }',
    '.drop-grid-header p, .drop-grid-header .drop-header-desc { color: rgba(255,255,255,0.82); }',
    '.drop-header-badge { background: var(--drop-accent); color: #0b0d10; box-shadow: 0 0 18px var(--drop-accent-soft); }',
    '.drop-header-tagline { font-size: 13px; font-weight: 800; letter-spacing: 2.5px; text-transform: uppercase; color: var(--drop-accent); margin: 0 0 10px; }',
    '@media (max-width: 768px) { .drop-grid-header { padding: 34px 14px 30px; margin: 10px 0 18px; border-radius: 14px; } .drop-header-tagline { font-size: 10.5px; letter-spacing: 1.8px; } }',
    /* FOMO strip — exclusivity pills inside the hero */
    '.drop-fomo { display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 10px 14px; margin: 18px auto 0; }',
    '.drop-fomo-pill { display: inline-flex; align-items: center; gap: 7px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #fff; background: rgba(255,255,255,0.10); border: 1px solid rgba(255,255,255,0.18); padding: 7px 14px; border-radius: 999px; }',
    '.drop-fomo-pill--hot { background: var(--drop-accent); color: #0b0d10; border-color: transparent; box-shadow: 0 0 22px var(--drop-accent-soft); }',
    '@media (max-width: 768px) { .drop-fomo { gap: 7px; } .drop-fomo-pill { font-size: 9.5px; padding: 6px 10px; letter-spacing: 0.8px; } }',
    /* Scarcity meter — real availability data only */
    '.drop-scarcity { max-width: 560px; margin: 20px auto 0; }',
    '.drop-scarcity-label { display: flex; justify-content: space-between; gap: 12px; font-size: 11px; font-weight: 700; letter-spacing: 0.8px; text-transform: uppercase; color: rgba(255,255,255,0.85); margin-bottom: 7px; }',
    '.drop-scarcity-bar { height: 8px; border-radius: 999px; background: rgba(255,255,255,0.15); overflow: hidden; }',
    '.drop-scarcity-fill { height: 100%; border-radius: 999px; background: linear-gradient(90deg, var(--drop-accent), #e74c3c); box-shadow: 0 0 14px var(--drop-accent-soft); transition: width 1s ease; }',
    '.drop-scarcity--low .drop-scarcity-label { color: #ff8a8a; }',
    '.drop-scarcity--low .drop-scarcity-fill { background: linear-gradient(90deg, #f97316, #e11d48); box-shadow: 0 0 16px rgba(225,29,72,0.45); }',
    /* Quick size filter chips */
    '.drop-size-filters { margin: 0 0 26px; }',
    '.drop-size-filters .drop-filter-btn--active { background: var(--drop-ink); border-color: var(--drop-ink); color: #fff; }',
    /* Drop (colorway) filter chips + sort control — aggregated collections */
    '.drop-color-filters { margin: 0 0 12px; }',
    '.drop-controls { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 14px; margin: 0 0 22px; }',
    '.drop-controls-hint { font-size: 12.5px; font-weight: 600; color: #777; }',
    '.drop-sort-wrap { display: inline-flex; align-items: center; gap: 8px; margin-left: auto; }',
    '.drop-sort-label { font-size: 12px; font-weight: 700; letter-spacing: 0.6px; text-transform: uppercase; color: #555; }',
    '.drop-sort { padding: 8px 16px; border: 1.5px solid #ccc; border-radius: 20px; background: #fff; color: #333; font-size: 13px; font-weight: 600; cursor: pointer; }',
    '.drop-sort:hover { border-color: #111; color: #111; }',
    '@media (max-width: 768px) { .drop-sort-wrap { margin-left: 0; } .drop-controls { gap: 8px; } }',
    /* Reviews / social proof */
    '.drop-reviews { max-width: 1100px; margin: 48px auto 0; padding: 0 20px; }',
    '.drop-reviews h2 { font-size: 24px; font-weight: 800; text-align: center; margin: 0 0 6px; }',
    '.drop-reviews-sub { text-align: center; font-size: 14px; color: #666; margin: 0 0 18px; }',
    /* ── FULL-PAGE THEMED MODE (drop-grid-wrap--themed, when theme.bg is set) ──
       The whole drop experience sits on the drop\'s own background with its own
       display font — cards float as bright product tiles on the moody canvas. */
    '.drop-grid-wrap--themed { background: var(--drop-bg, var(--drop-ink)); padding-top: 12px; color: #fff; position: relative; }',
    /* ── SOFT WALLPAPER ─────────────────────────────────────────────────
       Replaced the two-tier drafting grid (David, 2026-10-21: "the grid kind
       of makes it feel rough and tough ... think kind of like Owala: softer
       colors, softer everything"). Three big blurred glows — the drop's own
       accent top-left, a blush pink top-right, a lavender haze mid-page.
       No dots (David, 2026-10-21: "not sure about the dots in the background
       ... the gradients are nice"). The accent glow is auto-derived from
       theme.accent (--drop-glow), so future drops inherit it with zero
       config. Masked to fade downward so it never competes with the art. */
    '.drop-grid-wrap--themed::before { content: ""; position: absolute; inset: 0; pointer-events: none; z-index: 0;',
    '  background-image: radial-gradient(62% 560px at 10% 0%, var(--drop-glow, rgba(255,182,213,0.22)) 0%, transparent 72%),',
    '    radial-gradient(55% 520px at 92% 4%, rgba(255,184,222,0.24) 0%, transparent 72%),',
    '    radial-gradient(75% 700px at 50% 55%, rgba(206,186,255,0.14) 0%, transparent 70%);',
    '  background-size: 100% 100%, 100% 100%, 100% 100%;',
    '  -webkit-mask-image: linear-gradient(180deg, #000 0%, rgba(0,0,0,0.8) 45%, rgba(0,0,0,0.45) 100%);',
    '  mask-image: linear-gradient(180deg, #000 0%, rgba(0,0,0,0.8) 45%, rgba(0,0,0,0.45) 100%); }',
    /* keep every themed child above the wallpaper */
    '.drop-grid-wrap--themed > * { position: relative; z-index: 1; }',
    '.drop-grid-wrap--themed .drop-loading { color: rgba(255,255,255,0.7); }',
    '.drop-grid-wrap--themed .drop-grid-header { background: transparent; box-shadow: none; }',
    '.drop-grid-wrap--themed .drop-grid-header h1, .drop-grid-wrap--themed .drop-color-title, .drop-grid-wrap--themed .drop-bundle-title, .drop-grid-wrap--themed .drop-soldout h1, .drop-grid-wrap--themed .drop-reviews h2, .drop-grid-wrap--themed .drop-faq h2 { font-family: var(--drop-font, inherit); }',
    '.drop-grid-wrap--themed .drop-color-title { color: #fff; border-color: var(--drop-accent); }',
    '.drop-grid-wrap--themed .drop-size-filters .drop-filter-btn { background: rgba(255,255,255,0.07); color: #fff; border-color: rgba(255,255,255,0.25); }',
    '.drop-grid-wrap--themed .drop-size-filters .drop-filter-btn:hover { border-color: var(--drop-accent); color: #fff; }',
    '.drop-grid-wrap--themed .drop-size-filters .drop-filter-btn--active { background: var(--drop-accent); color: #0b0d10; border-color: transparent; }',
    '.drop-grid-wrap--themed .drop-controls-hint { color: rgba(255,255,255,0.72); }',
    '.drop-grid-wrap--themed .drop-sort-label { color: rgba(255,255,255,0.78); }',
    '.drop-grid-wrap--themed .drop-sort { background: rgba(255,255,255,0.07); color: #fff; border-color: rgba(255,255,255,0.28); }',
    '.drop-grid-wrap--themed .drop-sort option { color: #111; }',
    '.drop-grid-wrap--themed .drop-card { box-shadow: 0 10px 30px -14px rgba(0,0,0,0.45); }',
    /* CONTRAST GUARANTEES — the themed wrapper is white-on-dark. The FAQ and
       reviews are still light panels, so they keep their pinned dark text.
       The CARD no longer is (David, 2026-10-15: "fix the white background to
       kind of blend a little better. It looks a little awkward").

       It was the only white slab on the page: the filter chips, the sort
       select, the Complete-the-Look rows and the Shop by Collections rail all
       already sit on rgba(255,255,255,.045-.07), so the card read as a
       cut-out pasted over the theme — and the packshots are black-background
       renders, which made a hard white seam straight across the bottom of
       every photo. On the same translucent surface the art now runs into the
       panel instead of stopping dead at it.

       EVERY pinned dark colour below had to flip with the panel. That is the
       whole risk of this change: #111 title on a #111-ish card is invisible,
       and nothing in CI would catch it. The list is the complete set of
       colours declared anywhere inside .drop-card. */
    '.drop-grid-wrap--themed .drop-card { background: rgba(255,255,255,0.055); color: #fff; border: 1px solid rgba(255,255,255,0.13); border-radius: 22px; }',
    '.drop-grid-wrap--themed .drop-card:hover { border-color: rgba(255,255,255,0.22); box-shadow: 0 14px 36px -12px var(--drop-accent-soft, rgba(0,0,0,0.45)); }',
    /* SOFT SHAPES — pill buttons and badges, rounder panels (same Owala ask) */
    '.drop-grid-wrap--themed .drop-card-atc, .drop-grid-wrap--themed .drop-card .drop-card-atc--m, .drop-grid-wrap--themed .drop-card-badge, .drop-grid-wrap--themed .drop-card-drop-badge, .drop-grid-wrap--themed .drop-header-badge, .drop-grid-wrap--themed .drop-soldout-btn, .drop-grid-wrap--themed .drop-soldout-input { border-radius: 999px; }',
    '@media (max-width: 768px) { .drop-grid-wrap--themed .drop-card { border-radius: 18px; } }',
    /* the lazy-load placeholder was #f5f5f5 — a white flash per card on a dark page */
    '.drop-grid-wrap--themed .drop-card-img-wrap { background: rgba(255,255,255,0.04); }',
    '.drop-grid-wrap--themed .drop-card-title, .drop-grid-wrap--themed .drop-card-price { color: #fff; }',
    '.drop-grid-wrap--themed .drop-card-size { color: rgba(255,255,255,0.55); }',
    '.drop-grid-wrap--themed .drop-card-price--compare, .drop-grid-wrap--themed .drop-card-price--msrp, .drop-grid-wrap--themed .drop-card-msrp-label { color: rgba(255,255,255,0.56); }',
    /* #c0392b is ~2.1:1 on this background — a light rose keeps the "this is the
       sale price" signal and actually reads. The red SAVE % badge still sits on
       the art and carries the discount on its own. */
    '.drop-grid-wrap--themed .drop-card-price--sale { color: #ff8a93; }',
    '.drop-grid-wrap--themed .drop-card-reserve { color: #ff9ba4; }',
    '.drop-grid-wrap--themed .drop-card-price--pw, .drop-grid-wrap--themed .drop-card-prime-note { color: #7fc4ff; }',
    /* Filled stars take the drop accent — it is already used as a BACKGROUND
       with dark ink elsewhere on this page, so it is a light colour by
       construction and safe as text on the dark panel. This is the one place
       the card picks up the drop's own palette. */
    '.drop-grid-wrap--themed .drop-card-stars { color: rgba(255,255,255,0.20); }',
    '.drop-grid-wrap--themed .drop-card-star--on { color: var(--drop-accent, #fff); }',
    '.drop-grid-wrap--themed .drop-card-rcount { color: rgba(255,255,255,0.52); }',
    /* The buy button takes the DROP'S OWN ACCENT. Left white it just moved the
       white slab from the panel to the button — at 2-up on a phone it is the
       largest block of chrome on the card. The accent is already used as a
       BACKGROUND with dark ink by .drop-filter-btn--active and
       .drop-card-badge--soon, so it is a light colour by construction and this
       cannot produce an unreadable button for any drop. Its 2px #111 ring
       would have drawn a dark halo on the dark panel, so it goes transparent. */
    '.drop-grid-wrap--themed .drop-card .drop-card-atc--m { background: var(--drop-accent, #fff); color: var(--drop-ink, #0b0d10); border-color: transparent; }',
    '.drop-grid-wrap--themed .drop-card .drop-card-atc--m:hover { background: var(--drop-accent, #fff); }',
    '.drop-grid-wrap--themed .drop-card-atc { background: var(--drop-accent, #fff); color: var(--drop-ink, #0b0d10); }',
    '.drop-grid-wrap--themed .drop-card-atc:hover { background: #fff; color: #0b0d10; }',
    '.drop-grid-wrap--themed .drop-card-atc--oos, .drop-grid-wrap--themed .drop-card-atc--oos:hover { background: rgba(255,255,255,0.10); color: rgba(255,255,255,0.45); }',
    '.drop-grid-wrap--themed .drop-faq, .drop-grid-wrap--themed .drop-reviews { color: #111; }',
    '.drop-grid-wrap--themed .drop-faq h2, .drop-grid-wrap--themed .drop-reviews h2, .drop-grid-wrap--themed .drop-faq summary { color: #111; }',
    '.drop-grid-wrap--themed .drop-faq details p { color: #555; }',
    '.drop-grid-wrap--themed .drop-reviews-sub { color: #666; }',
    '.drop-grid-wrap--themed .drop-difference-inner, .drop-grid-wrap--themed .drop-difference-inner h2, .drop-grid-wrap--themed .drop-difference-inner li { color: #111; }',
    '.drop-grid-wrap--themed .drop-soldout-input { background: #fff; color: #111; }',
    '.drop-grid-wrap--themed .drop-faq, .drop-grid-wrap--themed .drop-reviews { background: #fff; border-radius: 26px; padding: 28px 24px 32px; }',
    '.drop-grid-wrap--themed .drop-faq { max-width: 940px; margin: 48px auto 0; }',
    '.drop-grid-wrap--themed .drop-bundle { border-color: var(--drop-accent-soft); box-shadow: 0 12px 40px rgba(0,0,0,0.45), 0 0 30px var(--drop-accent-soft); }',
    '.drop-grid-wrap--themed .drop-soldout h1 { color: #fff; }',
    '.drop-grid-wrap--themed .drop-soldout p, .drop-grid-wrap--themed .drop-soldout-divider p { color: rgba(255,255,255,0.78); }',
    '.drop-grid-wrap--themed .drop-soldout-divider h2, .drop-grid-wrap--themed .drop-alt-section h3 { color: #fff; }',
    '.drop-grid-wrap--themed .drop-alt-section h3 { border-color: var(--drop-accent); }',
    '@media (max-width: 768px) { .drop-grid-wrap--themed { padding-top: 6px; } }',
    /* ── CURATED DESIGN PACKS — motifs, title gradients, ribbons, patterns ── */
    '.drop-grid-wrap--themed { position: relative; }',
    '.drop-grid-wrap--themed > * { position: relative; z-index: 1; }',
    '.drop-grid-wrap--pattern::after { content: ""; position: absolute; inset: 0; background-image: var(--drop-pattern); background-size: 72px 72px; opacity: 0.5; pointer-events: none; z-index: 0; }',
    '.drop-grid-wrap--titlegrad .drop-grid-header h1 { background-image: var(--drop-title-grad); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; color: #fff; }',
    '.drop-grid-wrap--titlegrad .drop-grid-header h1 .drop-header-badge { -webkit-text-fill-color: #0b0d10; color: #0b0d10; background: var(--drop-accent); }',
    '.drop-hero-motif { position: absolute; font-size: 110px; opacity: 0.14; pointer-events: none; line-height: 1; z-index: 0; }',
    '.drop-hero-motif--left { top: 14px; left: 4%; transform: rotate(-12deg); }',
    '.drop-hero-motif--right { bottom: 12px; right: 4%; transform: rotate(10deg); }',
    '@media (max-width: 768px) { .drop-hero-motif { font-size: 58px; opacity: 0.12; } }',
    '.drop-hero-ribbon { position: absolute; left: 0; right: 0; bottom: 0; height: 6px; background: var(--drop-ribbon); opacity: 0.92; z-index: 2; }',
    /* ── 🎃 HALLOWEEN VAULT — extra-spooky, orange-forward treatment (scoped) ── */
    '.drop-wrap--halloween .drop-grid-header { border: 1px solid rgba(255,106,0,0.22); box-shadow: inset 0 0 150px rgba(255,106,0,0.16), 0 24px 60px rgba(0,0,0,0.6); }',
    '.drop-wrap--halloween .drop-grid-header h1 { font-size: 50px; letter-spacing: 2px; filter: drop-shadow(0 0 16px rgba(255,106,0,0.6)); }',
    '@media (max-width: 768px) { .drop-wrap--halloween .drop-grid-header h1 { font-size: 34px; } }',
    '@keyframes dropHweenFlicker { 0%,17%,21%,24%,52%,56%,84%,100% { opacity: 1; filter: drop-shadow(0 0 18px rgba(255,106,0,0.72)); } 19%,23%,54%,86% { opacity: 0.82; filter: drop-shadow(0 0 4px rgba(255,106,0,0.3)); } }',
    '@media (prefers-reduced-motion: no-preference) { .drop-wrap--halloween .drop-grid-header h1 { animation: dropHweenFlicker 5s infinite; } }',
    '.drop-wrap--halloween .drop-header-tagline { color: #ff8c1a; text-shadow: 0 0 12px rgba(255,106,0,0.5); }',
    '.drop-wrap--halloween .drop-header-desc { color: rgba(255,224,196,0.9); }',
    '.drop-wrap--halloween .drop-fomo-pill { border-color: rgba(255,106,0,0.4); background: rgba(255,106,0,0.1); }',
    '.drop-wrap--halloween .drop-fomo-pill--hot { background: var(--drop-accent); color: #180700; box-shadow: 0 0 24px rgba(255,106,0,0.55); }',
    '.drop-wrap--halloween .drop-hero-ribbon { height: 9px; opacity: 1; }',
    '.drop-wrap--halloween .drop-hero-ribbon::after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 16px; background: radial-gradient(circle at 50% 0, var(--drop-accent) 0 3.5px, transparent 4.5px) 0 0 / 34px 16px repeat-x; opacity: 0.85; filter: drop-shadow(0 2px 3px rgba(255,106,0,0.45)); }',
    '.drop-wrap--halloween .drop-grid-header::after { content: "🕸️"; position: absolute; top: 2px; right: 8px; font-size: 40px; opacity: 0.18; z-index: 0; pointer-events: none; }',
    '.drop-wrap--halloween .drop-hero-motif { opacity: 0.2; }',
    '.drop-wrap--halloween .drop-color-title { text-shadow: 0 0 14px rgba(255,106,0,0.45); letter-spacing: 1px; }',
    '.drop-wrap--halloween .drop-card { transition: transform 0.18s ease, box-shadow 0.18s ease; }',
    '.drop-wrap--halloween .drop-card:hover { transform: translateY(-4px); box-shadow: 0 14px 36px rgba(0,0,0,0.5), 0 0 22px rgba(255,106,0,0.45); }',
    '.drop-wrap--halloween .drop-scarcity-fill { background: linear-gradient(90deg, #ff8c1a, #e01616); box-shadow: 0 0 14px rgba(255,106,0,0.5); }',
    /* ── 🖼️ THE MASTERPIECE GALLERY — sophisticated, gilded museum treatment (scoped) ── */
    /* Header reads like a spotlit gallery placard: hairline gold frame + warm inner glow. */
    '.drop-wrap--art .drop-grid-header { border: 1px solid rgba(201,161,74,0.32); box-shadow: inset 0 0 0 4px rgba(201,161,74,0.06), inset 0 0 140px rgba(201,161,74,0.10), 0 24px 60px rgba(0,0,0,0.62); }',
    '.drop-wrap--art .drop-grid-header h1 { font-size: 46px; letter-spacing: 4px; text-transform: uppercase; filter: drop-shadow(0 2px 10px rgba(201,161,74,0.35)); }',
    '@media (max-width: 768px) { .drop-wrap--art .drop-grid-header h1 { font-size: 28px; letter-spacing: 2px; } }',
    '.drop-wrap--art .drop-header-tagline { color: #e7c873; letter-spacing: 3px; text-shadow: 0 0 12px rgba(201,161,74,0.4); }',
    '.drop-wrap--art .drop-header-desc { color: rgba(244,236,214,0.9); font-family: "Cormorant Garamond", Georgia, serif; font-size: 18px; font-style: italic; line-height: 1.6; }',
    '@media (max-width: 768px) { .drop-wrap--art .drop-header-desc { font-size: 15px; } }',
    '.drop-wrap--art .drop-fomo-pill { border-color: rgba(201,161,74,0.42); background: rgba(201,161,74,0.10); letter-spacing: 1.4px; }',
    '.drop-wrap--art .drop-fomo-pill--hot { background: var(--drop-accent); color: #1a1306; box-shadow: 0 0 22px rgba(201,161,74,0.5); }',
    /* Faint gilded ornament in the header corner, echoing a frame cartouche. */
    '.drop-wrap--art .drop-grid-header::after { content: "❧"; position: absolute; top: 6px; right: 14px; font-size: 34px; color: var(--drop-accent); opacity: 0.22; z-index: 0; pointer-events: none; }',
    '.drop-wrap--art .drop-hero-motif { opacity: 0.16; }',
    '.drop-wrap--art .drop-hero-ribbon { height: 10px; opacity: 1; }',
    '.drop-wrap--art .drop-color-title { text-shadow: 0 0 12px rgba(201,161,74,0.32); letter-spacing: 2px; text-transform: uppercase; }',
    /* Each card is a framed canvas: thin gilt border, museum-soft lift on hover. */
    '.drop-wrap--art .drop-card { transition: transform 0.2s ease, box-shadow 0.2s ease; box-shadow: 0 0 0 1px rgba(201,161,74,0.28), 0 8px 26px rgba(0,0,0,0.4); }',
    '.drop-wrap--art .drop-card:hover { transform: translateY(-5px); box-shadow: 0 0 0 1px rgba(201,161,74,0.6), 0 16px 40px rgba(0,0,0,0.5), 0 0 26px rgba(201,161,74,0.32); }',
    '.drop-wrap--art .drop-scarcity-fill { background: linear-gradient(90deg, #e7c873, #a47b2e); box-shadow: 0 0 14px rgba(201,161,74,0.5); }',
    /* The gilded "Art Masterpiece" placard, top-right of every gallery card. */
    '.drop-card-masterpiece-badge { background: linear-gradient(135deg, #f6e7b8 0%, #e7c873 42%, #c9a14a 100%); color: #2a2114; font-weight: 800; letter-spacing: 0.6px; text-transform: uppercase; font-size: 9.5px; padding: 4px 9px; border-radius: 2px; box-shadow: 0 0 0 1px rgba(255,255,255,0.4) inset, 0 0 0 1px rgba(120,90,30,0.35), 0 2px 8px rgba(0,0,0,0.3); text-shadow: 0 1px 0 rgba(255,255,255,0.25); }',
    '@media (max-width: 768px) { .drop-card-masterpiece-badge { font-size: 8px; padding: 3px 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-masterpiece-badge { font-size: 7.5px; padding: 2px 5px; } }',
    /* ── ⚡ PRIME WEEK — blue event theming (drop-wrap--prime-week) ── */
    '.drop-card-primeweek-badge { background: linear-gradient(135deg, #7fc4ff 0%, #38bdf8 42%, #1d6bff 100%); color: #04101f; font-weight: 800; letter-spacing: 0.6px; text-transform: uppercase; font-size: 9.5px; padding: 4px 9px; border-radius: 4px; box-shadow: 0 0 0 1px rgba(255,255,255,0.45) inset, 0 0 0 1px rgba(13,40,110,0.4), 0 2px 10px rgba(13,60,160,0.45); text-shadow: 0 1px 0 rgba(255,255,255,0.3); }',
    '@media (max-width: 768px) { .drop-card-primeweek-badge { font-size: 8px; padding: 3px 6px; letter-spacing: 0.3px; } }',
    '@media (max-width: 480px) { .drop-card-primeweek-badge { font-size: 7.5px; padding: 2px 5px; } }',
    '.drop-wrap--prime-week .drop-grid-header { border: 1px solid rgba(56,189,248,0.30); box-shadow: inset 0 0 0 4px rgba(56,189,248,0.05), inset 0 0 150px rgba(29,107,255,0.16), 0 24px 60px rgba(0,0,0,0.6); }',
    '.drop-wrap--prime-week .drop-grid-header h1 { font-size: 50px; letter-spacing: 2px; text-transform: uppercase; filter: drop-shadow(0 0 16px rgba(56,189,248,0.55)); }',
    '@media (max-width: 768px) { .drop-wrap--prime-week .drop-grid-header h1 { font-size: 32px; letter-spacing: 1px; } }',
    '.drop-wrap--prime-week .drop-header-tagline { color: #7fc4ff; letter-spacing: 2px; text-shadow: 0 0 12px rgba(56,189,248,0.5); }',
    '.drop-wrap--prime-week .drop-header-desc { color: rgba(224,238,255,0.92); }',
    '.drop-wrap--prime-week .drop-fomo-pill { border-color: rgba(56,189,248,0.42); background: rgba(29,107,255,0.12); letter-spacing: 1px; }',
    '.drop-wrap--prime-week .drop-fomo-pill--hot { background: var(--drop-accent); color: #04101f; box-shadow: 0 0 24px rgba(56,189,248,0.55); }',
    '.drop-wrap--prime-week .drop-hero-ribbon { height: 9px; opacity: 1; }',
    '.drop-wrap--prime-week .drop-grid-header::after { content: "⚡"; position: absolute; top: 4px; right: 12px; font-size: 38px; opacity: 0.18; z-index: 0; pointer-events: none; }',
    '.drop-wrap--prime-week .drop-hero-motif { opacity: 0.18; }',
    '.drop-wrap--prime-week .drop-color-title { text-shadow: 0 0 14px rgba(56,189,248,0.45); letter-spacing: 1px; }',
    '.drop-wrap--prime-week .drop-card { transition: transform 0.18s ease, box-shadow 0.18s ease; box-shadow: 0 0 0 1px rgba(56,189,248,0.22), 0 8px 26px rgba(0,0,0,0.4); }',
    '.drop-wrap--prime-week .drop-card:hover { transform: translateY(-4px); box-shadow: 0 0 0 1px rgba(56,189,248,0.55), 0 16px 40px rgba(0,0,0,0.5), 0 0 24px rgba(56,189,248,0.4); }',
    '.drop-wrap--prime-week .drop-scarcity-fill { background: linear-gradient(90deg, #7fc4ff, #1d6bff); box-shadow: 0 0 14px rgba(56,189,248,0.55); }',
    '@media (max-width: 768px) {'
      + ' .drop-wrap--prime-week .drop-grid-header { padding: 16px 12px 12px; margin: 6px 0 10px; }'
      + ' .drop-wrap--prime-week .drop-grid-header h1 { font-size: 22px; letter-spacing: 1px; line-height: 1.1; margin: 0 0 5px; }'
      + ' .drop-wrap--prime-week .drop-header-tagline { font-size: 9px; letter-spacing: 1.4px; margin: 0 0 4px; }'
      + ' .drop-wrap--prime-week .drop-header-desc { font-size: 12.5px; line-height: 1.38; margin: 5px auto 0; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }'
      + ' .drop-wrap--prime-week .drop-fomo { gap: 5px; margin-top: 8px; }'
      + ' .drop-wrap--prime-week .drop-fomo-pill { font-size: 8.5px; padding: 4px 8px; letter-spacing: 0.5px; }'
      + ' .drop-wrap--prime-week .drop-hero-motif { display: none; }'
      + ' .drop-wrap--prime-week .drop-grid-header::after { font-size: 22px; top: 4px; right: 8px; }'
      + ' }',
    /* Prime Week post-coupon price chain on each card: MSRP -> Prime Week price + % off */
    '.drop-card-price--prime { gap: 7px; }',
    '.drop-card-price--pw { color: #1d6bff; font-weight: 800; }',
    '.drop-card-price--msrp { font-size: 13px; font-weight: 400; color: #999; text-decoration: line-through; }',
    '.drop-card-msrp-label { text-decoration: none; display: inline-block; font-weight: 600; font-size: 9.5px; letter-spacing: 0.4px; color: #999; vertical-align: middle; }',
    '.drop-card-off-badge { text-decoration: none; background: #1d6bff; color: #fff; font-weight: 800; font-size: 10.5px; letter-spacing: 0.3px; padding: 2px 7px; border-radius: 999px; white-space: nowrap; }',
    '.drop-card-prime-note { margin: 0 0 6px; font-size: 11px; font-weight: 700; letter-spacing: 0.2px; color: #1d6bff; text-align: left; }',
    '.drop-grid-wrap--themed .drop-card-price--pw, .drop-grid-wrap--themed .drop-card-prime-note { color: #1d6bff; }',
    '@media (max-width: 768px) { .drop-card-price--msrp { font-size: 11px; } .drop-card-off-badge { font-size: 9.5px; padding: 2px 6px; } .drop-card-prime-note { font-size: 10px; } }',
    /* Infinite-scroll Load More button + sentinel */
    '.drop-load-more-wrap { text-align: center; padding: 26px 0 8px; }',
    '.drop-load-more { background: var(--drop-accent, #1d6bff); color: #04101f; font-weight: 800; letter-spacing: 0.5px; border: none; border-radius: 999px; padding: 13px 30px; font-size: 14px; cursor: pointer; box-shadow: 0 8px 22px rgba(29,107,255,0.4); transition: transform 0.15s ease, filter 0.15s ease; }',
    '.drop-load-more:hover { transform: translateY(-2px); filter: brightness(1.06); }',
    '#drop-scroll-sentinel { height: 1px; width: 100%; }',
    /* ── 📱 ART hero — Facebook-ad mobile fold guard ──
       Keep the gallery hero under ~half the viewport on phones so the first
       product cards peek above the fold (no scroll-to-shop for paid traffic).
       Tighten padding, shrink the title, clamp the description to 2 lines,
       cap the FOMO strip to one row, and drop purely-decorative bits. */
    '@media (max-width: 768px) {'
      + ' .drop-wrap--art .drop-grid-header { padding: 16px 12px 12px; margin: 6px 0 10px; }'
      + ' .drop-wrap--art .drop-grid-header h1 { font-size: 20px; letter-spacing: 1px; line-height: 1.1; margin: 0 0 5px; }'
      + ' .drop-wrap--art .drop-grid-header h1 .drop-header-badge { display: none; }'
      + ' .drop-wrap--art .drop-header-tagline { font-size: 9px; letter-spacing: 1.4px; margin: 0 0 4px; }'
      + ' .drop-wrap--art .drop-header-desc { font-size: 12.5px; line-height: 1.38; margin: 5px auto 0; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }'
      + ' .drop-wrap--art .drop-fomo { gap: 5px; margin-top: 8px; }'
      + ' .drop-wrap--art .drop-fomo-pill { font-size: 8.5px; padding: 4px 8px; letter-spacing: 0.5px; }'
      + ' .drop-wrap--art .drop-fomo-pill:nth-child(n+3) { display: none; }'
      + ' .drop-wrap--art .drop-hero-motif { display: none; }'
      + ' .drop-wrap--art .drop-grid-header::after { font-size: 22px; top: 4px; right: 8px; }'
      + ' }',
    /* Pre-launch drop-alert capture in the hero */
    '.drop-grid-header .drop-soldout-msg { color: #4ade80; margin-top: 10px; }',

    /* ── COMPACT MOBILE HERO (paid-traffic landing concept) ──────────────
       FB/paid traffic lands on these pages: products must be visible in the
       FIRST viewport. On mobile the hero collapses to title + tagline + one
       scrollable pill row + a one-line email capture; the subheading is cut
       (it duplicates the title) and the badge stays inline. Late in the
       cascade on purpose — overrides the earlier default header spacing. */
    '@media (max-width: 768px) { '
      + '.drop-grid-header { padding: 18px 12px 16px; margin: 8px 0 12px; } '
      + '.drop-grid-header h1 { font-size: 26px; margin: 0 0 2px; } '
      + '.drop-grid-header > p:not(.drop-header-tagline):not(.drop-soldout-msg), .drop-grid-header .drop-header-desc { display: none; } '
      + '.drop-header-tagline { margin: 0 0 4px; } '
      + '.drop-grid-header h1 .drop-header-badge { display: inline-block; margin: 0 0 0 8px; font-size: 9px; padding: 3px 8px; top: -3px; } '
      + '.drop-fomo { flex-wrap: nowrap; overflow-x: auto; -webkit-overflow-scrolling: touch; justify-content: flex-start; margin: 10px -12px 0; padding: 0 12px 2px; scrollbar-width: none; } '
      + '.drop-fomo::-webkit-scrollbar { display: none; } '
      + '.drop-fomo-pill { flex: 0 0 auto; white-space: nowrap; } '
      + '.drop-scarcity { margin: 12px auto 0; } '
      + '.drop-size-filters { margin: 0 0 14px; } '
      + '}',
    /* Comparison CRO block (homepage ch26-cmp design language) */
    '.drop-cmp-wrap { max-width: 900px; margin: 48px auto 0; padding: 0 20px; }',
    '.drop-cmp-wrap h2 { font-size: 24px; font-weight: 800; text-align: center; margin: 0 0 18px; }',
    '.drop-grid-wrap--themed .drop-cmp-wrap h2 { color: #fff; font-family: var(--drop-font, inherit); }',
    /* Curved-divider bands (cldstBands): blocks keep their geometry inside a full-bleed colour band;
       text that sits directly on the band takes the band's ink (white or #0c0d0e, best WCAG contrast);
       Reviews and FAQ stay white cards. */
    '.cldst-dropband { padding: 0 0 48px; }',
    '.drop-grid-wrap .cldst-dropband .drop-difference-inner { background: transparent; }',
    '.drop-grid-wrap .cldst-dropband .drop-difference-text, .drop-grid-wrap .cldst-dropband .drop-difference-text * { color: var(--cldst-ink) !important; }',
    '.drop-grid-wrap .cldst-dropband .drop-cmp-wrap > h2 { color: var(--cldst-ink) !important; }',
    '.drop-grid-wrap .cldst-dropband .drop-cmp-check { color: #166534; }',
    '.drop-grid-wrap .cldst-dropband .drop-cmp-x { color: #6b6e73; }',
    '.drop-grid-wrap .cldst-dropband .drop-reviews .oke-w-reviewer-verified, .drop-grid-wrap .cldst-dropband .drop-reviews .oke-w-reviewer-verified * { color: #7a5c00 !important; }',
    '.drop-grid-wrap .cldst-dropband .drop-faq, .drop-grid-wrap .cldst-dropband .drop-reviews { background: #fff; color: #111; border-radius: 16px; padding: 28px 24px 32px; }',
    '.drop-grid-wrap .cldst-dropband .drop-cmp { box-shadow: 0 18px 40px -24px rgba(0,0,0,.45); }',
    '.drop-cmp { background: #fff; border: 1px solid #e6e7ea; border-radius: 16px; overflow: hidden; color: #111; }',
    '.drop-cmp-table { width: 100%; border-collapse: collapse; font-size: 14.5px; }',
    '.drop-cmp-table th, .drop-cmp-table td { padding: 14px 12px; text-align: center; border-bottom: 1px solid #e6e7ea; }',
    '.drop-cmp-table th:first-child, .drop-cmp-table td:first-child { text-align: left; font-weight: 600; padding-left: 22px; }',
    '.drop-cmp-table thead th { background: #f7f8fa; font-size: 12.5px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: #555; }',
    '.drop-cmp-table thead th.drop-cmp-brand { background: var(--drop-ink, #0c0d0e); color: #fff; font-size: 14px; }',
    '.drop-cmp-table tr:last-child td { border-bottom: none; }',
    '.drop-cmp-us { background: var(--drop-accent-soft, rgba(245,166,35,0.08)); }',
    '.drop-cmp-check { color: #16a34a; font-size: 18px; font-weight: 700; }',
    '.drop-cmp-x { color: #d4d6db; font-size: 18px; }',
    /* Review cards (rendered from the Okendo store API) */
    '.drop-reviews-loading { text-align: center; color: #999; font-size: 13px; padding: 18px 0; }',
    '.drop-reviews-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-top: 8px; }',
    '@media (max-width: 900px) { .drop-reviews-grid { grid-template-columns: repeat(2, 1fr); } }',
    '@media (max-width: 560px) { .drop-reviews-grid { grid-template-columns: 1fr; } }',
    '.drop-review-card { background: #fafafa; border: 1px solid #ececec; border-radius: 12px; padding: 16px 16px 14px; color: #111; overflow: hidden; }',
    '.drop-review-media { margin: -16px -16px 12px; aspect-ratio: 4/3; background: #eee; }',
    '.drop-review-media img { width: 100%; height: 100%; object-fit: cover; display: block; }',
    '.drop-review-stars { color: #f5a623; font-size: 15px; letter-spacing: 2px; margin-bottom: 6px; }',
    '.drop-review-title { font-size: 14px; font-weight: 700; margin: 0 0 4px; }',
    '.drop-review-body { font-size: 13px; line-height: 1.55; color: #444; margin: 0 0 10px; }',
    '.drop-review-name { font-size: 12px; font-weight: 600; color: #333; margin: 0; }',
    '.drop-review-verified { color: #15803d; font-weight: 700; margin-left: 6px; font-size: 11px; }',
  ].join('\n');
  document.head.appendChild(style);

  /* ── LOADING STATE ──────────────────────────────────────── */
  var wrapper = document.createElement('div');
  wrapper.className = 'drop-grid-wrap' + (theme.bg ? ' drop-grid-wrap--themed' : '') +
    (theme.titleGradient ? ' drop-grid-wrap--titlegrad' : '') +
    (theme.pattern ? ' drop-grid-wrap--pattern' : '') +
    ' drop-wrap--' + handle;
  /* SSR first paint (templates/collection.drop.liquid) already shows real cards —
     don't stack a "Loading…" block on top of it; swap happens on real render. */
  var ssrNode = document.getElementById('drop-ssr');
  wrapper.innerHTML = ssrNode ? '' : '<div class="drop-loading">Loading Sports Drop...</div>';
  /* With SSR cards on screen, keep the (still empty) wrapper out of the flow
     until buildGrid() fills it — an empty themed wrap at main.firstChild pushed
     the SSR + footer down at DCL (CLS). Un-hidden right after innerHTML = html. */
  if (ssrNode) wrapper.style.display = 'none';

  /* Insert above the collection product grid so our drop-grid is visible first */
  function insertGrid() {
    /* The framework IS the page — render at the very top of main content.
       The native template sections are hidden via the drop-page-active rules. */
    var main = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
    main.insertBefore(wrapper, main.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertGrid);
  } else {
    insertGrid();
  }

  /* ── FETCH PRODUCT DATA ─────────────────────────────────── */
  /* We read product handles from the Boost grid, then fetch .js for each */
  function getProductHandles() {
    return new Promise(function(resolve) {
      var handles = new Set();
      /* Try parsing from Boost data attributes */
      var cards = document.querySelectorAll('[data-product]');
      cards.forEach(function(el) {
        try {
          var d = JSON.parse(el.getAttribute('data-product'));
          if (d && d.handle) handles.add(d.handle);
        } catch(e) {}
      });
      /* Also try product links */
      document.querySelectorAll('a[href*="/products/"]').forEach(function(a) {
        var m = a.href.match(/\/products\/([^\/\?#]+)/);
        if (m) handles.add(m[1]);
      });
      if (handles.size > 0) {
        resolve(Array.from(handles));
      } else {
        /* Boost may render async — wait and retry */
        var attempts = 0;
        var iv = setInterval(function() {
          attempts++;
          document.querySelectorAll('[data-product]').forEach(function(el) {
            try {
              var d = JSON.parse(el.getAttribute('data-product'));
              if (d && d.handle) handles.add(d.handle);
            } catch(e) {}
          });
          document.querySelectorAll('a[href*="/products/"]').forEach(function(a) {
            var m = a.href.match(/\/products\/([^\/\?#]+)/);
            if (m) handles.add(m[1]);
          });
          if (handles.size > 0 || attempts > 30) {
            clearInterval(iv);
            resolve(Array.from(handles));
          }
        }, 300);
      }
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });
  }

  /* ── BUILD VARIANT CARDS ────────────────────────────────── */
  /* ── RENDER SINGLE CARD ─────────────────────────────────── */
  /* Current drop badge state — same schedule as nav badges */
  function getDropBadge() {
    var now = new Date(new Date().toLocaleString('en-US',{timeZone:'America/New_York'}));
    var day = now.getDay();
    var hour = now.getHours();
    var min = now.getMinutes();
    /* Drop goes live Thursday 9:45am ET. Sneak Peek runs Mon 10pm -> Thu 9:45am. */
    var afterDrop = (hour > 9) || (hour === 9 && min >= 45);
    if(day === 4) return afterDrop
      ? {text:'New Drop', cls:'drop-card-drop-badge--new'}
      : {text:'Sneak Peek', cls:'drop-card-drop-badge--sneak'};
    if(day === 5 || day === 6 || day === 0) return {text:'New Drop', cls:'drop-card-drop-badge--new'};
    if(day === 1 || day === 2 || day === 3) return {text:'Sneak Peek', cls:'drop-card-drop-badge--sneak'};
    return null;
  }

  /* CRON-MANAGED: drop names that get badges — updated by weekly cron */
  var BADGE_DROP_NAMES = ["sapphire opal", "winterglass luna"];

  /* CRON-MANAGED: launch dates for "reserve inventory" text (ISO date string) */

  /* Pre-drop image reveal stage — returns 'silhouette' | 'partial' | null (full image) */
  /* Schedule (per spec): Sun & Mon = silhouette, Tue/Wed = partial, Thu before 9:45am = partial, Thu 9:45am ET = full reveal */
  /* Only applies within 6 days BEFORE the launch date (Sun-Thu morning of drop week) */
  /* Colors that always show their FULL real image regardless of reveal stage.
     Add a color name here (lowercase) to bypass the silhouette/partial dark scrim. */
  var ALWAYS_FULL_REVEAL = ['berry bae', 'magical potions', 'the ottoman'];

  /* Per-drop reveal mode (config.reveal), so drop theater is one config line:
       'auto'   (default) silhouette Sun -> sneak peek Mon-Thu -> full at 9:45am ET
       'none'   never conceal (evergreen/core collections, post-reveal events)
       'sealed' full blackout silhouette right up to the launch moment
     Any drop, current or future, opts in by setting reveal in DROP_CONFIG. */
  /* ── PRE-DROP vs SOLD OUT ────────────────────────────────────────────
     A drop's SKUs exist with zero inventory well before drop day, which used
     to render them as "Sold Out" — wrong and damaging, because the drop has
     not happened yet. Inventory is loaded during the Sunday ~10pm ET staging
     run, so up until Sunday 11pm ET of drop week a zero-inventory size means
     NOT DROPPED YET; after that cutoff inventory is live and zero genuinely
     means sold out. Applies to every current and future drop automatically. */
  var DROP_STOCK_STAGED = false;

  function preDropCutoff(launchStr) {
    var d = new Date(launchStr + 'T00:00:00');
    var dow = d.getDay();                          /* 0 = Sunday */
    var back = dow === 0 ? 7 : dow;                /* to the Sunday BEFORE launch */
    var sun = new Date(d.getTime() - back * 86400000);
    sun.setHours(23, 0, 0, 0);                     /* 11pm ET */
    return sun;
  }

  /* Has a drop launched (its launch date, 9:45am ET)? Compared on the ET WALL
     CLOCK, the way isPreDrop() and getRevealStage() do. A fixed '-04:00' offset
     is EDT only: from November to March it switched every page an hour early,
     at 8:45am EST (Request 263 review). */
  function launchedET(launchStr) {
    if (!launchStr) return false;
    var nowET = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    return nowET >= new Date(launchStr + 'T09:45:00');
  }

  function isPreDrop(colorLower) {
    var ls = DROP_LAUNCH_DATES[(colorLower || '').toLowerCase()];
    if (!ls) return false;
    var nowET = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    if (nowET >= new Date(ls + 'T09:45:00')) return false;   /* already dropped */
    if (!DROP_STOCK_STAGED) return true;                     /* nothing staged yet */
    return nowET < preDropCutoff(ls);                        /* staged: clock decides */
  }

  /* Friendly "Thursday" style label for the drop's launch day */
  function launchDayLabel(colorLower) {
    var ls = DROP_LAUNCH_DATES[(colorLower || '').toLowerCase()];
    if (!ls) return '';
    var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    return DAYS[new Date(ls + 'T09:45:00').getDay()];
  }

  function getRevealStage(colorLower) {
    var mode = (config && config.reveal) || 'auto';
    if (mode === 'none') return null;
    if (ALWAYS_FULL_REVEAL.indexOf(colorLower) !== -1) return null;
    var launchStr = DROP_LAUNCH_DATES[colorLower];
    if (!launchStr) return null;
    if (mode === 'sealed') {
      var nowS = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
      return nowS >= new Date(launchStr + 'T09:45:00') ? null : 'silhouette';
    }
    var now = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/New_York'}));
    var launch = new Date(launchStr + 'T09:45:00');   /* drop goes live Thursday 9:45am ET */
    /* Drop moment (Thu 9:45am ET) or later: full reveal */
    if (now >= launch) return null;
    var msPerDay = 86400000;
    var daysUntil = Math.ceil((launch - now) / msPerDay);
    /* Only reveal during the 6 days before drop (Sun -> Thu morning of drop week) */
    if (daysUntil > 6) return null;
    var day = now.getDay();   /* 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu */
    /* Reveal cadence (ET): Sun = silhouette (true sight unseen). Mon through
       Thu pre-9:45am = SNEAK PEEK — the real variant images, bright-blur
       teased (the blur is the concealment; nothing darkened).
       Thu 9:45am = full reveal (handled by the now >= launch check above). */
    if (day === 0) return 'silhouette';
    if (day >= 1 && day <= 4) return 'partial';
    /* Fri/Sat BEFORE a weekend launch (e.g. Mega Live Saturday drops): still
       pre-launch here (now < launch), so keep the sneak-peek treatment — falling
       through to null would fully reveal the design a day early. */
    return 'partial';
  }

  /* Core colors — no badge at all (not limited edition, not new drop) */
  var CORE_COLORS = ['stealth black', 'pink reflections', 'the american', 'moroccan', 'the moroccan', 'morrocan', 'the morrocan', 'purple nova'];

  /* Complete the Look no longer lives here: ACCESSORY_MAP (70 hardcoded
     colorway -> variant-id triples) was deleted in Request 198. 135 of its 213
     slots were unbuyable, every boots id was a /15oz variant, and 27 entries
     pointed at a DRAFT product whose /products/*.js 404s, so 25 pages rendered
     a tile reading "Loading..." forever. The rows are server-rendered from the
     drop size's product_family metaobject into <template id="drop-ctl-rows">
     by templates/collection.drop.liquid — see mountCompleteTheLook() below. */

  /* ── GLOBAL PRIME WEEK MODE ──────────────────────────────────────
     For the duration of the event, EVERY drop-framework collection shows a
     Prime Week badge + the post-coupon Prime Week price (regular price − 10%
     with code PRIMEWEEK), not just /collections/prime-week. Date-guarded so it
     auto-reverts the instant the code expires — we never advertise a dead code.
     The dedicated prime-week page keeps its own top-right placard
     (config.primeWeekBadge); other collections get a top-left flag instead. */
  var PRIME_WEEK_PCT = 10;
  var PRIME_WEEK_CODE = 'PRIMEWEEK';
  var PRIME_WEEK_ACTIVE = false; /* Prime Week event ended — turned off manually */

  /* ═══════════════════════════════════════════════════════════════════
     STICKY MOBILE BUY BAR (#3) — framework-wide, every current/future drop
     Once the shopper scrolls into the grid, the hero size stays one thumb
     away: drop name + from-price on the left (taps back to the grid), a real
     one-tap add on the right. Mobile only (CSS-gated); silent when the drop
     has nothing available.
     ═══════════════════════════════════════════════════════════════════ */
  /* Bundle discount configuration — MUST mirror a discount that exists in
     Shopify. percent 0 = no discount claim is made anywhere in the bundle UI.
       code:    a real discount code to attach at checkout, or null for an
                automatic (no-code) discount
       percent: fraction off, e.g. 0.10 — drives the savings copy and pricing
       min:     the discount's minimum quantity; the picker unlocks at it */
  /* Live discount: "Drop Bundle 10% (bundle CTA only)" — code DROPBUNDLE-K7Q3,
     10% off, minimum 4 items (3 until Request 262), scoped to the 55
     drop-template collections. Code-based on purpose: it only attaches when a
     shopper adds a set through the bundle picker, so an ordinary 4-bottle cart
     is unaffected (an automatic rule could not tell the difference, because
     every drop collection contains the same base products). The minimum caps
     the damage if it ever leaks. Change `min` and the code's minimum in Admin
     together, or the picker promises a discount checkout will not give. */
  var BUNDLE_DISCOUNT = { code: 'DROPBUNDLE-K7Q3', percent: 0.10, min: 4 };
  /* The US Domestic "Standard $0" rate starts at $125 after discounts (the
     slide cart's free_shipping_threshold is the same number). A 4-size set can
     land under it, so the picker claims free shipping only above it. */
  var FREE_SHIP_CENTS = 12500;
  /* Final-sale sizes: the live /pages/life closeout list names the 20oz
     Tumbler ("not eligible for returns, exchanges, refunds"), so a set that
     holds one cannot carry a plain "30-day returns" line. */
  var FINAL_SALE_HANDLES = ['tumbler'];

  /* A set's price in cents, with the bundle discount once it reaches
     BUNDLE_DISCOUNT.min. Rounded PER LINE, the way a percentage code is
     allocated across line items at checkout. */
  function bundleSetCents(prices) {
    var full = 0, off = 0;
    var on = BUNDLE_DISCOUNT.percent > 0 && prices.length >= BUNDLE_DISCOUNT.min;
    prices.forEach(function (p) { full += p; if (on) off += Math.round(p * BUNDLE_DISCOUNT.percent); });
    return { full: full, off: off, sale: full - off };
  }

  var STICKY_SIZE_PREF = ['36oz', '46oz', '32oz', '24oz', '20oz', '15oz', '128oz', '6.7oz'];

  function injectOnce(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* Reads the RENDERED cards rather than an internal array: the grid is the
     source of truth (it already reflects filtering, ordering and sold-out
     state), and the framework's item arrays are consumed during render. */
  function buildStickyBuyBar() {
    if (document.getElementById('drop-sticky-buy')) return;
    var avail = [];
    wrapper.querySelectorAll('.drop-card').forEach(function (card) {
      if (card.getAttribute('data-available') !== '1') return;
      var bag = card.querySelector('.drop-card-bag[data-variant-id]');
      if (!bag) return;
      avail.push({
        variantId: bag.getAttribute('data-variant-id'),
        size: card.getAttribute('data-size') || '',
        price: parseInt(card.getAttribute('data-price'), 10) || 0
      });
    });
    if (!avail.length) return;

    var pick = null;
    for (var s = 0; s < STICKY_SIZE_PREF.length && !pick; s++) {
      for (var i = 0; i < avail.length; i++) {
        if ((avail[i].size || '').toLowerCase() === STICKY_SIZE_PREF[s].toLowerCase()) { pick = avail[i]; break; }
      }
    }
    if (!pick) pick = avail[0];

    var from = avail.reduce(function (m, it) {
      var pc = it.price;
      return (pc && (!m || pc < m)) ? pc : m;
    }, 0);
    function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

    injectOnce('drop-sticky-buy-css', [
      '.drop-sticky-buy{position:fixed;left:0;right:0;bottom:0;z-index:60;display:none;align-items:center;gap:10px;',
      'padding:10px 12px calc(10px + env(safe-area-inset-bottom,0px));background:rgba(12,12,14,.97);',
      '-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);border-top:1px solid rgba(255,255,255,.12);',
      'transform:translateY(110%);transition:transform .22s cubic-bezier(.4,0,.2,1)}',
      '.drop-sticky-buy.is-on{transform:translateY(0)}',
      '@media (max-width:768px){.drop-sticky-buy{display:flex}',
      'body.has-drop-sticky-buy{padding-bottom:74px}}',
      '.drop-sticky-info{flex:1 1 auto;min-width:0;background:none;border:0;padding:0;text-align:left;color:#fff;font-family:inherit;cursor:pointer}',
      '.drop-sticky-name{display:block;font-size:12.5px;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.drop-sticky-from{display:block;font-size:11px;color:rgba(255,255,255,.62);margin-top:2px}',
      '.drop-sticky-from u{text-decoration:none;color:rgba(255,255,255,.9);border-bottom:1px dotted rgba(255,255,255,.45)}',
      '.drop-sticky-add{flex:0 1 auto;min-width:0;white-space:nowrap;border:0;border-radius:999px;padding:13px 16px;background:#fff;color:#111;',
      'font-family:inherit;font-size:12.5px;font-weight:900;letter-spacing:.04em;cursor:pointer;transition:background .15s,transform .12s}',
      '.drop-sticky-add:active{transform:scale(.96)}',
      '.drop-sticky-add.is-added{background:#22c55e;color:#052e12}'
    ].join(''));

    var bar = document.createElement('div');
    bar.className = 'drop-sticky-buy';
    bar.id = 'drop-sticky-buy';
    bar.innerHTML =
      '<button type="button" class="drop-sticky-info" id="drop-sticky-info">' +
        '<span class="drop-sticky-name">' + (config.heading || 'This drop') + '</span>' +
        '<span class="drop-sticky-from">From ' + money(from) + ' · <u>see all sizes</u></span>' +
      '</button>' +
      '<button type="button" class="drop-sticky-add" id="drop-sticky-add">ADD ' +
        (pick.size || '').toUpperCase() + ' · ' + money(parseInt(pick.price, 10) || 0) + '</button>';
    document.body.appendChild(bar);
    document.body.classList.add('has-drop-sticky-buy');   /* reserves space so the bar never covers footer content */

    document.getElementById('drop-sticky-info').addEventListener('click', function () {
      var grid = wrapper.querySelector('.drop-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var addBtn = document.getElementById('drop-sticky-add');
    addBtn.addEventListener('click', function () {
      if (addBtn.classList.contains('is-added')) return;
      var label = addBtn.textContent;
      addBtn.textContent = 'ADDING…';
      cartAddXHR({ items: [{ id: parseInt(pick.variantId, 10), quantity: 1 }] })
      .then(function (item) { return item; })
      .then(function () {
        addBtn.classList.add('is-added');
        addBtn.textContent = '✓ ADDED';
        openCartDrawer();
        setTimeout(function () { addBtn.classList.remove('is-added'); addBtn.textContent = label; }, 2000);
      })
      .catch(function () { addBtn.textContent = 'TRY AGAIN'; setTimeout(function () { addBtn.textContent = label; }, 1600); });
    });

    /* reveal once browsing the grid — but stand down while the bundle CTA is
       on screen, so the page never shows two competing primaries (#7) */
    var bundleEl2 = document.getElementById('drop-bundle-cta');
    function bundleInView() {
      if (!bundleEl2) return false;
      var r = bundleEl2.getBoundingClientRect();
      return r.top < window.innerHeight - 40 && r.bottom > 80;
    }
    function onScroll() {
      bar.classList.toggle('is-on', window.scrollY > 420 && !bundleInView());
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ═══════════════════════════════════════════════════════════════════
     DROP-DAY CELEBRATION (#4) — the reveal moment should feel like one.
     On the drop's launch day (after the 9:45am ET reveal) the first visit of
     a session gets a "JUST DROPPED" toast + a confetti burst in the drop's
     own accent colors. Session-gated, reduced-motion aware, pointer-safe.
     ═══════════════════════════════════════════════════════════════════ */
  function celebrateDropDay() {
    var colorLower = (COLORS[0] || '').toLowerCase();
    var launchStr = DROP_LAUNCH_DATES[colorLower];
    if (!launchStr) return;
    var nowET = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    var launch = new Date(launchStr + 'T09:45:00');
    if (nowET < launch) return;                               /* not revealed yet */
    if (nowET - launch > 86400000) return;                    /* only on drop day */
    var key = 'coldestDropCelebrated:' + handle;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}

    injectOnce('drop-celebrate-css', [
      '.drop-just-dropped{position:fixed;left:50%;top:86px;transform:translate(-50%,-14px);z-index:9998;',
      'display:flex;align-items:center;gap:9px;padding:11px 20px;border-radius:999px;background:rgba(12,12,14,.94);',
      '-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);color:#fff;font-size:12.5px;font-weight:900;',
      'letter-spacing:.14em;box-shadow:0 10px 34px rgba(0,0,0,.3);opacity:0;transition:opacity .3s,transform .3s;pointer-events:none}',
      '.drop-just-dropped.is-on{opacity:1;transform:translate(-50%,0)}'
    ].join(''));

    var toast = document.createElement('div');
    toast.className = 'drop-just-dropped';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<span>✦</span><span>JUST DROPPED — ' + (config.heading || '').toUpperCase() + '</span>';
    document.body.appendChild(toast);
    setTimeout(function () { toast.classList.add('is-on'); }, 350);
    setTimeout(function () { toast.classList.remove('is-on'); }, 4600);
    setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 5200);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var colors = [theme.accent || '#fff', theme.accent2 || '#888', '#ffffff'];
    var cv = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true');
    cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9997';
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), dpr = window.devicePixelRatio || 1;
    cv.width = window.innerWidth * dpr; cv.height = window.innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var parts = [];
    for (var i = 0; i < 110; i++) {
      parts.push({
        x: Math.random() * window.innerWidth, y: -14 - Math.random() * window.innerHeight * 0.45,
        vx: (Math.random() - 0.5) * 1.5, vy: 2.2 + Math.random() * 2.6,
        w: 5 + Math.random() * 6, h: 8 + Math.random() * 7,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.26,
        c: colors[(Math.random() * colors.length) | 0], sway: Math.random() * Math.PI * 2, life: 0
      });
    }
    (function tick() {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.life++; p.sway += 0.06; p.vy = Math.min(p.vy + 0.1, 5);
        p.x += p.vx + Math.sin(p.sway) * 1.1; p.y += p.vy; p.rot += p.vr;
        if (p.y > window.innerHeight + 26) { parts.splice(i, 1); continue; }
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, Math.abs(Math.sin(p.sway)) * p.h + 2); ctx.restore();
      }
      if (parts.length) requestAnimationFrame(tick);
      else if (cv.parentNode) cv.parentNode.removeChild(cv);
    })();
  }

  function renderCard(item) {
    var hasSale = item.compareAtPrice && item.compareAtPrice > item.price;
    var priceClass = hasSale ? ' drop-card-price--sale' : '';
    var h = '';
    var itemPreDrop = !item.available && isPreDrop(item.color);
    h += '<div class="drop-card' + (item.available ? '' : (itemPreDrop ? ' drop-card--soon' : ' drop-card--oos')) + '" data-collection="' + (item.title || '') + '" data-size="' + (item.size || '') + '" data-color="' + (item.color || '').toLowerCase() + '" data-price="' + (parseInt(item.price, 10) || 0) + '" data-available="' + (item.available ? '1' : '0') + '">';
    /* Per-variant remaining qty (real, from the server inventory map) */
    var lsQty = serverInv(item.variantId);
    if (lsQty === null && typeof item.inventory === 'number') lsQty = item.inventory;
    var isLowStock = item.available && typeof lsQty === 'number' && lsQty > 0 && lsQty < LOW_STOCK_THRESHOLD;
    /* Top-left badge stack: glow flag, then Sold Out, or Save% + "Only N left" */
    var tlBadges = '';
    /* The CARD's own colorway decides this, never the page's config — see
       GLOW_COLORWAYS. Shown on sold-out cards too when it applies: it
       describes the product, not its stock. */
    if (isGlowColorway(item.color)) {
      tlBadges += '<span class="drop-card-badge drop-card-badge--glow">\u2728 Glows in the Dark</span>';
    }
    if (!item.available) {
      tlBadges += isPreDrop(item.color)
        ? '<span class="drop-card-badge drop-card-badge--soon">Dropping Soon</span>'
        : '<span class="drop-card-badge drop-card-badge--oos">Sold Out</span>';
    } else {
      if (PRIME_WEEK_ACTIVE && !config.primeWeekBadge) {
        tlBadges += '<span class="drop-card-badge drop-card-pw-flag">⚡ Prime Week</span>';
      }
      if (hasSale) {
        var pct = Math.round((1 - item.price / item.compareAtPrice) * 100);
        tlBadges += '<span class="drop-card-badge drop-card-badge--sale">Save ' + pct + '%</span>';
      }
      if (isLowStock) {
        tlBadges += '<span class="drop-card-badge drop-card-badge--lowstock">🔥 Only ' + lsQty + ' left</span>';
      }
    }
    if (tlBadges) h += '<div class="drop-card-badges">' + tlBadges + '</div>';
    /* Drop badge (top-right) */
    var dropBadge = getDropBadge();
    var colorLower = item.color.toLowerCase();
    var isCurrentDrop = BADGE_DROP_NAMES.indexOf(colorLower) !== -1;
    var isCoreColor = CORE_COLORS.indexOf(colorLower) !== -1;
    if (config.primeWeekBadge) {
      /* Blue "Prime Week" placard — top-right of every event card. */
      h += '<span class="drop-card-drop-badge drop-card-primeweek-badge">⚡ Prime Week</span>';
    } else if (config.masterpieceBadge) {
      /* Gilded "Art Masterpiece" placard — top-right of every gallery card. */
      h += '<span class="drop-card-drop-badge drop-card-masterpiece-badge">🖼️ Art Masterpiece</span>';
    } else if (isCurrentDrop && dropBadge) {
      h += '<span class="drop-card-drop-badge ' + dropBadge.cls + '">' + dropBadge.text + '</span>';
    } else if (!isCoreColor) {
      h += '<span class="drop-card-drop-badge drop-card-drop-badge--limited">Limited Edition</span>';
    }
    /* Image — reveal stages only apply when we have real variant photos.
       If forceDefaultImage is active (and we're still pre-launch), the image
       already IS a "Coming Soon" placeholder, so skip the JS-applied dark scrim
       to avoid double-treatment. Once launch passes, forceDefaultImage no longer
       fires (see effectiveForceDefault in buildGrid), and revealStage runs
       normally so we can reveal real photos. */
    var __launchStr = DROP_LAUNCH_DATES[colorLower];
    /* Full reveal = drop day Thursday 9:45am ET */
    var __pastLaunch = launchedET(__launchStr);
    var __forceDefaultActive = config.forceDefaultImage && !__pastLaunch;
    /* A companion gets the same pre-launch treatment as the bottles beside it
       (Request 263): a sharp 30oz among sneak-peek-blurred bottles revealed the
       drop early. getRevealStage() keys on the colour's own launch date, so a
       companion on an already-launched drop still shows plainly. */
    var revealStage = __forceDefaultActive ? null : getRevealStage(colorLower);
    var imgCls = 'drop-card-img';
    var wrapCls = 'drop-card-img-wrap';
    var wrapAttrs = '';
    if (revealStage === 'silhouette') {
      imgCls += ' drop-card-img--silhouette';
      wrapCls += ' drop-card-img-wrap--reveal drop-card-img-wrap--silhouette';
      wrapAttrs = ' data-reveal-label="Coming Soon"';
    } else if (revealStage === 'partial') {
      imgCls += ' drop-card-img--partial';
      wrapCls += ' drop-card-img-wrap--reveal drop-card-img-wrap--partial';
      wrapAttrs = ' data-reveal-label="Sneak Peek"';
    }
    h += '<div class="' + wrapCls + '"' + wrapAttrs + '>';
    h += '<a class="drop-card-link" href="' + item.productUrl + '">';
    if (item.image) {
      h += '<img class="' + imgCls + '" src="' + item.image + '" alt="' + item.color + ' ' + item.size + '" loading="lazy">';
    }
    h += '</a>';
    /* Quick-add bag overlay (bottom-right of the image) — available items only */
    if (item.available) {
      h += '<button class="drop-card-bag" data-variant-id="' + item.variantId + '" aria-label="Add to bag" title="Add to bag">' + BAG_ICON + '</button>';
    }
    h += '</div>';
    /* Info */
    h += '<div class="drop-card-info">';
    h += '<a class="drop-card-link" href="' + item.productUrl + '">';
    h += '<p class="drop-card-title">' + item.color + ' — ' + item.size + '</p>';
    h += cardRatingHtml(item.productId);
    /* Prime Week pricing applies to the dedicated page (config.primeWeekDiscountPct)
       AND, while the event is live, to EVERY drop collection (PRIME_WEEK_ACTIVE).
       pwPct resolves to 0 once the code expires → cards fall back to normal price. */
    var pwPct = PRIME_WEEK_ACTIVE ? (config.primeWeekDiscountPct || PRIME_WEEK_PCT) : 0;
    var pwCode = config.primeWeekCode || PRIME_WEEK_CODE;
    if (pwPct) {
      /* Prime Week pricing chain: MSRP (compare-at price, or the regular price
         when there is no compare-at) → post-coupon Prime Week price (regular
         price − discount %), plus the TOTAL % off from MSRP to the Prime Week
         price. The discount itself is applied at checkout via the cart-wide
         PRIMEWEEK code. */
      var __pwMsrp = (hasSale && item.compareAtPrice > item.price) ? item.compareAtPrice : item.price;
      var __pwPrice = Math.round(item.price * (1 - pwPct / 100));
      var __pwOff = (__pwMsrp > 0) ? Math.round((1 - __pwPrice / __pwMsrp) * 100) : 0;
      h += '<p class="drop-card-price drop-card-price--prime">';
      h += '<span class="drop-card-price--pw">' + formatMoney(__pwPrice) + '</span>';
      h += '<span class="drop-card-price--msrp"><span class="drop-card-msrp-label">MSRP</span> ' + formatMoney(__pwMsrp) + '</span>';
      if (__pwOff > 0) h += '<span class="drop-card-off-badge">' + __pwOff + '% OFF</span>';
      h += '</p>';
      h += '<p class="drop-card-prime-note">⚡ Prime Week price · code ' + pwCode + '</p>';
    } else {
      h += '<p class="drop-card-price' + priceClass + '">';
      h += '<span>' + formatMoney(item.price) + '</span>';
      if (hasSale) h += '<span class="drop-card-price--compare">' + formatMoney(item.compareAtPrice) + '</span>';
      h += '</p>';
    }
    h += '</a></div>';
    /* Add-to-bag is the quick-add overlay on the image (tablet/desktop) and
       this full-width button on phones — same condition as the bag. Sold-out
       items get neither (greyed card + "Sold Out" badge); keep the pre-drop
       reserve note. */
    if (item.available) h += wideAtcHTML(item.variantId);
    if (!item.available) {
      var colorLowerReserve = item.color.toLowerCase();
      var launchDate = DROP_LAUNCH_DATES[colorLowerReserve];
      if (launchDate) {
        var launched = new Date(launchDate + 'T09:45:00');
        var now = new Date();
        var daysUntilLaunch = (launched - now) / (1000 * 60 * 60 * 24);
        if (daysUntilLaunch >= 0 && daysUntilLaunch <= 7) {
          h += isPreDrop(colorLowerReserve)
            ? '<p class="drop-card-reserve">Drops ' + (launchDayLabel(colorLowerReserve) || 'Thursday') + ' at 9:45am ET.</p>'
            : '<p class="drop-card-reserve">Sold out! Second Chance Drop Day Reserve Inventory will drop Thursday at 9:45am ET.</p>';
        }
      }
    }
    h += '</div>';
    return h;
  }

  /* ── SEO/AIO: inject FAQPage + ItemList JSON-LD for the rendered drop ──
     Crawlers that execute JS (Google, plus most AI answer engines) get the full
     drop as structured data: every size with live price + availability, and the
     FAQ (including the per-drop limited-edition answer). */
  function injectStructuredData(items, faqs) {
    var old = document.getElementById('drop-jsonld');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var origin = window.location.origin;
    var data = [];
    if (faqs && faqs.length) {
      data.push({
        '@context': 'https://schema.org', '@type': 'FAQPage',
        mainEntity: faqs.map(function(f) {
          return { '@type': 'Question', name: f[0],
                   acceptedAnswer: { '@type': 'Answer', text: f[1] } };
        })
      });
    }
    if (items && items.length) {
      data.push({
        '@context': 'https://schema.org', '@type': 'ItemList',
        name: config.heading + ' — Limited Edition Coldest Drop',
        numberOfItems: items.length,
        itemListElement: items.map(function(it, i) {
          return { '@type': 'ListItem', position: i + 1, item: {
            '@type': 'Product',
            name: config.heading + ' ' + it.size + ' Insulated Bottle',
            image: it.image || undefined,
            url: origin + it.productUrl,
            brand: { '@type': 'Brand', name: 'The Coldest Water' },
            offers: { '@type': 'Offer',
              price: ((parseInt(it.price, 10) || 0) / 100).toFixed(2),
              priceCurrency: 'USD',
              availability: it.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
              url: origin + it.productUrl }
          } };
        })
      });
    }
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'drop-jsonld';
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  }

  function buildGrid(products) {
    var variantsByColor = {};

    /* If forceDefaultImage is on but the launch date has already passed,
       disable it so the drop page auto-switches to real variant photos.
       Compares against DROP_LAUNCH_DATES[primaryColor]. If no launch date is
       configured, forceDefaultImage stays as-is (treated as ongoing pre-reveal). */
    var primaryColor = (COLORS[0] || '').toLowerCase();
    var launchStr = DROP_LAUNCH_DATES[primaryColor];
    /* Full reveal = drop day Thursday 9:45am ET */
    var pastLaunch = launchedET(launchStr);
    var effectiveForceDefault = config.forceDefaultImage && !pastLaunch;

    products.forEach(function(product) {
      if (!product || !product.variants) return;

      /* Find color option index — .js returns [{name,position,values}, ...] */
      var colorIdx = -1;
      var sizeIdx = -1;
      (product.options || []).forEach(function(opt, i) {
        var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
        if (name === 'color') colorIdx = i;
        if (name === 'size') sizeIdx = i;
      });
      if (colorIdx === -1) return;

      product.variants.forEach(function(v) {
        var colorVal = normalizeColor(v.options[colorIdx] || '');
        if (COLORS.indexOf(colorVal) === -1) return;
        /* Curated in-stock collections (config.inStockOnly): never render a
           sold-out card. If it leaves the grid empty the sold-out experience
           takes over downstream, so the page is never blank. */
        if (config.inStockOnly && !v.available) return;
        var comp = isCompanion(product.handle);
        if (comp && !v.available) return;   /* Request 241: companion is in stock only */

        var displayColor = (v.options[colorIdx] || '').replace(/\s*Ultra\s*$/i, '').trim();
        var size = sizeIdx >= 0 ? v.options[sizeIdx] : '';

        /* Find variant image — override map > variant featured_image > default override */
        var imgUrl = '';
        var overrides = (config.imageOverrides || {})[colorVal] || {};
        var sizeKey = (size || '').toLowerCase();

        if (comp) {
          /* Request 241: after launch a companion shows its OWN packshot or no
             card at all: never the drop's art, never a shared teaser.
             Request 263 (David, 2026-10-26: "Don't reveal the image because
             it's sight unseen right now"): BEFORE its colour's 9:45am ET launch
             the companion is sight unseen like the bottles beside it. Its
             variant sits on the HIDDEN image (the Drive Thru's "NEW DROP /
             COMING SOON" silhouette, shared by every unreleased colour), and the
             card shows the page's coming-soon art while forceDefaultImage is on,
             that hidden image after. Never a real render before launch. */
          var cfi = v.featured_image, cfiIds = (cfi && cfi.variant_ids) || [];
          var compLaunch = DROP_LAUNCH_DATES[(displayColor || '').toLowerCase()];
          var compSealed = !!compLaunch && !launchedET(compLaunch);
          if (compSealed) {
            imgUrl = (effectiveForceDefault && overrides['default']) ? overrides['default'] : ((cfi && cfi.src) || overrides['default'] || '');
          } else if (cfi && cfi.src && cfiIds.length <= 5 && (cfiIds.length === 0 || cfiIds.indexOf(v.id) !== -1)) {
            imgUrl = cfi.src;
          }
        } else if (overrides[sizeKey] && !pastLaunch) {
          /* Pre-launch only: explicit per-size overrides win (staged teaser art). */
          imgUrl = overrides[sizeKey];
        } else if (effectiveForceDefault && overrides['default']) {
          /* Per-collection flag: skip variant featured_image entirely, always use default override.
             Auto-disabled once the launch date has passed (see effectiveForceDefault above). */
          imgUrl = overrides['default'];
        } else if (v.featured_image && v.featured_image.src) {
          /* Past launch the variant's CURRENT featured image always wins — image swaps
             on the PDP show up here with no config change. Overrides become fallbacks. */
          var fi_vids = v.featured_image.variant_ids || [];
          var isAssigned = fi_vids.length === 0 || fi_vids.indexOf(v.id) !== -1;
          var isGeneric = fi_vids.length > 5;
          if (isAssigned && !isGeneric) {
            imgUrl = v.featured_image.src;
          } else if (overrides[sizeKey] || overrides['default']) {
            imgUrl = overrides[sizeKey] || overrides['default'];
          }
        } else if (overrides[sizeKey] || overrides['default']) {
          imgUrl = overrides[sizeKey] || overrides['default'];
        }

        /* Single-variant products (e.g. the Mystery bottles) carry their image
           at the PRODUCT level, not on the variant (variant.featured_image is
           null), so the variant-image lookup above leaves them blank. Fall back
           to the product image — restricted to 1-variant products so multi-color
           products never show a generic / wrong-color image. */
        if (comp && !imgUrl) return;
        if (!imgUrl && (product.variants || []).length === 1) {
          imgUrl = product.featured_image || ((product.images || [])[0]) || '';
        }

        /* Use 600px wide image */
        if (imgUrl) {
          imgUrl = imgUrl.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');
        }

        if (!variantsByColor[displayColor]) variantsByColor[displayColor] = [];
        variantsByColor[displayColor].push({
          variantId: v.id,
          productId: product.id,
          productHandle: product.handle,
          title: product.title.replace(/\s*v\d+$/i, '').replace(/COLDEST\s*/i, ''),
          color: displayColor,
          size: size,
          price: v.price,
          compareAtPrice: v.compare_at_price,
          available: v.available,
          inventory: (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null,
          invManaged: !!v.inventory_management,
          image: imgUrl,
          companion: comp,
          productUrl: '/products/' + product.handle + '?variant=' + v.id
        });
      });
    });

    /* Deduplicate: one card per color + product (prefer Ultra variant) */
    Object.keys(variantsByColor).forEach(function(color) {
      var seen = {};
      variantsByColor[color] = variantsByColor[color].filter(function(item) {
        var key = item.productHandle + '|' + item.size;
        if (!seen[key]) { seen[key] = true; return true; }
        return false;
      });
      /* Sort: in-stock first (by size), then sold-out (by size) */
      variantsByColor[color].sort(function(a, b) {
        if (a.available && !b.available) return -1;
        if (!a.available && b.available) return 1;
        return sizeSort(a, b);
      });
      /* Backfill: cards with no image get the image from an in-stock sibling */
      var fallbackImg = '';
      variantsByColor[color].forEach(function(item) {
        if (item.available && item.image && !item.companion) fallbackImg = item.image;
      });
      if (!fallbackImg) {
        variantsByColor[color].forEach(function(item) {
          if (item.image && !item.companion) fallbackImg = item.image;
        });
      }
      if (fallbackImg) {
        variantsByColor[color].forEach(function(item) {
          if (!item.image && !item.companion) item.image = fallbackImg;
        });
      }
    });

    /* ── Collect all items flat for single-color mode ── */
    var allItems = [];
    Object.keys(variantsByColor).forEach(function(color) {
      variantsByColor[color].forEach(function(item) { allItems.push(item); });
    });

    /* ── DEFAULT ORDER: most expensive first ──────────────────────────────
       Every collection now leads with its highest-priced sizes (David, Aug
       2026). Sold-out cards still sink below in-stock ones, and the opt-in
       arrangement features below (mixColorways / soldOutEvery / alternateSize)
       still run — they just start from a price-sorted list instead of the
       order the products happened to be fetched in. Ties keep their previous
       relative order, so nothing jitters between renders.
       config.defaultSort: 'price-desc' (default) | 'fetched' to opt out. */
    if ((config.defaultSort || 'price-desc') === 'price-desc') {
      var __px = function (it) { return parseInt(it.price, 10) || 0; };
      allItems = allItems
        .map(function (it, i) { return { it: it, i: i }; })
        .sort(function (a, b) {
          if (a.it.available !== b.it.available) return a.it.available ? -1 : 1;
          var d = __px(b.it) - __px(a.it);
          return d !== 0 ? d : a.i - b.i;
        })
        .map(function (x) { return x.it; });
    }

    /* Sold-out items to the bottom (stable: keep existing order within each group). */
    if (config.soldOutLast) {
      var __inStock = [], __sold = [];
      allItems.forEach(function(it) { (it.available ? __inStock : __sold).push(it); });
      allItems = __inStock.concat(__sold);
    }
    /* ── Colorway interleave + sold-out spacing (per-config framework feature) ──
       config.mixColorways : round-robin across colorways so they alternate
         card-to-card instead of sitting in a run (6.7oz always sorted last
         within each colorway).
       config.soldOutEvery : distribute sold-out cards at most 1 per N cards
         (e.g. 8 → seven in-stock then one sold-out); any remaining sold-out
         beyond that cadence are appended at the very end.
       config.alternateSize : diagonal fill so consecutive cards differ in BOTH
         colorway and size (each colorway's sizes are rotated by its index before
         the round-robin). 6.7oz stays pinned last within each colorway, so it
         still lands at the tail. Implies the colorway interleave.
       All are opt-in and leave every other drop's ordering untouched. */
    if (config.mixColorways || config.soldOutEvery || config.alternateSize) {
      var __sizeRankLast = { '15oz': 0, '20oz': 1, '24oz': 2, '30oz': 3, '32oz': 4, '36oz': 5, '46oz': 6, '128oz': 7, 'gallon': 8, '6.7oz': 98 };
      var __rankSize = function (it) { var v = __sizeRankLast[(it.size || '').toLowerCase()]; return v === undefined ? 90 : v; };
      var __interleave = function (list) {
        if (!config.mixColorways && !config.alternateSize) return list.slice();
        var buckets = {}, seq = [];
        list.forEach(function (it) { var c = it.color || ''; if (!buckets[c]) { buckets[c] = []; seq.push(c); } buckets[c].push(it); });
        seq.forEach(function (c) { buckets[c].sort(function (a, b) { return __rankSize(a) - __rankSize(b); }); });
        /* Diagonal: rotate each colorway's non-6.7oz sizes by its index so sizes
           also shift card-to-card; 6.7oz stays pinned last. */
        if (config.alternateSize) {
          seq.forEach(function (c, ci) {
            var head = [], tail = [];
            buckets[c].forEach(function (it) { ((it.size || '').toLowerCase() === '6.7oz' ? tail : head).push(it); });
            if (head.length > 1) { var off = ci % head.length; head = head.slice(off).concat(head.slice(0, off)); }
            buckets[c] = head.concat(tail);
          });
        }
        var out = [], maxL = 0;
        seq.forEach(function (c) { if (buckets[c].length > maxL) maxL = buckets[c].length; });
        for (var i = 0; i < maxL; i++) { seq.forEach(function (c) { if (buckets[c][i]) out.push(buckets[c][i]); }); }
        return out;
      };
      var __inS = __interleave(allItems.filter(function (it) { return it.available; }));
      var __soldQ = __interleave(allItems.filter(function (it) { return !it.available; }));
      if (config.soldOutEvery && config.soldOutEvery > 1) {
        var __run = config.soldOutEvery - 1, __merged = [], __ii = 0;
        while (__ii < __inS.length) {
          for (var __k = 0; __k < __run && __ii < __inS.length; __k++) { __merged.push(__inS[__ii++]); }
          if (__soldQ.length) __merged.push(__soldQ.shift());
        }
        while (__soldQ.length) __merged.push(__soldQ.shift());
        allItems = __merged;
      } else {
        allItems = __inS.concat(__soldQ);
      }
    }


    /* Has this drop's inventory been staged yet? Until ANY size of the drop
       carries stock, nothing has been released — so a zero-inventory size means
       "not dropped yet", not "sold out". Once staging happens, the sizes that
       got no units correctly read as sold out. Self-correcting: it does not
       matter whether staging lands Sunday 10pm, Monday, or drop morning. */
    DROP_STOCK_STAGED = allItems.some(function (i) { return i.available && !i.companion; });

    /* Render */
    var html = '';
    /* Header rendered per-mode below (skipped for sold-out) */

    /* ── Single-color mode ── */
    if (config.singleColor) {
      var anyInStock = allItems.some(function(item) { return item.available; });

      /* Pre-launch drops have zero stock by definition — that's "not dropped
         yet", not "sold out". Only render the sold-out experience once the
         launch date has passed (or no launch date is configured), and never
         for drops flagged showGridWhenSoldOut (pre-release: show the SKUs). */
      if (!anyInStock && (pastLaunch || !launchStr) && !config.showGridWhenSoldOut) {
        /* ── SOLD OUT EXPERIENCE (conversion-optimized) ─────
           Cold FB-ad traffic landing on an empty drop must still convert, so
           lead with shoppable best sellers + similar drops; email is secondary. */
        html += '<div class="drop-soldout">';
        html += '<span class="drop-soldout-tag">Just Sold Out</span>';
        html += '<h1>' + config.heading + ' just fully sold out</h1>';
        html += '<p>This limited drop is gone — but the cold doesn\x27t stop here. Shop our best sellers and similar drops below, all in stock and ready to ship today. 🧊</p>';
        /* Route the disappointment somewhere: this drop now lives in the Vault,
           where the Legacy paths (Games / Loyalty / Crates) are spelled out. */
        html += '<a class="drop-soldout-vault" href="/collections/vault">🔒 ' + config.heading +
                ' is now sealed in The Vault — see every drop that\x27s gone →</a>';
        html += '</div>';

        /* 1) Best sellers — proven converters, loaded from /collections/best-sellers */
        html += '<div class="drop-soldout-divider">';
        html += '<h2>🏆 Shop Our Best Sellers</h2>';
        html += '<p>The Coldest favorites our community keeps coming back to — in stock now.</p>';
        html += '</div>';
        html += '<div id="drop-bestsellers"><div class="drop-loading">Loading best sellers…</div></div>';

        /* 2) Similar drops you might like — genre/family-matched limited designs */
        html += '<div class="drop-soldout-divider">';
        html += '<h2>✨ Similar Drops You Might Like</h2>';
        html += '<p>Limited designs with the same energy — grab one before it\x27s gone too.</p>';
        html += '</div>';
        html += '<div id="drop-alt-collections"></div>';

        /* 3) Secondary: capture for the NEXT drop (no re-drops, so frame forward) */
        html += '<div class="drop-soldout drop-soldout--capture">';
        html += '<p>Want first access to the next drop? New drops land every Thursday at 9:45am ET.</p>';
        html += '<div class="drop-soldout-form" id="drop-restock-form">';
        html += '<input class="drop-soldout-input" type="email" placeholder="Enter your email" id="drop-restock-email">';
        html += '<button class="drop-soldout-btn" id="drop-restock-btn">Get Drop Alerts</button>';
        html += '</div>';
        html += '<p class="drop-soldout-msg" id="drop-restock-msg" style="display:none"></p>';
        html += '</div>';

        /* Mark that we need to load alternatives + best sellers */
        wrapper.setAttribute('data-soldout', 'true');
        wrapper.setAttribute('data-soldout-color', config.colors[0]);
        wrapper.setAttribute('data-capture-mode', 'soldout');

      } else {
        /* Normal header — themed hero band with FOMO strip + real scarcity data */
        var capDesc = config.__capturedDesc || captureCollectionDescription();
        var soldOutCount = allItems.filter(function(item) { return !item.available; }).length;
        /* Request 241: scarcity (units bar, sizes-claimed bar) is the drop's
           BOTTLES; a companion card never counts. */
        var scarceItems = allItems.filter(function(item) { return !item.companion; });
        html += '<div class="drop-grid-header">';
        if (theme.motif) {
          html += '<span class="drop-hero-motif drop-hero-motif--left">' + theme.motif + '</span>';
          html += '<span class="drop-hero-motif drop-hero-motif--right">' + theme.motif + '</span>';
        }
        if (theme.tagline) {
          html += '<p class="drop-header-tagline">' + theme.tagline + '</p>';
        }
        var preDrop = isPreDrop(config.colors[0] || '');
        html += '<h1>' + config.heading + ' <span class="drop-header-badge' + (preDrop ? ' drop-header-badge--soon' : '') + '">' +
          (preDrop ? 'Dropping Soon' : 'Limited Edition') + '</span></h1>';
        if (capDesc) {
          html += '<p class="drop-header-desc">' + capDesc + '</p>';
        } else {
          html += '<p>' + config.subheading + '</p>';
        }
        if (preDrop) {
          /* Pre-drop banner replaces any scarcity/sold-out framing: nothing has
             sold out because nothing has been released. */
          html += '<div class="drop-predrop-banner">';
          html += '<span class="drop-predrop-dot"></span>';
          html += 'Dropping ' + (launchDayLabel(config.colors[0] || '') || 'Thursday') +
                  ' at 9:45am ET — sizes go live the moment it drops';
          html += '</div>';
        }
        var pills = theme.pills || ['&#9889; Limited Edition Drop', 'Once it\x27s gone, it\x27s gone', 'New drops Thursdays &middot; 9:45am ET'];
        html += '<div class="drop-fomo">';
        pills.forEach(function(p, i) {
          html += '<span class="drop-fomo-pill' + (i === 0 ? ' drop-fomo-pill--hot' : '') + '">' + p + '</span>';
        });
        html += '</div>';
        /* ── Scarcity meter ──────────────────────────────────
           UNITS-REMAINING bar (preferred): % of units left across the whole
           collection, using real per-variant inventory vs an assumed start of
           UNITS_PER_SIZE per size. Far more granular than "sizes claimed".
           Falls back to the size-claimed bar when inventory isn't exposed.
           Gated to UNITS_BAR_HANDLES while we validate per drop. */
        var unitsBar = '';
        var isCoreDrop = CORE_COLORS.indexOf((COLORS[0] || '').toLowerCase()) !== -1;
        if (scarceItems.length > 1 && !isCoreDrop
            && (UNITS_BAR_ALL || UNITS_BAR_HANDLES.indexOf(handle) !== -1)) {
          var sizesSeenU = {}, remaining = 0, haveInv = false;
          scarceItems.forEach(function(item) {
            if (item.size) sizesSeenU[item.size.toLowerCase()] = true;
            /* Prefer the server-rendered inventory (Liquid truth); fall back to
               the .js inventory only if the server map lacks this variant. */
            var qty = serverInv(item.variantId);
            if (qty === null && typeof item.inventory === 'number') qty = item.inventory;
            if (qty !== null) haveInv = true;
            remaining += Math.max(0, qty || 0);
          });
          var nSizes = Object.keys(sizesSeenU).length;
          var perSize = config.unitsPerSize || UNITS_PER_SIZE;
          /* Aggregated collections (dropFilters) span multiple colorways sharing
             the same sizes, so the unit start must scale by the number of variant
             cards (colorway×size), not just distinct sizes — otherwise the
             denominator is far too small and the units bar never reveals. */
          var startUnits = (config.dropFilters ? scarceItems.length : nSizes) * perSize;
          var pctLeft = startUnits > 0 ? Math.max(0, Math.min(100, Math.round(remaining / startUnits * 100))) : 100;
          var pctClaimed = Math.max(0, Math.min(100, 100 - pctLeft));
          /* Only reveal the scarcity meter once a drop is MORE than 60% sold out. */
          if (haveInv && startUnits > 0 && pctClaimed > 60) {
            /* Bar fills toward sold-out: nearly full when few units remain. */
            var barW = remaining > 0 ? Math.min(100, Math.max(pctClaimed, 4)) : 100;
            var low = pctLeft <= 25;
            var d = (pctLeft < 1 && remaining > 0) ? 'under 1' : pctLeft;
            /* Dynamic, escalating copy — light & fun when fresh, scarcer as it sells. */
            var leftLabel;
            if (pctLeft >= 80)      leftLabel = '🧊 Fresh drop — ' + d + '% of units still up for grabs';
            else if (pctLeft >= 60) leftLabel = '👀 Catching on — ' + d + '% of units left';
            else if (pctLeft >= 40) leftLabel = '🔥 Heating up — ' + d + '% of units remaining';
            else if (pctLeft >= 25) leftLabel = '🔥 Going fast — only ' + d + '% of units left';
            else if (pctLeft >= 10) leftLabel = '🚨 Selling fast — only ' + d + '% of units left';
            else if (pctLeft >= 3)  leftLabel = '🚨 Almost gone — just ' + d + '% left!';
            else                    leftLabel = '⏳ Final units — ' + d + '% left, don\x27t blink!';
            var rightLabel = (pctClaimed >= 99 && remaining > 0 ? '99' : pctClaimed) + '% claimed';
            unitsBar = '<div class="drop-scarcity' + (low ? ' drop-scarcity--low' : '') + '">'
              + '<div class="drop-scarcity-label"><span>' + leftLabel + '</span>'
              + '<span>' + rightLabel + '</span></div>'
              + '<div class="drop-scarcity-bar"><div class="drop-scarcity-fill" style="width:' + barW + '%"></div></div>'
              + '</div>';
          }
        }
        if (unitsBar && !preDrop) {
          html += unitsBar;
        } else if (!preDrop && soldOutCount > 0 && scarceItems.length > 1
                   && Math.round(soldOutCount / scarceItems.length * 100) >= 50) {
          /* Fallback: size-claimed bar (drops without inventory data). Gated to
             >=50% claimed — a "14% claimed" bar is weak scarcity and just adds
             text above the grid (aligns with the units bar's >60% gate). */
          var claimedPct = Math.round(soldOutCount / scarceItems.length * 100);
          html += '<div class="drop-scarcity">';
          html += '<div class="drop-scarcity-label"><span>' + claimedPct + '% of sizes claimed</span>';
          html += '<span>' + (scarceItems.length - soldOutCount) + ' of ' + scarceItems.length + ' still available</span></div>';
          html += '<div class="drop-scarcity-bar"><div class="drop-scarcity-fill" style="width:' + claimedPct + '%"></div></div>';
          html += '</div>';
        }
        /* Pre-launch hero email capture REMOVED (2026-07-08): the drop-alert
           form pushed the grid down on every teased page; the sold-out page
           keeps its own capture form. */
        if (theme.ribbon) {
          html += '<div class="drop-hero-ribbon"></div>';
        }
        html += '</div>';
        /* Drop (colorway) filter chips — only for aggregated multi-drop
           collections (config.dropFilters). One chip per distinct colorway.
           Suppressed entirely when config.hideFilters is set (clean signature
           layout — show one uninterrupted grid). */
        var distinctColorways = 0;
        (function () {
          var seenC = {};
          allItems.forEach(function (it) {
            var c = (it.color || '').toLowerCase();
            if (c && !seenC[c]) { seenC[c] = 1; distinctColorways++; }
          });
        })();
        if (config.dropFilters && !config.hideFilters && distinctColorways > 1) {
          var dropColorsSeen = [];
          allItems.forEach(function(item) {
            if (item.color && dropColorsSeen.indexOf(item.color) === -1) dropColorsSeen.push(item.color);
          });
          if (dropColorsSeen.length > 1) {
            html += '<div class="drop-filters drop-size-filters drop-color-filters" id="drop-color-filters">';
            html += '<button class="drop-filter-btn drop-filter-btn--active" data-color-filter="all">All Drops</button>';
            dropColorsSeen.forEach(function(c) {
              html += '<button class="drop-filter-btn" data-color-filter="' + c.toLowerCase() + '">' + c + '</button>';
            });
            html += '</div>';
          }
        }
        /* Quick size filter — chips built from this drop\x27s real size list */
        var sizesSeen = [];
        allItems.forEach(function(item) {
          if (item.size && sizesSeen.indexOf(item.size) === -1) sizesSeen.push(item.size);
        });
        sizesSeen.sort(function(a, b) { return sizeSort({ size: a }, { size: b }); });
        if (sizesSeen.length > 1 && distinctColorways > 1 && (!config.hideFilters || config.showSizeFilter)) {
          html += '<div class="drop-filters drop-size-filters" id="drop-size-filters">';
          html += '<button class="drop-filter-btn drop-filter-btn--active" data-size-filter="all">All Sizes</button>';
          sizesSeen.forEach(function(s) {
            html += '<button class="drop-filter-btn" data-size-filter="' + s + '">' + s + '</button>';
          });
          html += '</div>';
        }
        /* Sort control — aggregated collections (config.dropFilters) */
        if (config.dropFilters && allItems.length > 1 && !config.hideFilters) {
          html += '<div class="drop-controls">';
          html += '<span class="drop-controls-hint">' + (theme.controlsHint || 'Filter by drop or size, then sort 👇') + '</span>';
          html += '<div class="drop-sort-wrap"><label class="drop-sort-label" for="drop-sort">Sort</label>';
          html += '<select id="drop-sort" class="drop-sort">';
          html += '<option value="featured">Featured</option>';
          html += '<option value="price-asc">Price: Low to High</option>';
          html += '<option value="price-desc" selected>Price: High to Low</option>';
          html += '<option value="name">Name: A–Z</option>';
          html += '</select></div>';
          html += '</div>';
        }
        /* Normal in-stock grid */
        if (config.showFilters && allItems.length > 1) {
          var collections = [];
          var seenTitles = {};
          allItems.forEach(function(item) {
            if (!seenTitles[item.title]) {
              seenTitles[item.title] = true;
              collections.push(item.title);
            }
          });
          if (collections.length > 1) {
            html += '<div class="drop-filters" id="drop-filters">';
            html += '<button class="drop-filter-btn drop-filter-btn--active" data-filter="all">All Sizes</button>';
            collections.forEach(function(title) {
              html += '<button class="drop-filter-btn" data-filter="' + title + '">' + title + '</button>';
            });
            html += '</div>';
          }
        }

        html += '<div class="drop-grid" id="drop-main-grid">';
        allItems.forEach(function(item) {
          html += renderCard(item);
        });
        html += '</div>';
        if (config.infiniteScroll) {
          html += '<div id="drop-scroll-sentinel" aria-hidden="true"></div>';
          html += '<div class="drop-load-more-wrap"><button type="button" id="drop-load-more" class="drop-load-more">Load more deals</button></div>';
        }
      }

    } else {
      /* Multi-color header */
      var capDescMulti = config.__capturedDesc || captureCollectionDescription();
      html += '<div class="drop-grid-header">';
      html += '<h1>' + config.heading + '</h1>';
      if (capDescMulti) {
        html += '<p class="drop-header-desc">' + capDescMulti + '</p>';
      } else {
        html += '<p>' + config.subheading + '</p>';
      }
      html += '</div>';
      /* ── Multi-color mode: sections per color ── */
      var colorOrder = Object.keys(variantsByColor).sort();
      colorOrder.forEach(function(color) {
        var items = variantsByColor[color];
        var anyAvailable = items.some(function(item) { return item.available; });
        if (!anyAvailable) return;
        html += '<div class="drop-color-section">';
        html += '<h2 class="drop-color-title">' + color + '</h2>';
        html += '<div class="drop-grid">';
        items.forEach(function(item) {
          html += renderCard(item);
        });

      html += '</div>'; /* /drop-grid */
      html += '</div>'; /* /drop-color-section */
    });
    } /* end if/else singleColor */

    /* ── Bundle CTA: "Build your set" (Request 262) ──────────────────────
       David, 2026-10-26: "Add all 6 to cart" asked for the whole drop in one
       go ($305 on Sapphire Opal). Now every in-stock size is a checkbox tile
       and any BUNDLE_DISCOUNT.min (4) or more of them get the extra 10%:
       "Select at least four of the set and get an extra 10% off". Nothing is
       ticked to start; until the shopper picks, the price line quotes the
       cheapest qualifying set. Shown only when at least BUNDLE_DISCOUNT.min
       in-stock pieces exist, because fewer can never reach the discount.
       Companions (the 30oz Drive Thru) stay out, as before. paintBundle()
       below keeps the progress, price, button and trust lines in step with
       the ticks. With BUNDLE_DISCOUNT.percent at 0 (the kill switch) there
       is no discount to unlock, so any 2+ sizes can be added. */
    var bundleItems = allItems.filter(function(it) { return it.available && it.variantId && !it.companion; });
    var bundleMin = BUNDLE_DISCOUNT.percent > 0 ? BUNDLE_DISCOUNT.min : 2;
    if (bundleItems.length >= bundleMin) {
      /* ── BUNDLE DISCOUNT TRUTH ──────────────────────────────────────────
         Audited 2026-07-27 (customer reports of the coupon not attaching):
         the per-drop BUNDLE-<HANDLE>-10 code this CTA used was missing for
         most drops, so their pages promised "Save an extra 10%" and sent
         shoppers to checkout at full price. The claim is gated on a discount
         that really exists (BUNDLE_DISCOUNT); percent 0 switches every
         savings line off. */
      var hasBundleDiscount = BUNDLE_DISCOUNT.percent > 0;
      var bundlePct = Math.round(BUNDLE_DISCOUNT.percent * 100);

      /* the claim must match reality: a single-colorway drop is N SIZES */
      var bundleColorways = {};
      bundleItems.forEach(function (it) { bundleColorways[(it.color || '').toLowerCase()] = 1; });
      var multiColorway = Object.keys(bundleColorways).length > 1;
      /* past 12 tiles (sports-drop can list 20+), show 9 and a "Show all" */
      var BUNDLE_SHOWN = bundleItems.length > 12 ? 9 : bundleItems.length;

      html += '<aside class="drop-bundle drop-bundle--pick" id="drop-bundle-cta" ';
      html += 'data-bundle-code="' + (BUNDLE_DISCOUNT.code || '') + '" data-bundle-min="' + bundleMin + '">';
      html += '<div class="drop-bundle-inner">';
      html += '<div class="drop-bundle-copy">';
      html += '<div class="drop-bundle-eyebrow-row">';
      html += '<span class="drop-bundle-eyebrow">★ Coldest.com Exclusive' +
        (hasBundleDiscount ? ' · Save ' + bundlePct + '%' : '') + '</span>';
      html += '</div>';
      html += '<h2 class="drop-bundle-title" id="drop-bundle-title">Build Your ' + config.heading + ' Set</h2>';
      html += '<p class="drop-bundle-sub">' + (hasBundleDiscount
        ? 'Select at least ' + bundleMin + ' of the set and get an extra ' + bundlePct + '% off.'
        : 'Select the ' + (multiColorway ? 'pieces' : 'sizes') + ' you want and add them in one click.') + '</p>';
      html += '<div class="drop-bundle-pickhead">';
      html += '<p class="drop-bundle-progress" id="drop-bundle-progress" aria-live="polite"></p>';
      html += '<button type="button" class="drop-bundle-all" id="drop-bundle-all"></button>';
      html += '</div>';
      if (hasBundleDiscount) {
        html += '<div class="drop-bundle-meter" id="drop-bundle-meter" aria-hidden="true">';
        for (var bmi = 0; bmi < bundleMin; bmi++) html += '<i></i>';
        html += '</div>';
      }
      html += '<div class="drop-bundle-picks" id="drop-bundle-picks" role="group" aria-labelledby="drop-bundle-title">';
      bundleItems.forEach(function (it, bi) {
        var pickName = (multiColorway ? (it.color || '') + ' ' : '') + (it.size || '');
        html += '<label class="drop-bundle-pick' + (bi >= BUNDLE_SHOWN ? ' is-extra' : '') + '">';
        html += '<input type="checkbox" class="drop-bundle-pick-input" value="' + it.variantId + '" data-price="' +
          (parseInt(it.price, 10) || 0) + '" data-handle="' + (it.productHandle || '') + '" data-size="' + (it.size || '') + '"' +
          (FINAL_SALE_HANDLES.indexOf(it.productHandle) !== -1 ? ' data-final="1"' : '') +
          ' aria-label="' + pickName + ', ' + formatMoney(parseInt(it.price, 10) || 0) + '">';
        html += '<span class="drop-bundle-pick-art">';
        if (it.image) html += '<img src="' + it.image + '" alt="" loading="lazy" width="96" height="96">';
        html += '<span class="drop-bundle-pick-check" aria-hidden="true"></span></span>';
        html += '<span class="drop-bundle-pick-size" aria-hidden="true">' + pickName + '</span>';
        html += '<span class="drop-bundle-pick-price" aria-hidden="true">' + formatMoney(parseInt(it.price, 10) || 0) + '</span>';
        html += '</label>';
      });
      html += '</div>';
      if (bundleItems.length > BUNDLE_SHOWN) {
        html += '<button type="button" class="drop-bundle-more" id="drop-bundle-more">Show all ' + bundleItems.length + '</button>';
      }
      html += '</div>';
      html += '<div class="drop-bundle-cta">';
      html += '<div class="drop-bundle-pricing" id="drop-bundle-pricing"></div>';
      html += '<p class="drop-bundle-unit" id="drop-bundle-unit" hidden></p>';
      html += '<button type="button" class="drop-bundle-btn" id="drop-bundle-btn" disabled></button>';
      html += '<p class="drop-bundle-err" id="drop-bundle-err" role="alert" hidden></p>';
      html += '<p class="drop-bundle-trust" id="drop-bundle-trust"></p>';
      html += '<p class="drop-bundle-fineprint">' + (hasBundleDiscount
        ? 'The ' + bundlePct + '% comes off at checkout on ' + bundleMin + ' or more bottles.'
        : 'Adds every size you pick to your cart in one click.') + '</p>';
      html += '</div>';
      html += '</div>';
      html += '</aside>';
    }

    /* ── Complete the Look (Request 198) ──────────────────────────────────
       One system with the PDP's "Frequently added" and the slide cart's
       "Complete your {family}": same product_family data, same row snippet,
       same fit engine, same add helper. templates/collection.drop.liquid
       server-renders up to 4 in-stock rows into <template id="drop-ctl-rows">
       (Liquid, because /products/*.js carries no metafields — the same reason
       as #drop-inventory-data and #drop-reviews-data). This file holds no
       accessory list at all now.
       No config.singleColor gate: the family comes from the drop's SIZE, so
       aggregate pages and sports-drop get the block too. The rows are cloned
       in by mountCompleteTheLook() right after this html lands, because
       wrapper.innerHTML wipes anything placed inside the wrapper. */
    var ctlTpl = document.getElementById('drop-ctl-rows');
    if (ctlTpl && ctlTpl.content && ctlTpl.content.querySelector('[data-csc-acc]')) {
      html += '<div class="drop-color-section dctl" id="drop-ctl">';
      html += '<div class="drop-ctl-head">';
      html += '<h2 class="drop-color-title">Complete the Look</h2>';
      html += '<button type="button" class="drop-ctl-addall" id="drop-ctl-addall" hidden>Add all <b></b></button>';
      html += '</div>';
      html += '<div id="drop-ctl-slot"></div>';
      html += '<p class="dctl__err" id="drop-ctl-err" role="alert" hidden></p>';
      html += '</div>';
    }

    /* ── Append below-grid content blocks ─────────────── */
    /* Curved-divider colour bands (window.cldstBands, defined in <head> on collection pages from the
       collection's coldest.band_colors metafield, brand palette when empty). The hero/grid above stays
       straight-edged on the drop's themed background; Difference, Comparison, Reviews and FAQ each get a
       full-bleed band with an own-colour curved cap. No helper -> markup exactly as before. */
    var cldstSeq = (window.cldstBands && window.cldstBands.seq) ? window.cldstBands.seq() : null;
    if (cldstSeq) html += cldstSeq.band(1, 'wave', false, 'cldst-dropband');
    html += '<div class="drop-difference"><div class="drop-difference-inner">';
    html += '<div class="drop-difference-media">';
    html += '<video autoplay loop muted playsinline preload="none" style="width:100%;border-radius:8px"><source src="https://i.shgcdn.com/36612610-0645-4775-a187-109e8ca9a6a5/gif2video/-/format/webm/-/quality/lighter/" type="video/webm"><source src="https://i.shgcdn.com/36612610-0645-4775-a187-109e8ca9a6a5/gif2video/-/format/mp4/-/quality/lighter/" type="video/mp4"></video>';
    html += '</div>';
    html += '<div class="drop-difference-text">';
    html += '<h2>The Coldest Difference</h2>';
    html += '<p>It\x27s NOT just a water bottle. Our COLDEST Water bottles are designed to help you stay colder, longer\u2122. We designed our water bottles to stay cold for 36 to 100+ hours*. They\x27re leakproof, ultra-durable, and fit everywhere. This is Your Last Bottle\u2122.</p>';
    html += '<ul>';
    html += '<li>Up to 36+ Hours Cold*</li>';
    html += '<li>Leak-Proof</li>';
    html += '<li>Coldest Armor\u2122 Triple Insulation</li>';
    html += '</ul>';
    html += '</div></div></div>';
    if (cldstSeq) html += cldstSeq.end() + cldstSeq.band(2, 'curve', true, 'cldst-dropband');

    /* ── Coldest vs. the rest — comparison CRO block (ported from homepage) ── */
    html += '<div class="drop-cmp-wrap"><h2>What you get with Coldest</h2>';
    html += '<div class="drop-cmp"><table class="drop-cmp-table"><thead><tr><th></th><th class="drop-cmp-brand">Coldest</th></tr></thead><tbody>';
    [['Cold for up to 36+ hours*', 1], ['Lids designed to seal tight', 1], ['3 lids included', 1],
     ['<a href="/pages/life">Limited lifetime warranty</a>', 1], ['18/8 stainless steel', 1], ['New colors most Thursdays', 1]]
      .forEach(function(r) {
        html += '<tr><td>' + r[0] + '</td><td class="drop-cmp-us">' + (r[1] ? '<span class="drop-cmp-check">&#10003;</span>' : '') + '</td></tr>';
      });
    html += '</tbody></table></div>';
    html += '</div>';
    if (cldstSeq) html += cldstSeq.end() + cldstSeq.band(3, 'blob', false, 'cldst-dropband');

    /* ── Social proof: Okendo reviews from EVERY parent listing in this drop —
       reviews pool across all colors sold on the same size listing. Fetched from
       Okendo's store API and rendered as our own cards (the app-block widget
       doesn't hydrate client-injected divs on collection pages). ── */
    var reviewParents = [];
    allItems.forEach(function(it) {
      if (it.productId && reviewParents.indexOf(it.productId) === -1) reviewParents.push(it.productId);
    });
    if (!reviewParents.length) reviewParents = [9018145702120];
    html += '<div class="drop-reviews"><h2>Loved by the Coldest Community</h2>';
    html += '<p class="drop-reviews-sub">Every ' + config.heading + ' piece is the same award-winning Limitless hardware — real reviews from every size, across all colorways.</p>';
    html += '<div id="drop-reviews-list" data-parents="' + reviewParents.join(',') + '"><p class="drop-reviews-loading">Loading reviews…</p></div>';
    html += '</div>';
    if (cldstSeq) html += cldstSeq.end() + cldstSeq.band(4, 'zigzag-soft', true, 'cldst-dropband');

    html += '<div class="drop-faq"><h2>Frequently Asked Questions</h2>';
    var faqs = [
      ['What makes Coldest bottles different?', 'Our bottles use Coldest Armor\u2122 Triple Insulation technology, keeping drinks cold for 36 to 100+ hours*. Lids are designed to seal tight, sizes are built for standard cup holders, and 3 lids are included.'],
      ['How long do Coldest bottles keep drinks cold?', 'Depending on the size, our bottles keep drinks cold for 36 to 100+ hours*. Results vary with lid, ice, outside temperature, and how often the bottle is opened.'],
      ['Will a Coldest lid stay sealed in a bag?', 'Lids use a gasket seal designed to stay closed on the move. If a lid fails because of a manufacturing defect, we replace it under the limited lifetime warranty.'],
      ['Do Coldest bottles fit in cup holders?', 'Yes. All sizes are designed to fit standard car, truck, and stroller cup holders.'],
      ['What sizes are available?', 'We offer 6.7oz, 15oz, 20oz, 24oz, 36oz, 46oz, and Gallon sizes across our Limitless Ultra lineup.'],
      ['What are Coldest bottles made of?', 'Coldest bottles are made from 18/8 stainless steel. Lids use silicone and plastic parts.'],
      ['What is the warranty?', 'Every Coldest bottle comes with a <a href="/pages/life">limited lifetime warranty</a> against manufacturing defects. Read the full terms on the Life page.'],
      ['Do you offer free shipping?', 'Yes \u2014 free shipping on all orders over $125.']
    ];
    /* Per-drop FAQ — launch/restock question with real drop data, then any
       CRON-managed extras (improved over time by the weekly CRO review). */
    var primaryLaunchStr = DROP_LAUNCH_DATES[(COLORS[0] || '')];
    if (primaryLaunchStr) {
      var faqMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                       'August', 'September', 'October', 'November', 'December'];
      var faqLd = new Date(primaryLaunchStr + 'T12:00:00');
      faqs.unshift(['Is the ' + config.heading + ' drop limited edition?',
        'Yes — ' + config.heading + ' is a limited edition Coldest drop (launched ' +
        faqMonths[faqLd.getMonth()] + ' ' + faqLd.getDate() + ', ' + faqLd.getFullYear() +
        ' at 9:45am ET). Each drop is produced in one small run. When a size sells out, your ' +
        'only second chance is the Drop Day Reserve at 9:45am ET the morning after launch.']);
    }
    (DROP_FAQ_EXTRA[handle] || []).forEach(function(f) { faqs.push(f); });
    faqs.forEach(function(faq) {
      html += '<details><summary>' + faq[0] + '</summary><p>' + faq[1] + '</p></details>';
    });
    html += '</div>';
    if (cldstSeq) html += cldstSeq.end() + cldstSeq.finish('wave', true);

    wrapper.innerHTML = html;
    wrapper.style.display = '';
    /* Complete the Look: clone the server-rendered rows into their slot. Must
       run AFTER wrapper.innerHTML, which wipes the wrapper's contents. */
    try { mountCompleteTheLook(); } catch (e) { /* non-fatal */ }
    try { mountShopByCollections(); } catch (e) { /* non-fatal */ }

    /* SSR placeholder has served its purpose — remove it so cards aren't doubled */
    if (ssrNode && ssrNode.parentNode) { ssrNode.parentNode.removeChild(ssrNode); ssrNode = null; }

    /* Sticky mobile buy bar + drop-day celebration (both no-op when N/A) */
    try { buildStickyBuyBar(); } catch (e) { /* non-fatal */ }
    try { celebrateDropDay(); } catch (e) { /* non-fatal */ }

    /* ── SEO/AIO: FAQPage + ItemList structured data for this drop ── */
    try { injectStructuredData(allItems, faqs); } catch (e) { /* non-fatal */ }
    setTimeout(loadDropReviews, 300);

    /* ── BUNDLE PICKER (Request 262): paint the set as the shopper ticks,
       then add it and go straight to checkout. ── */
    var bundleEl = wrapper.querySelector('#drop-bundle-cta');
    var bundleBtn = wrapper.querySelector('#drop-bundle-btn');
    if (bundleEl && bundleBtn) {
      var bMin = parseInt(bundleEl.getAttribute('data-bundle-min'), 10) || BUNDLE_DISCOUNT.min;
      var bPct = Math.round(BUNDLE_DISCOUNT.percent * 100);
      var bOn = BUNDLE_DISCOUNT.percent > 0;
      var bBoxes = Array.prototype.slice.call(bundleEl.querySelectorAll('.drop-bundle-pick-input'));
      var bPicks = bundleEl.querySelector('#drop-bundle-picks');
      var bAll = bundleEl.querySelector('#drop-bundle-all');
      var bMore = bundleEl.querySelector('#drop-bundle-more');
      var bErr = bundleEl.querySelector('#drop-bundle-err');
      var bPrice = function (box) { return parseInt(box.getAttribute('data-price'), 10) || 0; };
      /* a tile that sold out after page load (found on a refused add) is out of play */
      var bLive = function (box) { return box.getAttribute('data-gone') !== '1'; };
      var bShown = function (box) { return !box.closest('.is-extra') || (bPicks && bPicks.classList.contains('is-open')); };
      /* Free shipping is the US Domestic rate in USD only: never promise it to
         a country or currency checkout will charge (the slide cart's rule). */
      var bShipUS = !!(window.Shopify && Shopify.country === 'US' &&
        (!Shopify.currency || !Shopify.currency.active || Shopify.currency.active === 'USD'));

      var paintBundle = function () {
        var live = bBoxes.filter(bLive);
        var on = live.filter(function (b) { return b.checked; });
        var n = on.length, need = Math.max(0, bMin - n);
        var t = bundleSetCents(on.map(bPrice));
        /* "Any 4 from": the cheapest qualifying set among the tiles in view */
        var fromBoxes = live.filter(bShown).sort(function (a, b) { return bPrice(a) - bPrice(b); }).slice(0, bMin);
        var from = bundleSetCents(fromBoxes.map(bPrice));
        var prog = bundleEl.querySelector('#drop-bundle-progress');
        var short = live.length < bMin;   /* sizes sold out during the visit */
        if (short) prog.textContent = 'Only ' + live.length + ' size' + (live.length === 1 ? '' : 's') + ' left: not enough for a set';
        else if (!bOn) prog.textContent = n ? n + ' picked' : 'Pick the sizes you want';
        else if (!n) prog.textContent = 'Pick ' + bMin + ' to unlock ' + bPct + '% off';
        else if (need) prog.textContent = n + ' picked · ' + need + ' more for ' + bPct + '% off';
        else prog.innerHTML = '<span class="drop-bundle-ok">✓</span> ' + bPct + '% off unlocked · ' + n + ' picked';
        prog.classList.toggle('is-done', bOn && !need);
        bundleEl.querySelectorAll('#drop-bundle-meter i').forEach(function (seg, i) { seg.classList.toggle('is-on', i < n); });

        var pr = '';
        if (!n) {
          if (bOn && fromBoxes.length >= bMin) {
            pr = '<span class="drop-bundle-price-from">Any ' + bMin + ' from</span>' +
              '<span class="drop-bundle-price-sale">' + formatMoney(from.sale) + '</span>' +
              '<span class="drop-bundle-price-orig">' + formatMoney(from.full) + '</span>';
          }
        } else if (need || !bOn) {
          pr = '<span class="drop-bundle-price-sale">' + formatMoney(t.full) + '</span>' +
            (bOn && !short ? '<span class="drop-bundle-savings drop-bundle-savings--hint">' + bPct + '% off at ' + bMin + '</span>' : '');
        } else {
          pr = '<span class="drop-bundle-price-sale">' + formatMoney(t.sale) + '</span>' +
            '<span class="drop-bundle-price-orig">' + formatMoney(t.full) + '</span>' +
            '<span class="drop-bundle-savings">You save ' + formatMoney(t.off) + '</span>';
        }
        bundleEl.querySelector('#drop-bundle-pricing').innerHTML = pr;

        var unit = bundleEl.querySelector('#drop-bundle-unit');
        if (bOn && n && !need) {
          var perFull = Math.round(t.full / n), perSale = Math.round(t.sale / n);
          var free = perFull ? Math.floor(t.off / perFull) : 0;
          unit.innerHTML = formatMoney(perSale) + ' per item <s>' + formatMoney(perFull) + '</s>' +
            (free >= 1 ? ' <b>— like getting ' + (free === 1 ? 'one' : free) + ' free</b>' : '');
          unit.hidden = false;
        } else {
          unit.hidden = true;
        }

        if (!bundleBtn.classList.contains('is-busy') && short) {
          /* sizes sold out during the visit: no set can be built any more */
          bundleBtn.disabled = true;
          bundleBtn.textContent = 'Not Enough Sizes Left';
        } else if (!bundleBtn.classList.contains('is-busy')) {
          bundleBtn.disabled = n < bMin;
          bundleBtn.innerHTML = n >= bMin
            ? 'Add ' + n + ' To Cart <span class="drop-bundle-btn-arrow">→</span>'
            : (n ? 'Pick ' + need + ' More' : 'Pick ' + bMin + (bOn ? ' to Unlock ' + bPct + '%' : ''));
        }

        /* trust lines describe THIS set (or, before a tick, the quoted one) */
        var setBoxes = n ? on : fromBoxes;
        var setCents = n ? t.sale : from.sale;
        var finals = [];
        setBoxes.forEach(function (b) {
          var fs = b.getAttribute('data-size') || '';
          if (b.getAttribute('data-final') === '1' && finals.indexOf(fs) === -1) finals.push(fs);
        });
        var trust = '';
        if (bShipUS) {
          trust += setCents >= FREE_SHIP_CENTS
            ? '<span>✓ Free shipping</span>'
            : '<span>Free shipping at ' + formatMoney(FREE_SHIP_CENTS).replace(/\.00$/, '') + '</span>';
        }
        trust += finals.length
          ? '<span class="drop-bundle-trust-wrap">✓ 30-day returns (' + finals.join(', ') + (finals.length > 1 ? ' are' : ' is') + ' final sale)</span>'
          : '<span>✓ 30-day returns</span>';
        if (bOn && n && !need) trust += '<span>✓ Discount applies automatically</span>';
        bundleEl.querySelector('#drop-bundle-trust').innerHTML = trust;

        if (bAll) {
          bAll.hidden = live.length < bMin;
          bAll.textContent = live.length && live.every(function (b) { return b.checked; }) ? 'Clear' : 'Select all ' + live.length;
        }
      };

      var bClearErr = function () { if (bErr && !bErr.hidden) { bErr.hidden = true; bErr.textContent = ''; } };
      var bOpen = function () {
        if (!bPicks || bPicks.classList.contains('is-open')) return;
        var first = bPicks.querySelector('.is-extra .drop-bundle-pick-input');
        var hadFocus = bMore && document.activeElement === bMore;
        bPicks.classList.add('is-open');
        if (bMore) bMore.hidden = true;
        if (hadFocus && first) first.focus();   /* keyboard users land on the first revealed tile */
        paintBundle();   /* the "Any 4 from" quote covers the tiles in view */
      };
      bBoxes.forEach(function (b) { b.addEventListener('change', function () { bClearErr(); paintBundle(); }); });
      if (bAll) bAll.addEventListener('click', function () {
        if (bundleBtn.classList.contains('is-busy')) return;
        var live = bBoxes.filter(bLive);
        var all = live.every(function (b) { return b.checked; });
        live.forEach(function (b) { b.checked = !all; });
        if (!all) bOpen();   /* never tick a tile the shopper cannot see */
        bClearErr();
        paintBundle();
      });
      if (bMore) bMore.addEventListener('click', bOpen);
      paintBundle();

      /* A refused add: say why in the block (Shopify's own reason), then
         re-read the ticked sizes' stock and take the ones that sold out since
         page load out of play, so a retry is not the same doomed request. */
      var bRefused = function (msg) {
        if (bErr) {
          bErr.textContent = (msg ? msg + ' ' : 'We couldn’t add your set. ') + 'Check your picks and try again.';
          bErr.hidden = false;
        }
        var ticked = bBoxes.filter(function (b) { return b.checked; });
        var handles = {};
        ticked.forEach(function (b) { var h = b.getAttribute('data-handle'); if (h) handles[h] = 1; });
        return Promise.all(Object.keys(handles).map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          var avail = {};
          products.forEach(function (pr) { ((pr && pr.variants) || []).forEach(function (v) { avail[String(v.id)] = !!v.available; }); });
          var gone = [];
          ticked.forEach(function (b) {
            if (avail[b.value] === false) {
              b.checked = false; b.disabled = true; b.setAttribute('data-gone', '1');
              var lab = b.closest('label');
              if (lab) {
                lab.classList.add('is-gone');
                var pp = lab.querySelector('.drop-bundle-pick-price');
                if (pp) pp.textContent = 'Sold out';
              }
              gone.push(b.getAttribute('data-size') || 'one size');
            }
          });
          if (gone.length && bErr) {
            var liveLeft = bBoxes.filter(bLive).length;
            var stillOn = bBoxes.filter(function (b) { return b.checked && bLive(b); }).length;
            var what = gone.join(', ') + ' just sold out, so we unticked ' + (gone.length > 1 ? 'them' : 'it') + '. ';
            bErr.textContent = what + (liveLeft < bMin
              ? 'Fewer than ' + bMin + ' sizes are left, so the set is off: add sizes one by one from the grid above.'
              : stillOn >= bMin
                ? 'The rest of your set is still ticked: add it now.'
                : 'Pick ' + (bMin - stillOn > 1 ? 'others' : 'another') + ' to finish your set.');
          }
          paintBundle();
        });
      };

      /* ── BUNDLE ADD ──────────────────────────────────────────────────
         Flow:
           1. POST the ticked variants to /cart/add.js in one call
           2. fetch('/discount/{CODE}') — Shopify sets the discount cookie on
              the response regardless of whether we follow the redirect, so
              the next cart fetch (and checkout) will include the discount
           3. Navigate to /checkout (David 2026-05-13: virtual bundles skip the
              /cart page, so the discount is locked in and the purchase
              friction is minimal). Individual ATC buttons on the same page
              keep their drawer behaviour. */
      bundleBtn.addEventListener('click', function() {
        if (bundleBtn.disabled) return;
        var code = bundleEl.getAttribute('data-bundle-code') || '';
        var ids = bBoxes.filter(function (b) { return b.checked && bLive(b); }).map(function (b) { return b.value; });
        if (ids.length < bMin) return; /* belt-and-suspenders */

        bClearErr();
        bundleBtn.disabled = true;
        bundleBtn.classList.add('is-busy');
        bBoxes.forEach(function (b) { b.disabled = true; });
        bundleBtn.textContent = 'Adding your set…';

        var items = ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) { return r.json().catch(function () { return {}; }).then(function(b) { return { ok: r.ok, body: b }; }); })
        .then(function(res) {
          if (!res.ok) {
            var e = new Error('Bundle add failed');
            e.shopper = (res.body && (res.body.description || res.body.message)) || '';
            throw e;
          }
          /* Apply the discount cookie. redirect:'follow' so the browser
             actually applies the Set-Cookie header (manual redirect mode skips
             it in some browsers); redirect=/cart.js keeps the chase short. */
          if (code) {
            return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), {
              method: 'GET',
              credentials: 'same-origin',
              redirect: 'follow'
            }).catch(function() { /* swallow — cookie may still be set */ });
          }
        })
        .then(function() {
          /* Re-fetch the cart so the discount totals are refreshed and any cart
             drawer that listens to /cart.js sees the new state with discount. */
          return fetch('/cart.js', { credentials: 'same-origin' }).catch(function() {});
        })
        .then(function() {
          try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
          bundleBtn.innerHTML = 'Set Added ✓';
          setTimeout(function() {
            window.location.href = '/checkout';
          }, 350);
        })
        .catch(function(err) {
          console.error('[bundle] add failed', err);
          bundleBtn.classList.remove('is-busy');
          bBoxes.forEach(function (b) { if (bLive(b)) b.disabled = false; });
          paintBundle();
          bRefused(err && err.shopper);
        });
      });
    }

    /* ── Re-init Okendo star ratings for dynamically added cards ── */
    if (window.okeWidgetApi) {
      window.okeWidgetApi.initAllWidgets();
    } else {
      /* Okendo may load after us — poll for it */
      var okeCheck = setInterval(function() {
        if (window.okeWidgetApi) {
          clearInterval(okeCheck);
          window.okeWidgetApi.initAllWidgets();
        }
      }, 500);
      setTimeout(function() { clearInterval(okeCheck); }, 10000);
    }

    /* ── Composable filter + sort (aggregated drop collections) ───
       Size chips and drop chips both feed one applyDropFilters() so they
       compose instead of clobbering each other. Sort reorders #drop-main-grid;
       the server render order is captured once as the "Featured" baseline. */
    var __activeSize = 'all', __activeColor = 'all';
    var __pwInfinite = !!config.infiniteScroll;
    var __pwBatch = config.infiniteBatch || 12;
    var __pwLimit = __pwBatch;
    function applyDropFilters() {
      var grid = wrapper.querySelector('#drop-main-grid');
      if (!grid) return;
      var matched = 0, visible = 0;
      grid.querySelectorAll('.drop-card').forEach(function(card) {
        var okSize = (__activeSize === 'all' || card.getAttribute('data-size') === __activeSize);
        var okColor = (__activeColor === 'all' || (card.getAttribute('data-color') || '') === __activeColor);
        if (!(okSize && okColor)) { card.style.display = 'none'; return; }
        matched++;
        /* Infinite scroll: only reveal the first __pwLimit matching cards. */
        if (__pwInfinite && matched > __pwLimit) { card.style.display = 'none'; }
        else { card.style.display = ''; visible++; }
      });
      if (__pwInfinite) {
        var hasMore = matched > visible;
        var moreBtn = wrapper.querySelector('#drop-load-more');
        var sentinel = wrapper.querySelector('#drop-scroll-sentinel');
        if (moreBtn) moreBtn.style.display = hasMore ? '' : 'none';
        if (sentinel) sentinel.style.display = hasMore ? '' : 'none';
      }
    }
    function pwLoadMore() {
      __pwLimit += __pwBatch;
      applyDropFilters();
    }
    function sortDropGrid(mode) {
      var grid = wrapper.querySelector('#drop-main-grid');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.drop-card'));
      var price = function(c) { return parseInt(c.getAttribute('data-price'), 10) || 0; };
      var avail = function(c) { return c.getAttribute('data-available') === '1' ? 1 : 0; };
      var order = function(c) { return parseInt(c.getAttribute('data-order'), 10) || 0; };
      cards.sort(function(a, b) {
        if (mode === 'featured') return order(a) - order(b);
        /* keep in-stock ahead of sold-out for every sort mode */
        if (avail(a) !== avail(b)) return avail(b) - avail(a);
        if (mode === 'price-asc') return price(a) - price(b);
        if (mode === 'price-desc') return price(b) - price(a);
        if (mode === 'name') {
          var na = (a.getAttribute('data-color') || '') + ' ' + (a.getAttribute('data-size') || '');
          var nb = (b.getAttribute('data-color') || '') + ' ' + (b.getAttribute('data-size') || '');
          return na.localeCompare(nb);
        }
        return order(a) - order(b);
      });
      cards.forEach(function(c) { grid.appendChild(c); });
    }
    (function captureFeaturedOrder() {
      var grid = wrapper.querySelector('#drop-main-grid');
      if (!grid) return;
      var i = 0;
      grid.querySelectorAll('.drop-card').forEach(function(c) { c.setAttribute('data-order', i++); });
    })();

    /* ── FILTER HANDLERS (single-color mode) ─────────────── */
    var filterBar = wrapper.querySelector('#drop-filters');
    if (filterBar) {
      filterBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.drop-filter-btn');
        if (!btn) return;
        var filter = btn.getAttribute('data-filter');
        /* Update active state */
        filterBar.querySelectorAll('.drop-filter-btn').forEach(function(b) {
          b.classList.remove('drop-filter-btn--active');
        });
        btn.classList.add('drop-filter-btn--active');
        /* Show/hide cards */
        wrapper.querySelectorAll('.drop-card').forEach(function(card) {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            var cardTitle = card.getAttribute('data-collection') || '';
            card.style.display = (cardTitle === filter) ? '' : 'none';
          }
        });
      });
    }

    /* ── SIZE FILTER HANDLER (quick chips, main grid only) ── */
    var sizeFilterBar = wrapper.querySelector('#drop-size-filters');
    if (sizeFilterBar) {
      sizeFilterBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.drop-filter-btn');
        if (!btn) return;
        var f = btn.getAttribute('data-size-filter');
        sizeFilterBar.querySelectorAll('.drop-filter-btn').forEach(function(b) {
          b.classList.remove('drop-filter-btn--active');
        });
        btn.classList.add('drop-filter-btn--active');
        __activeSize = f || 'all';
        if (__pwInfinite) __pwLimit = __pwBatch;
        applyDropFilters();
      });
    }

    /* ── DROP (colorway) FILTER HANDLER — aggregated collections ── */
    var colorFilterBar = wrapper.querySelector('#drop-color-filters');
    if (colorFilterBar) {
      colorFilterBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.drop-filter-btn');
        if (!btn) return;
        colorFilterBar.querySelectorAll('.drop-filter-btn').forEach(function(b) {
          b.classList.remove('drop-filter-btn--active');
        });
        btn.classList.add('drop-filter-btn--active');
        __activeColor = btn.getAttribute('data-color-filter') || 'all';
        if (__pwInfinite) __pwLimit = __pwBatch;
        applyDropFilters();
      });
    }

    /* ── SORT HANDLER — aggregated collections ────────────── */
    var sortSelect = wrapper.querySelector('#drop-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        sortDropGrid(sortSelect.value);
        if (__pwInfinite) { __pwLimit = __pwBatch; applyDropFilters(); }
      });
    }

    /* ── INFINITE SCROLL (load more variants as you scroll) ── */
    if (__pwInfinite) {
      applyDropFilters(); /* collapse to the first batch on first paint */
      var __loadMoreBtn = wrapper.querySelector('#drop-load-more');
      if (__loadMoreBtn) __loadMoreBtn.addEventListener('click', pwLoadMore);
      var __sentinel = wrapper.querySelector('#drop-scroll-sentinel');
      if (__sentinel && 'IntersectionObserver' in window) {
        var __io = new IntersectionObserver(function(entries) {
          entries.forEach(function(en) { if (en.isIntersecting) pwLoadMore(); });
        }, { rootMargin: '600px 0px' });
        __io.observe(__sentinel);
      }
    }

    /* ── ATC HANDLERS (quick-add bag overlay) ─────────────── */
    bindBagButtons(wrapper);
  }

  /* ── COMPLETE THE LOOK: mount the server-rendered rows ──────────────────
     The rows come from <template id="drop-ctl-rows"> (templates/collection.drop
     .liquid), rendered by snippets/coldest-slide-cart-accessory.liquid — the
     same snippet as the PDP's "Frequently added" and the slide cart's
     "Complete your {family}". That snippet IS the in-stock gate: a sold-out
     product, a sold-out variant and a variant whose Size does not fit the
     family all render nothing, on Shopify `availableForSale`. So there is
     nothing to filter here and no list to keep fresh. */

  /* The shop money format is amount_no_decimals, so the cart and the PDP show
     "$49" where formatMoney() (:1858) shows "$49.00". Add all must agree with
     them, or one system looks like two. Mirrors snippets/coldest-slide-cart-money. */
  function ctlMoney(cents) {
    var c = Math.max(0, Math.round(cents || 0));
    var d = Math.floor(c / 100), r = c % 100;
    var s = String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s + (r ? '.' + (r < 10 ? '0' : '') + r : '');
  }

  /* Canonical add path (snippets/coldest-atc-drawer.liquid). cartAddXHR stays
     only as the pre-helper fallback; its XHR is seen by the same hook. */
  function ctlAdd(items) {
    if (typeof window.coldestCartAdd === 'function') return window.coldestCartAdd({ items: items });
    return cartAddXHR({ items: items });
  }

  /* "Shop by Collections" — the image rail of every live drop, under the drop
     header and above the grid (David, 2026-10-14). Its markup, art and sealed
     state come from Liquid (#drop-sbc-src on templates/collection.drop.liquid)
     because the menu, the collection images and coldest.drop_launch are not in
     /products/*.js. CLONED, never moved: wrapper.innerHTML is rewritten on
     every render, so the source has to survive. The clone drops the wiring
     flags its source picked up, then the refresh event measures it where it
     now lives — inside the hidden source it has no width and no arrows. */
  function mountShopByCollections() {
    var src = document.getElementById('drop-sbc-src');
    if (!src) return;
    var nav = src.querySelector('.cldst-sbc');
    if (!nav || wrapper.querySelector('.cldst-sbc')) return;
    var copy = nav.cloneNode(true);
    copy.removeAttribute('data-sbc-wired');
    copy.classList.remove('is-wired', 'is-scrollable', 'is-end');
    var head = wrapper.querySelector('.drop-grid-header');
    if (head) { head.parentNode.insertBefore(copy, head.nextSibling); }
    else { wrapper.insertBefore(copy, wrapper.firstChild); }
    try { document.dispatchEvent(new Event('coldest:sbc:refresh')); } catch (e) { /* non-fatal */ }
  }

  function mountCompleteTheLook() {
    var slot = wrapper.querySelector('#drop-ctl-slot');
    var tpl = document.getElementById('drop-ctl-rows');
    if (!slot || !tpl || !tpl.content || slot.__ctl) return;
    slot.__ctl = true;
    slot.appendChild(tpl.content.cloneNode(true));
    var sect = wrapper.querySelector('#drop-ctl');
    var err = wrapper.querySelector('#drop-ctl-err');
    var addAll = wrapper.querySelector('#drop-ctl-addall');

    /* Match this drop (assets/coldest-fit.js, loaded sitewide by the slide-cart
       section): the colorway's coldest.palette when it has one, otherwise the
       drop theme's accent — the accent IS the dominant colour pulled from the
       revealed drop image, and the newest colorway has no palette until
       sync_variant_fit.py can read a real variant image, which is exactly
       launch week. Neither: the server's pick stays and the pill stays hidden. */
    function ctlAnchor() {
      var a = tpl.getAttribute('data-fit') || '';
      if (a) return a;
      var ac = String(theme.accent || '').replace('#', '');
      return /^[0-9a-f]{6}$/i.test(ac) ? ac.toLowerCase() + ':100' : '';
    }
    function refit() {
      if (!window.coldestFit) return;
      try { window.coldestFit.apply(slot, ctlAnchor()); } catch (e) {}
    }
    refit();

    function rows() { return [].slice.call(slot.querySelectorAll('[data-csc-acc]')); }
    function rowPick(row) {
      var sel = row.querySelector('[data-csc-acc-select]');
      var id = sel && parseInt(sel.value, 10);
      if (!id) return null;
      var opt = (sel.options && sel.selectedIndex >= 0) ? sel.options[sel.selectedIndex] : null;
      var txt = (opt && opt.getAttribute('data-price')) ||
        ((row.querySelector('[data-csc-acc-price]') || {}).textContent || '');
      var cents = Math.round(parseFloat(String(txt).replace(/[^0-9.]/g, '')) * 100);
      return { id: id, cents: cents > 0 ? cents : 0 };
    }
    function priceAddAll() {
      var list = rows();
      if (sect) sect.hidden = list.length === 0;
      if (!addAll) return;
      var picks = list.map(rowPick).filter(Boolean);
      if (picks.length < 2) { addAll.hidden = true; return; }
      var total = picks.reduce(function (t, x) { return t + x.cents; }, 0);
      addAll.querySelector('b').textContent = picks.length + ' · ' + ctlMoney(total);
      addAll.hidden = false;
    }

    /* Same option -> price / compare / image swap as the PDP
       (assets/coldest-pdp-essentials.js:53-70) and the drawer
       (assets/coldest-cart-accessories.js:23-38). Third copy of that glue, on
       purpose: extracting it would mean touching the live PDP and the live
       drawer in a drop-page change. */
    slot.addEventListener('change', function (e) {
      var sel = e.target && e.target.closest && e.target.closest('select[data-csc-acc-select]');
      if (!sel) return;
      var row = sel.closest('[data-csc-acc]');
      var opt = sel.options[sel.selectedIndex];
      if (!row || !opt) return;
      var price = row.querySelector('[data-csc-acc-price]');
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      var cmp = row.querySelector('[data-csc-acc-compare]');
      if (cmp) {
        cmp.textContent = opt.getAttribute('data-compare') || '';
        cmp.hidden = !opt.getAttribute('data-compare');
      }
      var img = row.querySelector('[data-csc-acc-img]');
      if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
      var b = row.querySelector('[data-csc-acc-add]');
      if (b && b.classList.contains('is-added')) { b.classList.remove('is-added'); b.textContent = '+ Add'; }
      priceAddAll();
    });

    /* Quick add: the CLICK, not a submit (there is no form here, but
       cldst-atc-fast.js intercepts card-form submits and would double-add). */
    slot.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-csc-acc-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault(); e.stopPropagation();
      var row = btn.closest('[data-csc-acc]');
      var pick = row && rowPick(row);
      if (!pick) return;
      if (err) err.hidden = true;
      btn.disabled = true;
      btn.classList.remove('is-added');
      btn.classList.add('is-adding');
      btn.textContent = 'Adding…';
      ctlAdd([{ id: pick.id, quantity: 1 }]).then(function () {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = '✓ Added';
        openCartDrawer();  /* delegates to window.coldestOpenCartDrawer (:1545) */
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = '+ Add'; }, 1800);
      }).catch(function (e2) {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        btn.textContent = '+ Add';
        var m = (e2 && e2.message) || '';
        if (err) {
          err.textContent = /422/.test(m) ? 'That one just sold out.' : (m || 'Could not add it. Please try again.');
          err.hidden = false;
        }
      });
    });

    if (addAll && !addAll.__wired) {
      addAll.__wired = true;
      addAll.addEventListener('click', function () {
        if (addAll.disabled) return;
        var picks = rows().map(rowPick).filter(Boolean);
        if (picks.length < 2) return;
        var label = addAll.innerHTML;
        if (err) err.hidden = true;
        addAll.disabled = true;
        addAll.textContent = 'Adding…';
        ctlAdd(picks.map(function (x) { return { id: x.id, quantity: 1 }; }))
        .then(function () {
          addAll.textContent = '✓ Added';
          openCartDrawer();
          setTimeout(function () { addAll.innerHTML = label; addAll.disabled = false; priceAddAll(); }, 2200);
        })
        .catch(function () {
          addAll.textContent = 'Try again';
          addAll.disabled = false;
          setTimeout(function () { addAll.innerHTML = label; priceAddAll(); }, 1800);
        });
      });
    }

    priceAddAll();

    /* Render time is the gate, but this page is served from Shopify's full-page
       HTML cache on most requests (measured: 46 of 72 responses never ran
       Liquid), so a row can be minutes stale. One lazy pass when the block
       scrolls into view re-reads live availability and prunes what sold out
       since — the Limitless lander's runtime-overlay precedent. Rows with no
       picker are single-variant evergreens (75k-99k on hand), so they are
       skipped: at most 3 requests, all below the fold. */
    function verify() {
      var jobs = {}, handles = [];
      rows().forEach(function (row) {
        if (!row.querySelector('select[data-csc-acc-select]')) return;
        var a = row.querySelector('.csc-acc__title');
        var m = a && String(a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        if (!m) return;
        if (!jobs[m[1]]) { jobs[m[1]] = []; handles.push(m[1]); }
        jobs[m[1]].push(row);
      });
      if (!handles.length) return;
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (prods) {
        var changed = false;
        prods.forEach(function (p, i) {
          if (!p || !p.variants) return;
          var live = {};
          p.variants.forEach(function (v) { live[String(v.id)] = !!v.available; });
          jobs[handles[i]].forEach(function (row) {
            var sel = row.querySelector('select[data-csc-acc-select]');
            if (!sel) return;
            var was = sel.value;
            [].slice.call(sel.options).forEach(function (o) {
              if (live[o.value] === false) { o.parentNode.removeChild(o); changed = true; }
            });
            if (!sel.options.length) { row.parentNode.removeChild(row); changed = true; return; }
            if (sel.value !== was) {
              sel.removeAttribute('data-default-index');
              sel.selectedIndex = 0;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
        if (changed) { refit(); priceAddAll(); }
      });
    }
    var conn = navigator.connection || {};
    if (conn.saveData || /2g/.test(conn.effectiveType || '')) return;
    if (!('IntersectionObserver' in window)) { setTimeout(verify, 2500); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      io.disconnect();
      verify();
    }, { rootMargin: '400px' });
    io.observe(sect || slot);
  }

  /* ── COLOR FAMILY MAP for visually similar suggestions ── */
  var COLOR_FAMILIES = {
    'pink': ['glossy pink', 'love pop', 'xoxo', 'flirt & flower', 'magnolia bloom'],
    'blue': ['blue opal', 'starry night', 'the world stage', 'the marrakech', 'water lilies'],
    'green': ['clover floral', 'the dragonfly', 'water lilies', 'mont sainte'],
    'red': ['red luna', 'love pop', 'xoxo'],
    'yellow': ['stung by a bee', 'clover floral'],
    'purple': ['love of music', 'starry night'],
    'black': ['stealth black', 'buzzer beater'],
    'neutral': ['mont sainte', 'magnolia bloom', 'stealth black']
  };

  function getColorFamily(colorName) {
    var cl = colorName.toLowerCase();
    for (var family in COLOR_FAMILIES) {
      if (COLOR_FAMILIES[family].indexOf(cl) !== -1) return family;
    }
    return 'neutral';
  }

  /* ── Load best sellers for the sold-out page (cold-traffic conversion) ──
     Pulls in-stock products from /collections/best-sellers and renders
     shoppable cards linking to the PDP (multi-color products → choose on PDP). */
  function loadBestSellers() {
    if (!wrapper.getAttribute('data-soldout')) return;
    var container = wrapper.querySelector('#drop-bestsellers');
    if (!container) return;
    fetch('/collections/best-sellers/products.json?limit=8')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        var prods = (data && data.products) || [];
        var cards = '';
        prods.forEach(function(p) {
          var v0 = (p.variants || [])[0];
          if (!v0) return;
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          if (img) img = img.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');
          var title = (p.title || '').replace(/\s*v\d+$/i, '').replace(/COLDEST\s*/i, '');
          var hasSale = v0.compare_at_price && parseFloat(v0.compare_at_price) > parseFloat(v0.price);
          cards += '<div class="drop-card">';
          cards += '<a class="drop-card-link" href="/products/' + p.handle + '">';
          cards += '<div class="drop-card-img-wrap">' + (img ? '<img class="drop-card-img" src="' + img + '" alt="' + title + '" loading="lazy">' : '') + '</div></a>';
          cards += '<div class="drop-card-info"><a class="drop-card-link" href="/products/' + p.handle + '">';
          cards += '<p class="drop-card-title">' + title + '</p>';
          cards += cardRatingHtml(p.id);
          cards += '<p class="drop-card-price' + (hasSale ? ' drop-card-price--sale' : '') + '"><span>' + formatMoney(Math.round(parseFloat(v0.price) * 100)) + '</span>';
          if (hasSale) cards += '<span class="drop-card-price--compare">' + formatMoney(Math.round(parseFloat(v0.compare_at_price) * 100)) + '</span>';
          cards += '</p></a></div>';
          cards += '<a class="drop-card-atc" href="/products/' + p.handle + '">Shop Now</a>';
          cards += '</div>';
        });
        container.innerHTML = cards
          ? '<div class="drop-grid">' + cards + '</div>'
          : '';
        if (window.okeWidgetApi) { try { window.okeWidgetApi.initAllWidgets(); } catch (e) {} }
      })
      .catch(function() {
        var c = wrapper.querySelector('#drop-bestsellers');
        if (c) c.innerHTML = '';
      });
  }

  /* ── Load alternative in-stock collections for sold-out page ── */
  function loadAlternativeCollections() {
    if (!wrapper.getAttribute('data-soldout')) return;
    var soldoutColor = wrapper.getAttribute('data-soldout-color');
    var family = getColorFamily(soldoutColor);
    var familyColors = COLOR_FAMILIES[family] || [];

    /* Gather all single-color configs except the sold-out one */
    var candidates = [];
    for (var h in DROP_CONFIG) {
      var cfg = DROP_CONFIG[h];
      if (!cfg.singleColor) continue;
      if (cfg.colors[0] === soldoutColor) continue;
      /* Prioritize: same family first, then BADGE_DROP_NAMES (newest), then others */
      var isSameFamily = familyColors.indexOf(cfg.colors[0]) !== -1;
      var isNewDrop = BADGE_DROP_NAMES.indexOf(cfg.colors[0]) !== -1;
      candidates.push({ handle: h, config: cfg, isSameFamily: isSameFamily, isNewDrop: isNewDrop });
    }

    /* Sort: newest drops first, then same color family, then rest */
    candidates.sort(function(a, b) {
      if (a.isNewDrop && !b.isNewDrop) return -1;
      if (!a.isNewDrop && b.isNewDrop) return 1;
      if (a.isSameFamily && !b.isSameFamily) return -1;
      if (!a.isSameFamily && b.isSameFamily) return 1;
      return 0;
    });

    /* Take the first 3 */
    var picks = candidates.slice(0, 3);

    /* For each pick, fetch product data and render a mini collection grid */
    var allHandles = picks[0] ? picks[0].config.handles : HANDLES_DEFAULT;
    var uniqueHandles = [];
    picks.forEach(function(p) {
      (p.config.handles || []).forEach(function(h) {
        if (uniqueHandles.indexOf(h) === -1) uniqueHandles.push(h);
      });
    });

    Promise.all(uniqueHandles.map(function(h) {
      return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }).catch(function() { return null; });
    })).then(function(products) {
      products = products.filter(Boolean);
      var container = wrapper.querySelector('#drop-alt-collections');
      if (!container) return;

      var altHtml = '';
      picks.forEach(function(pick) {
        var cfg = pick.config;
        var colorVal = cfg.colors[0];
        var items = [];

        products.forEach(function(product) {
          var colorIdx = -1;
          var sizeIdx = -1;
          (product.options || []).forEach(function(opt, i) {
            var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
            if (name === 'color') colorIdx = i;
            if (name === 'size') sizeIdx = i;
          });
          if (colorIdx === -1) return;

          product.variants.forEach(function(v) {
            var vc = normalizeColor(v.options[colorIdx] || '');
            if (vc !== colorVal) return;
            if (!v.available) return;

            var displayColor = (v.options[colorIdx] || '').replace(/\s*Ultra\s*$/i, '').trim();
            var size = sizeIdx >= 0 ? v.options[sizeIdx] : '';
            var imgUrl = '';
            var overrides = (cfg.imageOverrides || {})[colorVal] || {};
            var sizeKey = (size || '').toLowerCase();
            if (overrides[sizeKey]) imgUrl = overrides[sizeKey];
            else if (v.featured_image && v.featured_image.src) {
              var fi_vids = v.featured_image.variant_ids || [];
              var isGeneric = fi_vids.length > 5;
              if (!isGeneric) imgUrl = v.featured_image.src;
            }
            if (!imgUrl && overrides['default']) imgUrl = overrides['default'];
            if (imgUrl) imgUrl = imgUrl.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_600x$1$3');

            items.push({
              variantId: v.id, productId: product.id, productHandle: product.handle,
              title: product.title.replace(/\s*v\d+$/i, '').replace(/COLDEST\s*/i, ''),
              color: displayColor, size: size, price: v.price,
              compareAtPrice: v.compare_at_price, available: true, image: imgUrl,
              productUrl: '/products/' + product.handle + '?variant=' + v.id
            });
          });
        });

        /* Backfill images */
        var bestImg = '';
        items.forEach(function(item) { if (item.image && !bestImg) bestImg = item.image; });
        if (bestImg) items.forEach(function(item) { if (!item.image) item.image = bestImg; });

        /* Dedup and sort */
        var seen = {};
        items = items.filter(function(item) {
          var key = item.productHandle + '|' + item.size;
          if (!seen[key]) { seen[key] = true; return true; }
          return false;
        });
        items.sort(sizeSort);

        if (items.length === 0) return;

        altHtml += '<div class="drop-alt-section">';
        altHtml += '<h3><a href="/collections/' + pick.handle + '" style="color:inherit;text-decoration:none">' + cfg.heading + '</a></h3>';
        altHtml += '<div class="drop-grid">';
        items.forEach(function(item) { altHtml += renderCard(item); });
        altHtml += '</div></div>';
      });

      container.innerHTML = altHtml;

      /* Quick-add bag overlay for alt-collection cards */
      bindBagButtons(container);
    });

    /* Drop-page email capture — posts to the notify-me worker via
       window.coldestBrevoSubscribe (assets/coldest-signup-brevo.js).
       Success only when the worker returns {ok:true}. Never paint
       "Subscribed!" on a failed or missing request (supersedes PR #301). */
    var restockBtn = wrapper.querySelector('#drop-restock-btn');
    var restockInput = wrapper.querySelector('#drop-restock-email');
    var restockMsg = wrapper.querySelector('#drop-restock-msg');
    if (restockBtn && restockInput) {
      restockBtn.addEventListener('click', function() {
        var email = restockInput.value.trim();
        if (!email || email.indexOf('@') === -1) {
          restockInput.style.borderColor = '#c0392b';
          if (restockMsg) {
            restockMsg.textContent = 'Enter a valid email address.';
            restockMsg.style.display = 'block';
          }
          return;
        }
        var capMode = wrapper.getAttribute('data-capture-mode')
          || (wrapper.getAttribute('data-prelaunch') === 'true' ? 'prelaunch' : 'restock');
        var toMainList = (capMode === 'prelaunch' || capMode === 'soldout');
        var signupType = toMainList ? 'drop_alert' : 'back_in_stock';
        var idleLabel = toMainList ? 'Get Drop Alerts' : 'Notify Me';
        var sourceLabel = (capMode === 'prelaunch' ? 'Drop Alert - '
          : capMode === 'soldout' ? 'Sold Out Capture - ' : 'Restock Notify - ') + config.heading;
        var okMsg = (capMode === 'prelaunch')
          ? 'You\x27re on the list \u2014 we\x27ll email you the moment ' + config.heading + ' drops.'
          : (capMode === 'soldout')
          ? 'You\x27re in! You\x27ll be first to know about the next drop. \ud83e\uddca'
          : 'We\x27ll notify you when ' + config.heading + ' restocks.';
        var subscribe = window.coldestBrevoSubscribe;
        if (typeof subscribe !== 'function') {
          restockBtn.textContent = idleLabel;
          if (restockMsg) {
            restockMsg.textContent = 'Signups are temporarily unavailable.';
            restockMsg.style.display = 'block';
          }
          return;
        }
        restockBtn.disabled = true;
        restockBtn.textContent = 'Submitting...';
        subscribe({
          type: signupType,
          email: email,
          source: sourceLabel,
          collectionHandle: config.handle || (window.location.pathname || '').replace(/^\/collections\//, '').split('/')[0],
          productTitle: config.heading,
          color: wrapper.getAttribute('data-soldout-color') || (config.colors && config.colors[0]) || ''
        }).then(function(res) {
          if (res && res.ok) {
            restockBtn.textContent = 'Subscribed!';
            restockBtn.classList.add('drop-soldout-btn--done');
            if (restockMsg) {
              restockMsg.textContent = okMsg;
              restockMsg.style.display = 'block';
            }
            restockInput.style.display = 'none';
            return;
          }
          restockBtn.disabled = false;
          restockBtn.textContent = idleLabel;
          if (restockMsg) {
            restockMsg.textContent = (res && res.message) || 'We couldn\u2019t sign you up just now \u2014 please try again.';
            restockMsg.style.display = 'block';
          }
        });
      });
    }
  }

  var HANDLES_DEFAULT = ['15oz','tumbler','coldest-limitless-24oz-ultra-v8','coldest-limitless-bottle','coldest-limitless-bottle-46oz','coldest-1-gallon-limitless-ultra','coldest-7-oz-bottle','32oz-go'];

  /* ── REVIEWS LOADER ──────────────────────────────────────
     Pull top reviews for every parent listing from Okendo's store API (the
     subscriber id ships with the app embed on every page) and render our own
     themed cards. Falls back to raw Okendo widget divs if the API/id is
     unavailable. */
  function okendoSubscriberId() {
    try {
      var el = document.getElementById('oke-reviews-settings');
      if (el) {
        var cfg = JSON.parse(el.textContent || '{}');
        if (cfg.subscriberId) return cfg.subscriberId;
      }
    } catch (e) {}
    if (window.okendoReviews && window.okendoReviews.subscriberId) return window.okendoReviews.subscriberId;
    var meta = document.querySelector('meta[name="oke:subscriber_id"]');
    return meta ? meta.getAttribute('content') : null;
  }

  /* Canonical reviews listing: the 36oz Limitless flagship aggregates the most
     reviews across all colorways. Render EXACTLY ONE Okendo widget — embedding
     one per parent product stacked multiple full widgets (the "reviews block
     twice" bug). Fall back to the first parent if the flagship isn't present. */
  var REVIEWS_FLAGSHIP_PID = 9018145702120;
  function canonicalReviewPid(pids) {
    for (var i = 0; i < pids.length; i++) {
      if (String(pids[i]) === String(REVIEWS_FLAGSHIP_PID)) return pids[i];
    }
    return pids[0] || REVIEWS_FLAGSHIP_PID;
  }

  function okendoWidgetEmbed(holder, pids) {
    var pid = canonicalReviewPid(pids);
    holder.innerHTML = '<div data-oke-widget data-oke-reviews-product-id="shopify-' + pid + '">&nbsp;</div>';
    function initThem() {
      var el = holder.querySelector('[data-oke-widget]');
      try {
        if (el && window.okeWidgetApi.initWidget) window.okeWidgetApi.initWidget(el);
        else if (window.okeWidgetApi.initAllWidgets) window.okeWidgetApi.initAllWidgets();
      } catch (e) {}
    }
    if (window.okeWidgetApi) {
      initThem();
    } else {
      var tries = 0;
      var iv = setInterval(function() {
        if (window.okeWidgetApi) { clearInterval(iv); initThem(); }
        else if (++tries > 20) { clearInterval(iv); }
      }, 500);
    }
  }

  function escText(s) { return (s || '').replace(/</g, '&lt;'); }

  function reviewImage(rv) {
    /* Okendo media shapes vary — check the common fields defensively */
    var m = (rv.media && rv.media[0]) || null;
    var url = (m && (m.thumbnailUrl || m.smallUrl || m.url || m.fullSizeUrl)) ||
              (rv.imageUrls && rv.imageUrls[0]) || (rv.mediaUrls && rv.mediaUrls[0]) || '';
    if (typeof url !== 'string') return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url.indexOf('http') === 0 ? url : '';
  }

  function loadDropReviews() {
    var holder = wrapper.querySelector('#drop-reviews-list');
    if (!holder) return;
    var pids = (holder.getAttribute('data-parents') || '').split(',').filter(Boolean);
    /* Native Okendo widget first — full features, same experience as the PDP. */
    okendoWidgetEmbed(holder, pids);
    /* Only if the widget hasn't hydrated after 8s, swap to API-rendered photo cards. */
    setTimeout(function() {
      var hydrated = holder.querySelector('.oke-w, .okeReviews, [data-oke-container], .oke-reviewContent, iframe');
      if (!hydrated || holder.offsetHeight < 60) fetchReviewCards(holder, pids);
    }, 8000);
  }

  function fetchReviewCards(holder, pids) {
    var sid = okendoSubscriberId();
    if (!sid) return; /* keep the widget markup in place */
    Promise.all(pids.slice(0, 7).map(function(pid) {
      return fetch('https://api.okendo.io/v1/stores/' + encodeURIComponent(sid) +
                   '/products/shopify-' + pid + '/reviews?limit=15')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    })).then(function(results) {
      var reviews = [], seen = {};
      results.forEach(function(res) {
        ((res && res.reviews) || []).forEach(function(rv) {
          if (!rv || !rv.body || (rv.rating || 0) < 4) return;
          var key = rv.reviewId || rv.id || (rv.body || '').slice(0, 60);
          if (seen[key]) return;
          seen[key] = 1;
          rv.__img = reviewImage(rv);
          reviews.push(rv);
        });
      });
      if (!reviews.length) { return; } /* keep widget markup */
      /* Prefer 5-star reviews WITH customer photos, then 5-star, then 4-star photo */
      reviews.sort(function(a, b) {
        var sa = (a.__img ? 2 : 0) + (a.rating >= 5 ? 1 : 0);
        var sb = (b.__img ? 2 : 0) + (b.rating >= 5 ? 1 : 0);
        return (sb - sa) ||
               (new Date(b.dateCreated || 0) - new Date(a.dateCreated || 0));
      });
      var h = '<div class="drop-reviews-grid">';
      reviews.slice(0, 6).forEach(function(rv) {
        var stars = '';
        for (var i = 0; i < 5; i++) stars += i < Math.round(rv.rating) ? '★' : '☆';
        var who = escText((rv.reviewer && (rv.reviewer.displayName || rv.reviewer.name)) || 'Coldest Customer');
        var body = escText(rv.body);
        if (body.length > 230) body = body.slice(0, 227) + '…';
        h += '<div class="drop-review-card">' +
             (rv.__img ? '<div class="drop-review-media"><img src="' + rv.__img.replace(/"/g, '') + '" alt="Customer photo" loading="lazy"></div>' : '') +
             '<div class="drop-review-stars">' + stars + '</div>' +
             (rv.title ? '<p class="drop-review-title">' + escText(rv.title) + '</p>' : '') +
             '<p class="drop-review-body">' + body + '</p>' +
             '<p class="drop-review-name">' + who + ' <span class="drop-review-verified">✓ Verified</span></p></div>';
      });
      h += '</div>';
      holder.innerHTML = h;
    }).catch(function() { /* keep widget markup */ });
  }

  /* ── ANTI-STACKING RUNTIME GUARD ─────────────────────────
     CSS rules hide known native sections, but apps (Shogun, Boost, page
     builders) and cached templates can inject content the selectors don't
     know about. After we render, force-hide ANY visible sibling content in
     main that isn't the framework — re-checked on a timer because some apps
     render late. The framework is the ONLY experience on a drop page. */
  function enforceSingleExperience() {
    var main = document.querySelector('main') || document.querySelector('#MainContent');
    if (!main || !wrapper.parentNode) return;
    Array.prototype.forEach.call(main.children, function(el) {
      if (el === wrapper || el.contains(wrapper)) return;
      /* Keep the SSR first paint visible until the real grid replaces it
         (buildGrid removes #drop-ssr) — hiding it first blanked the page. */
      if (ssrNode && el.contains(ssrNode)) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
      if (el.offsetHeight > 0 || el.offsetWidth > 0) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }
  [600, 1500, 3000, 6000].forEach(function(ms) { setTimeout(enforceSingleExperience, ms); });
  document.addEventListener('DOMContentLoaded', enforceSingleExperience);

  /* ── INIT ───────────────────────────────────────────────── */
  /* Use pre-configured handles directly — no need to parse the DOM */
  var handles = config.handles && config.handles.length > 0
    ? config.handles
    : [];
  /* Request 241: append a companion only when the template says it carries
     one of this page's colours in stock, so the other drop pages never pay
     for its fetch. config.noCompanions opts a page out. */
  if (handles.length && !config.noCompanions) {
    handles = handles.slice();
    COMPANION_HANDLES.forEach(function(h) {
      var c = SERVER_COMPANIONS[h];
      if (!c || handles.indexOf(h) !== -1) return;
      if ((c.colors || []).some(function(x) { return COLORS.indexOf(x) !== -1; })) handles.push(h);
    });
  }

  if (handles.length === 0) {
    /* Fallback: try to detect from Boost DOM */
    getProductHandles().then(function(detectedHandles) {
      return Promise.all(detectedHandles.map(fetchProduct));
    }).then(function(products) {
      buildGrid(products.filter(Boolean));
      setTimeout(loadAlternativeCollections, 200);
      setTimeout(loadBestSellers, 150);
    });
  } else {
    Promise.all(handles.map(fetchProduct)).then(function(products) {
      buildGrid(products.filter(Boolean));
      setTimeout(loadAlternativeCollections, 200);
      setTimeout(loadBestSellers, 150);
    });
  }

})();

/* BUST 1779247332 */
/* coldest-drop-collections-v4.js — created 1779678806 for Crochet + Baby Dinosaur launch */

/* tagline-v2-bump 1779760549 */

//__cb_1780894991__